import { RentabilityReportComponent } from './reports/rentability-report/rentability-report.component';
import { DisplaySuajeComponent } from './suajes/display-suaje/display-suaje.component';
import { firestore } from "firebase/app";
import { CustomerBillData } from './services/customer-bill.service';
export interface PdfElements { h1, h2, h3, span, img, table, column, tableHeader, pageBreak}
export interface PdfCssAtts { fontSize?: number, bold?: boolean, italics?: boolean, margin?: number[], color?: string, alignment?: string, columnGap?: number, fillColor?: string, pageBreak?: string}

export declare class PdfmakeServiceType {
    pageSize: string;
    pageOrientation: string;
    private base64textString;
    docDefinition: {
        header?: ContentCell[],
        content?: ContentCell[],
        images?: {[id: string]: string},
        pageOrientation?: PdfOrientation,
        pageSize?: PdfPageSize,
        pageMargins: number[],
        styles?: {[K in keyof PdfElements]: PdfCssAtts},
        footer?: ContentCell[]
    }
    constructor()
    open(): void;
    print(): void;
    download(name?: string): void;
    configureStyles(styles: any): void;
    addText(text: string, style?: string): void;
    addColumns(columnsText: string[]): void;
    addTable(table: Table): void;
    addImage(url: string, width?: number, height?: number): void;
    addUnorderedlist(items: any[]): void;
    addOrderedList(items: any[], reversed?: boolean, start?: number): void;
}

export interface ContentCell{
    //elements
    text?: string,
    image?: string,
    columns?: ContentCell[],
    table?: ContentCell,
    body?: string[][],
    //options
    widths?: any[],
    colSpan?: number[],
    headerRows?: number,
    absolutePosition?: {x: number, y: number},
    styles?: keyof PdfElements,
}
export class Globals {
  public static get AGROWEB_URL(): string { return 'https://agro-web.firebaseio.com/'; }

  public static get COMPANIES_COLLECTION(): string { return 'companies' }

  public static get AGRO_VIVA_DOCUMENT_ID(): string { return '2a2Yvthyo0Lr6Pw7FXmm'}; //Agroviva  sireilusa proy-pruebas...
  /**
   public static get AGRO_VIVA_DOCUMENT_ID(): string { return 'NTC8scn4gobsAlYKpCd5'}; //Sire-web
   */
  
 
  public static get USER_COLLECTION_URL(): string { return this.AGROWEB_URL + 'user.json'; }
  public static get USER_DOCUMENT_URL(): string { return this.AGROWEB_URL + 'user'; }

  public static get ACTIVITIES_COLLECTION_URL(): string { return this.AGROWEB_URL + 'activities.json'; }
  public static get ACTIVITY_DOCUMENT_URL(): string { return this.AGROWEB_URL + 'activities'; }

  public static get SUBSIDIARIES_COLLECTION_URL(): string { return this.AGROWEB_URL + 'subsidiaries.json'; }
  public static get SUBSIDIARY_DOCUMENT_URL(): string { return this.AGROWEB_URL + 'subsidiaries'; }

  public static get SHIPS_COLLECTION_URL(): string { return this.AGROWEB_URL + 'customers_ships.json'; }
  public static get SHIP_DOCUMENT_URL(): string { return this.AGROWEB_URL + 'customers_ships'; }

  /**
   * Firestore  Collections
   */
  public static get ACTIVITY_COLLECTION(): string { return 'activity'; }

  public static get ACTIVITY_CLASSIFICATION_COLLECTION(): string { return 'activity_classification'; }

  public static get ADDRESS_COLLECTION(): string { return 'address'; }

  public static get APPROVED_ASSISTANCE_COLLECTION(): string { return 'approved_assistance'; }

  public static get ASSISTANCE_COLLECTION(): string { return 'assistance'; }

  public static get ASSISTANCE_REPORT_COLLECTION(): string { return 'assistance_report'; }

  public static get CARRIER_REPORT_COLLECTION(): string { return 'carrier_report'; }

  public static get CATALOGS_SETTINGS(): string { return 'catalogs_settings'; }

  public static get CHECK_CLOCK_COLLECTION(): string { return 'check_clock'; }

  public static get CHECK_CLOCK_LOAD_COLLECTION(): string { return 'check_clock_load'; }

  public static get COUNTRY_COLLECTION(): string { return 'country'; }

  public static get CUSTOMER_SUPPLIER_COLLECTION(): string { return 'customer_supplier'; }

  public static get CUSTOMER_SUPPLIER_TYPE_COLLECTION(): string { return 'customer_supplier_type'; }

  public static get DEPARTMENT_COLLECTION(): string { return 'department'; }

  public static get EMPLOYEE_COLLECTION(): string { return 'user'; }

  public static get FEATURES_COLLECTION(): string { return 'features'; }

  public static get GROUP_COLLECTION(): string { return 'group'; }

  public static get IN_AND_OUT_COLLECTION(): string { return 'in-and-out'; }

  public static get JOB_COLLECTION(): string { return 'job'; }

  public static get LOAN_COLLECTION(): string { return 'loan'; }

  public static get ADDRESSES_COLLECTION(): string { return 'addresses'; }

  public static get FISCAL_DATA_COLLECTION(): string { return 'fiscal_data'; }

  public static get KEY_PERSONS_COLLECTION(): string { return 'key_persons'; }

  public static get LOG_COLLECTION(): string { return 'log'; }

  public static get OVERTIME_COLLECTION(): string { return 'overtime'; }

  public static get PAYROLL_COLLECTION(): string { return 'payroll'; }

  public static get PRCMPA_COLLECTION(): string { return 'prCmpa'; }

  public static get PRODUCTION_ORDER_COLLECTION(): string { return 'production_order'; }

  public static get PROMPTER_REPORT_COLLECTION(): string { return 'prompter_report'; }

  public static get SECURITY_REPORT_COLLECTION(): string { return 'security_report'; }

  public static get NEW_PROMPTER_REPORT_COLLECTION(): string { return 'new_prompter_report'; }

  public static get PRTYPE_COLLECTION(): string { return 'prType'; }

  public static get PRVNTA_COLLECTION(): string { return 'prVnta'; }

  public static get PRCLIENT_COLLECTION(): string { return 'prClient'; }

  public static get ROLE_COLLECTION(): string { return 'role'; }

  public static get SHIP_COLLECTION(): string { return 'ship'; }

  public static get STATE_COLLECTION(): string { return 'state'; }

  public static get SUBSIDIARY_COLLECTION(): string { return 'subsidiary'; }

  public static get PURCHASE_ORDER_COLLECTION(): string { return 'purchase_order'; }

  public static get PURCHASE_REQUEST_COLLECTION(): string { return 'purchase_request'; }

  public static get LIFT_ORDER_COLLECTION(): string { return 'liftOrder'; }

  public static get SUPPLIER_BILL_COLLECTION(): string { return 'supplierBill'; }

  public static get CUSTOMER_BILL_COLLECTION(): string { return 'customerBill'; }

  public static get INCOME_COLLECTION(): string { return 'income'; }

  public static get OUTCOME_COLLECTION(): string { return 'outcome'; }

  public static get REMISSION_COLLECTION(): string { return 'remission'; }

  public static get SUPERVISOR_REPORT_COLLECTION(): string { return 'supervisor_report'; }

  public static get UNIT_COLLECTION(): string { return 'unit'; }

  public static get BANK_COLLECTION(): string { return 'bank'; }

  public static get BANK_TRANSFER_COLLECTION(): string { return 'bankTransfer'; }

  public static get SUAJE_COLLECTION(): string { return 'suaje'; }

  public static get MACHINE_COLLECTION(): string { return 'machine'; }

  public static get USER_COLLECTION(): string { return 'users'; }

  public static get WAREHOUSE_COLLECTION(): string { return 'warehouse'; }

  public static get TRANSACTION_COLLECTION(): string { return 'transaction'; }

  public static get STOCK_COLLECTION(): string { return 'stock'; }

  public static get CONSTANT_COSTS_COLLECTION(): string { return 'constant_costs'; }

  public static get WORK_SHIFT_COLLECTION(): string { return 'work_shift'; }

  public static get QUOTATIONS_COLLECTION(): string { return 'quotations'; }

  public static get QUOT_COLLECTION(): string { return 'quot'; }

  public static get AUTO_COLLECTION(): string { return 'auto'; }

  public static get EXPENSE_CATEGORY_COLLECTION(): string { return 'expenseCategory'; }

  public static get EXPENSE_CONCEPT_COLLECTION(): string { return 'expenseConcept'; }

  public static get STUDENT_COLLECTION(): string { return 'student'; }
  public static get TEACHER_COLLECTION(): string { return 'teacher'; }

  public static get PARENT_COLLECTION(): string { return 'parent'; }

  public static get DOCUMENTS_TYPES_COLLECTION(): string { return 'documents_types'; }

  public static get DEFECT_COLLECTION(): string { return 'defect'; }

  public static get TIMBRE_PURCHASE_COLLECTION(): string { return 'timbrePurchase'; }


  //////////////////////////////////////////////////////////////////////////////////////////////////////////////Vars
  public static COUNTRIES = {
    '1': { code: 'MEX', name: 'México', clave: 'MEX' },
    '2': { code: 'USA', name: 'Estados Unidos', clave: 'USA' }
  }
  public static STATES = {
    "1": { name: "Aguascalientes", clave: 'AGU' },
    "2": { name: "Baja California", clave: 'BCN' },
    "3": { name: "Baja California Sur", clave: 'BCS' },
    "4": { name: "Campeche", clave: 'CAM' },
    "5": { name: "Coahuila de Zaragoza", clave: 'COA' },
    "6": { name: "Colima", clave: 'COL' },
    "7": { name: "Chiapas", clave: 'CHP' },
    "8": { name: "Chihuahua", clave: 'CHH' },
    "9": { name: "Ciudad de México", clave: 'DIF' },
    "10": { name: "Durango", clave: 'DUR' },
    "11": { name: "Guanajuato", clave: 'GUA' },
    "12": { name: "Guerrero", clave: 'GRO' },
    "13": { name: "Hidalgo", clave: 'HID' },
    "14": { name: "Jalisco", clave: 'JAL' },
    "15": { name: "México", clave: 'MEX' },
    "16": { name: "Michoacán de Ocampo", clave: 'MIC' },
    "17": { name: "Morelos", clave: 'MOR' },
    "18": { name: "Nayarit", clave: 'NAY' },
    "19": { name: "Nuevo León", clave: 'NLE' },
    "20": { name: "Oaxaca", clave: 'OAX' },
    "21": { name: "Puebla", clave: 'PUE' },
    "22": { name: "Querétaro", clave: 'QUE' },
    "23": { name: "Quintana Roo", clave: 'ROO' },
    "24": { name: "San Luis Potosí", clave: 'SLP' },
    "25": { name: "Sinaloa", clave: 'SIN' },
    "26": { name: "Sonora", clave: 'SON' },
    "27": { name: "Tabasco", clave: 'TAB' },
    "28": { name: "Tamaulipas", clave: 'TAM' },
    "29": { name: "Tlaxcala", clave: 'TLA' },
    "30": { name: "Veracruz de Ignacio de la Llave", clave: 'VER' },
    "31": { name: "Yucatán", clave: 'YUC' },
    "32": { name: "Zacatecas", clave: 'ZAC' },
    "999": { name: "Otro", clave: 'CR1' },
  }
  public static LOCALITYS = {
    'Aguascalientes': {locality: '01', state: 'AGU'},
    'Ensenada': {locality: '01', state: 'BCN'},
    'Ciudad Constitución': {locality: '01', state: 'BCS'},
    'San Francisco de Campeche': {locality: '01', state: 'CAM'},
    'Ciudad Acuña': {locality: '01', state: 'COA'},
    'Colima': {locality: '01', state: 'COL'},
    'Santa Rosalía de Camargo': {locality: '01', state: 'CHH'},
    'Comitán de Domínguez': {locality: '01', state: 'CHP'},
    'Ciudad de México': {locality: '01', state: 'DIF'},
    'Victoria de Durango': {locality: '01', state: 'DUR'},
    'Acapulco de Juárez': {locality: '01', state: 'GRO'},
    'Acámbaro': {locality: '01', state: 'GUA'},
    'Actopan': {locality: '01', state: 'HID'},
    'Ameca': {locality: '01', state: 'JAL'},
    'Ciudad Adolfo López Mateos': {locality: '01', state: 'MEX'},
    'Apatzingán de la Constitución': {locality: '01', state: 'MIC'},
    'Cuautla (Cuautla de Morelos)': {locality: '01', state: 'MOR'},
    'Santiago Ixcuintla': {locality: '01', state: 'NAY'},
    'Ciudad Apodaca': {locality: '01', state: 'NLE'},
    'Juchitán (Juchitán de Zaragoza)': {locality: '01', state: 'OAX'},
    'Atlixco': {locality: '01', state: 'PUE'},
    'Querétaro': {locality: '01', state: 'QUE'},
    'Cancún': {locality: '01', state: 'ROO'},
    'Los Mochis': {locality: '01', state: 'SIN'},
    'Ciudad Valles': {locality: '01', state: 'SLP'},
    'San Luis Río Colorado': {locality: '01', state: 'SON'},
    'Cárdenas': {locality: '01', state: 'TAB'},
    'Altamira': {locality: '01', state: 'TAM'},
    'Apizaco': {locality: '01', state: 'TLA'},
    'Acayucan': {locality: '01', state: 'VER'},
    'Mérida': {locality: '01', state: 'YUC'},
    'Fresnillo': {locality: '01', state: 'ZAC'},
    'Calvillo': {locality: '02', state: 'AGU'},
    'Mexicali': {locality: '02', state: 'BCN'},
    'La Paz': {locality: '02', state: 'BCS'},
    'Ciudad del Carmen': {locality: '02', state: 'CAM'},
    'Frontera': {locality: '02', state: 'COA'},
    'Manzanillo': {locality: '02', state: 'COL'},
    'Chihuahua': {locality: '02', state: 'CHH'},
    'San Cristóbal de las Casas': {locality: '02', state: 'CHP'},
    //'Ciudad de México': {locality: '02', state: 'DIF'},
    'Gómez Palacio': {locality: '02', state: 'DUR'},
    'Chilpancingo de los Bravo': {locality: '02', state: 'GRO'},
    'San miguel de Allende': {locality: '02', state: 'GUA'},
    'Apan': {locality: '02', state: 'HID'},
    'Ciudad Guzmán': {locality: '02', state: 'JAL'},
    'Chimalhuacán': {locality: '02', state: 'MEX'},
    'Los Reyes de Salgado': {locality: '02', state: 'MIC'},
    'Cuernavaca': {locality: '02', state: 'MOR'},
    'Tepic': {locality: '02', state: 'NAY'},
    'San Pedro Garza García': {locality: '02', state: 'NLE'},
    'Oaxaca de Juárez': {locality: '02', state: 'OAX'},
    'Izúcar de Matamoros': {locality: '02', state: 'PUE'},
    'San Juan del Rio': {locality: '02', state: 'QUE'},
    'Cozumel': {locality: '02', state: 'ROO'},
    'Culiacán Rosales': {locality: '02', state: 'SIN'},
    'Ébano': {locality: '02', state: 'SLP'},
    'Agua Prieta': {locality: '02', state: 'SON'},
    'Villahermosa': {locality: '02', state: 'TAB'},
    'Ciudad Camargo': {locality: '02', state: 'TAM'},
    'Villa Vicente Guerrero': {locality: '02', state: 'TLA'},
    'Naranjos': {locality: '02', state: 'VER'},
    'Tizimín': {locality: '02', state: 'YUC'},
    'Jerez de García Salinas': {locality: '02', state: 'ZAC'},
    'San Francisco de los Romo': {locality: '03', state: 'AGU'},
    'Tecate': {locality: '03', state: 'BCN'},
    'Cabo San Lucas': {locality: '03', state: 'BCS'},
    'Calkini': {locality: '03', state: 'CAM'},
    'Matamoros': {locality: '03', state: 'COA'},
    'Tecoman': {locality: '03', state: 'COL'},
    'Cuauhtémoc': {locality: '03', state: 'CHH'},
    'Tapachula de Córdova y Ordóñez': {locality: '03', state: 'CHP'},
    //'Ciudad de México': {locality: '03', state: 'DIF'},
    'Ciudad Lerdo': {locality: '03', state: 'DUR'},
    'Iguala de la Independencia': {locality: '03', state: 'GRO'},
    'Celaya': {locality: '03', state: 'GUA'},
    'Pachuca de Soto': {locality: '03', state: 'HID'},
    'Guadalajara': {locality: '03', state: 'JAL'},
    'Coacalco de Berriozabal': {locality: '03', state: 'MEX'},
    'Ciudad Hidalgo': {locality: '03', state: 'MIC'},
    'Galeana': {locality: '03', state: 'MOR'},
    'Tuxpan': {locality: '03', state: 'NAY'},
    'Ciudad General Escobedo': {locality: '03', state: 'NLE'},
    'Salina Cruz': {locality: '03', state: 'OAX'},
    'Puebla (Heroica Puebla)': {locality: '03', state: 'PUE'},
    'Felipe Carrillo Puerto': {locality: '03', state: 'ROO'},
    'Escuinapa de Hidalgo': {locality: '03', state: 'SIN'},
    'Matehuala': {locality: '03', state: 'SLP'},
    'Heroica Caborca': {locality: '03', state: 'SON'},
    'Comalcalco': {locality: '03', state: 'TAB'},
    'Ciudad Madero': {locality: '03', state: 'TAM'},
    'Tlaxcala (Tlaxcala de Xicotencatl)': {locality: '03', state: 'TLA'},
    'Boca del RÍo': {locality: '03', state: 'VER'},
    'Ticul': {locality: '03', state: 'YUC'},
    'Zacatecas': {locality: '03', state: 'ZAC'},
    'Jesús María': {locality: '04', state: 'AGU'},
    'Tijuana': {locality: '04', state: 'BCN'},
    'San José del Cabo': {locality: '04', state: 'BCS'},
    'Candelaria': {locality: '04', state: 'CAM'},
    'Monclova': {locality: '04', state: 'COA'},
    'Ciudad de Villa de Álvarez': {locality: '04', state: 'COL'},
    'Delicias': {locality: '04', state: 'CHH'},
    'Tuxtla Gutiérrez': {locality: '04', state: 'CHP'},
    //'Ciudad de México': {locality: '04', state: 'DIF'},
    'Santiago Papasquiaro': {locality: '04', state: 'DUR'},
    'Taxco de Alarcón': {locality: '04', state: 'GRO'},
    'Cortazar': {locality: '04', state: 'GUA'},
    'Cd. de Fray Bernardino de Sahagún': {locality: '04', state: 'HID'},
    'Lagos de Moreno': {locality: '04', state: 'JAL'},
    'Cuautitlán Izcalli': {locality: '04', state: 'MEX'},
    'Jacona de Plancarte': {locality: '04', state: 'MIC'},
    'Jojutla': {locality: '04', state: 'MOR'},
    'Acaponeta': {locality: '04', state: 'NAY'},
    'Guadalupe': {locality: '04', state: 'NLE'},
    'San Juan Bautista Tuxtepec': {locality: '04', state: 'OAX'},
    'San Martín Texmelucan de Labastida': {locality: '04', state: 'PUE'},
    'El Pueblito': {locality: '04', state: 'QUE'},
    'Chetumal': {locality: '04', state: 'ROO'},
    'Guasave': {locality: '04', state: 'SIN'},
    'Rioverde': {locality: '04', state: 'SLP'},
    'Ciudad Obregón': {locality: '04', state: 'SON'},
    'Emiliano Zapata': {locality: '04', state: 'TAB'},
    'Ciudad Mante': {locality: '04', state: 'TAM'},
    'Huamantla': {locality: '04', state: 'TLA'},
    'Coatepec': {locality: '04', state: 'VER'},
    'Motul de Carrillo Puerto': {locality: '04', state: 'YUC'},
    //'Guadalupe': {locality: '04', state: 'ZAC'},
    'Pabellón de Arteaga': {locality: '05', state: 'AGU'},
    'Playas de Rosarito': {locality: '05', state: 'BCN'},
    'Loreto': {locality: '05', state: 'BCS'},
    'Escárcega': {locality: '05', state: 'CAM'},
    'Parras de la Fuente': {locality: '05', state: 'COA'},
    'Ciudad de Armería': {locality: '05', state: 'COL'},
    'Hidalgo del Parral': {locality: '05', state: 'CHH'},
    'Venustiano Carranza': {locality: '05', state: 'CHP'},
    //'Ciudad de México': {locality: '05', state: 'DIF'},
    'Canatlán': {locality: '05', state: 'DUR'},
    'Arcelia': {locality: '05', state: 'GRO'},
    'Guanajuato': {locality: '05', state: 'GUA'},
    'Tula de Allende': {locality: '05', state: 'HID'},
    'Ocotlán': {locality: '05', state: 'JAL'},
    'Ecatepec de Morelos': {locality: '05', state: 'MEX'},
    'La piedad de Cabadas': {locality: '05', state: 'MIC'},
    'Puente de Ixtla': {locality: '05', state: 'MOR'},
    'Tecuala': {locality: '05', state: 'NAY'},
    'Linares': {locality: '05', state: 'NLE'},
    'Matías Romero Avendaño': {locality: '05', state: 'OAX'},
    'Tehuacan': {locality: '05', state: 'PUE'},
    'Playa del Carmen': {locality: '05', state: 'ROO'},
    'Mazatlán': {locality: '05', state: 'SIN'},
    'San Luis Potosí': {locality: '05', state: 'SLP'},
    'Empalme': {locality: '05', state: 'SON'},
    'Jalpa de Méndez': {locality: '05', state: 'TAB'},
    'Heroica Matamoros': {locality: '05', state: 'TAM'},
    'Calpulalpan': {locality: '05', state: 'TLA'},
    'Agua dulce': {locality: '05', state: 'VER'},
    'Valladolid': {locality: '05', state: 'YUC'},
    'Río Grande': {locality: '05', state: 'ZAC'},
    'Rincón de Romos': {locality: '06', state: 'AGU'},
    'Rodolfo Sánchez T. (Maneadero)': {locality: '06', state: 'BCN'},
    'Puerto Adolfo López Mateos': {locality: '06', state: 'BCS'},
    'Sabancuy': {locality: '06', state: 'CAM'},
    'Piedras Negras': {locality: '06', state: 'COA'},
    'Juárez': {locality: '06', state: 'CHH'},
    'Jiquipilas': {locality: '06', state: 'CHP'},
    //'Ciudad de México': {locality: '06', state: 'DIF'},
    'San Juan del Río del Centauro del Norte': {locality: '06', state: 'DUR'},
    'Ayutla de los Libres': {locality: '06', state: 'GRO'},
    'Irapuato': {locality: '06', state: 'GUA'},
    'Tulancingo': {locality: '06', state: 'HID'},
    'Puerto Vallarta': {locality: '06', state: 'JAL'},
    'Huixquilucan de Degollado': {locality: '06', state: 'MEX'},
    'Morelia': {locality: '06', state: 'MIC'},
    'Santa Rosa Treinta': {locality: '06', state: 'MOR'},
    'Compostela': {locality: '06', state: 'NAY'},
    'Montemorelos': {locality: '06', state: 'NLE'},
    'Heroica Ciudad de Huajuapan de León': {locality: '06', state: 'OAX'},
    'Teziutlan': {locality: '06', state: 'PUE'},
    'Kantunilkín': {locality: '06', state: 'ROO'},
    'Guamúchil': {locality: '06', state: 'SIN'},
    'Soledad de Graciano Sánchez': {locality: '06', state: 'SLP'},
    'Heroica Guaymas': {locality: '06', state: 'SON'},
    'Nuevo Laredo': {locality: '06', state: 'TAM'},
    'Chiautempan': {locality: '06', state: 'TLA'},
    'Coatzacoalcos': {locality: '06', state: 'VER'},
    'Kanasín': {locality: '06', state: 'YUC'},
    'Ciudad Cuauhtémoc': {locality: '06', state: 'ZAC'},
    'Asientos': {locality: '07', state: 'AGU'},
    'San Felipe': {locality: '07', state: 'BCN'},
    'Todos Santos': {locality: '07', state: 'BCS'},
    'Hopelchén': {locality: '07', state: 'CAM'},
    'Sabinas': {locality: '07', state: 'COA'},
    'Nuevo Casas Grandes': {locality: '07', state: 'CHH'},
    'Villaflores': {locality: '07', state: 'CHP'},
    //'Ciudad de México': {locality: '07', state: 'DIF'},
    'Peñón Blanco': {locality: '07', state: 'DUR'},
    'Atoyac de Álvarez': {locality: '07', state: 'GRO'},
    'León de los Aldama': {locality: '07', state: 'GUA'},
    'Zimapan': {locality: '07', state: 'HID'},
    'San Juan de los Lagos': {locality: '07', state: 'JAL'},
    'Los Reyes Acaquilpan (La Paz)': {locality: '07', state: 'MEX'},
    'Pátzcuaro': {locality: '07', state: 'MIC'},
    'Zacatepec de Hidalgo': {locality: '07', state: 'MOR'},
    'Francisco I. Madero (Puga)': {locality: '07', state: 'NAY'},
    'Monterrey': {locality: '07', state: 'NLE'},
    'Loma Bonita': {locality: '07', state: 'OAX'},
    'San Andrés Cholula': {locality: '07', state: 'PUE'},
    'Isla Mujeres': {locality: '07', state: 'ROO'},
    'Navolato': {locality: '07', state: 'SIN'},
    'Charcas': {locality: '07', state: 'SLP'},
    'Hermosillo': {locality: '07', state: 'SON'},
    'Macuspana': {locality: '07', state: 'TAB'},
    'Reynosa': {locality: '07', state: 'TAM'},
    'Córdoba': {locality: '07', state: 'VER'},
    'Ojocaliente': {locality: '07', state: 'ZAC'},
    'Tepezalá': {locality: '08', state: 'AGU'},
    'Heroica Mulegé': {locality: '08', state: 'BCS'},
    'Champotón': {locality: '08', state: 'CAM'},
    'Saltillo': {locality: '08', state: 'COA'},
    'Las Margaritas': {locality: '08', state: 'CHP'},
    //'Ciudad de México': {locality: '08', state: 'DIF'},
    'Francisco I. Madero': {locality: '08', state: 'DUR'},
    'Moroleón': {locality: '08', state: 'GUA'},
    'Huejutla de Reyes': {locality: '08', state: 'HID'},
    'Tepatitlán de Morelos': {locality: '08', state: 'JAL'},
    'Metepec': {locality: '08', state: 'MEX'},
    'Sahuayo de Morelos': {locality: '08', state: 'MIC'},
    'Tlaquiltenango': {locality: '08', state: 'MOR'},
    'Villa Hidalgo (El Nuevo)': {locality: '08', state: 'NAY'},
    'Ciudad Sabinas Hidalgo': {locality: '08', state: 'NLE'},
    'Puerto Escondido': {locality: '08', state: 'OAX'},
    'San Pedro Cholula': {locality: '08', state: 'PUE'},
    'Bacalar': {locality: '08', state: 'ROO'},
    'Quila': {locality: '08', state: 'SIN'},
    'Salinas de Hidalgo': {locality: '08', state: 'SLP'},
    'Huatabampo': {locality: '08', state: 'SON'},
    'Tenosique de Pino Suárez': {locality: '08', state: 'TAB'},
    'Ciudad Río Bravo': {locality: '08', state: 'TAM'},
    'Tres Valles': {locality: '08', state: 'VER'},
    'Villa Hidalgo': {locality: '08', state: 'ZAC'},
    'Cosío': {locality: '09', state: 'AGU'},
    'Villa Alberto Andrés Alvarado Arámburo': {locality: '09', state: 'BCS'},
    'Hecelchakán': {locality: '09', state: 'CAM'},
    'Nueva Rosita': {locality: '09', state: 'COA'},
    'Madera': {locality: '09', state: 'CHH'},
    'Arriaga': {locality: '09', state: 'CHP'},
    //'Ciudad de México': {locality: '09', state: 'DIF'},
    'Nombre de Dios': {locality: '09', state: 'DUR'},
    'San Jerónimo de Juárez': {locality: '09', state: 'GRO'},
    'Salamanca': {locality: '09', state: 'GUA'},
    'Tlaxcoapan': {locality: '09', state: 'HID'},
    'Tlaquepaque': {locality: '09', state: 'JAL'},
    'Naucalpan de Juárez': {locality: '09', state: 'MEX'},
    'Uruapan': {locality: '09', state: 'MIC'},
    'Ruiz': {locality: '09', state: 'NAY'},
    'San Nicolás de los Garza': {locality: '09', state: 'NLE'},
    'Río Grande o Piedra Parada': {locality: '09', state: 'OAX'},
    'Huauchinango': {locality: '09', state: 'PUE'},
    'Ahome': {locality: '09', state: 'SIN'},
    //'Cárdenas': {locality: '09', state: 'SLP'},
    'Navojoa': {locality: '09', state: 'SON'},
    'Teapa': {locality: '09', state: 'TAB'},
    'San Fernando': {locality: '09', state: 'TAM'},
    'Jáltipan de Morelos': {locality: '09', state: 'VER'},
    'Villanueva': {locality: '09', state: 'ZAC'},
    'San Ignacio': {locality: '10', state: 'BCS'},
    'San Pedro': {locality: '10', state: 'COA'},
    'Colonia Anáhuac': {locality: '10', state: 'CHH'},
    'Palenque': {locality: '10', state: 'CHP'},
    //'Ciudad de México': {locality: '10', state: 'DIF'},
    'Vicente Guerrero': {locality: '10', state: 'DUR'},
    'Ciudad Apaxtla de Castrejón': {locality: '10', state: 'GRO'},
    'San Francisco del Rincón': {locality: '10', state: 'GUA'},
    'Tizayuca': {locality: '10', state: 'HID'},
    'Zapopan': {locality: '10', state: 'JAL'},
    'Ciudad Nezahualcoyotl': {locality: '10', state: 'MEX'},
    'Zacapu': {locality: '10', state: 'MIC'},
    'San Blas': {locality: '10', state: 'NAY'},
    'Ciudad Santa Catarina': {locality: '10', state: 'NLE'},
    'Acatlán de Osorio': {locality: '10', state: 'PUE'},
    'Higuera de Zaragoza': {locality: '10', state: 'SIN'},
    'Cerritos': {locality: '10', state: 'SLP'},
    'Heroica Nogales': {locality: '10', state: 'SON'},
    'Paraíso': {locality: '10', state: 'TAB'},
    'Tampico': {locality: '10', state: 'TAM'},
    'Xalapa-Enríquez': {locality: '10', state: 'VER'},
    'Villa de Cos': {locality: '10', state: 'ZAC'},
    'Guerrero Negro': {locality: '11', state: 'BCS'},
    'Pomuch': {locality: '11', state: 'CAM'},
    'Torreón': {locality: '11', state: 'COA'},
    'Juan Aldama': {locality: '11', state: 'CHH'},
    'Ocosingo': {locality: '11', state: 'CHP'},
    //'Ciudad de México': {locality: '11', state: 'DIF'},
    'El Salto': {locality: '11', state: 'DUR'},
    'Ciudad Altamirano': {locality: '11', state: 'GRO'},
    'Silao': {locality: '11', state: 'GUA'},
    'Santiago Tulantepec': {locality: '11', state: 'HID'},
    'Tlajomulco de Zúñiga': {locality: '11', state: 'JAL'},
    'Villa Nicolás Romero': {locality: '11', state: 'MEX'},
    'Zamora de Hidalgo': {locality: '11', state: 'MIC'},
    'Ixtlán del Río': {locality: '11', state: 'NAY'},
    'Doctor Arroyo': {locality: '11', state: 'NLE'},
    'Santiago Suchilquitongo': {locality: '11', state: 'OAX'},
    'Cuautlancingo': {locality: '11', state: 'PUE'},
    'Choix': {locality: '11', state: 'SIN'},
    'Tamuin': {locality: '11', state: 'SLP'},
    'Puerto Peñasco': {locality: '11', state: 'SON'},
    //'Frontera': {locality: '11', state: 'TAB'},
    'Ciudad Victoria': {locality: '11', state: 'TAM'},
    'Minatitlán': {locality: '11', state: 'VER'},
    'Nochistlán de Mejía': {locality: '11', state: 'ZAC'},
    'Santa Rosalía': {locality: '12', state: 'BCS'},
    'Castaños': {locality: '12', state: 'COA'},
    'José Mariano Jiménez': {locality: '12', state: 'CHH'},
    'Tonalá': {locality: '12', state: 'CHP'},
    //'Ciudad de México': {locality: '12', state: 'DIF'},
    'Santa María del Oro': {locality: '12', state: 'DUR'},
    'Buenavista de Cuellar': {locality: '12', state: 'GRO'},
    'Jerécuaro': {locality: '12', state: 'GUA'},
    'Ixmiquilpan': {locality: '12', state: 'HID'},
    //'Tonalá': {locality: '12', state: 'JAL'},
    'Tecamac de Felipe Villanueva': {locality: '12', state: 'MEX'},
    'Heroica Zitácuaro': {locality: '12', state: 'MIC'},
    'Bucerías': {locality: '12', state: 'NAY'},
    'Ciénega de Flores': {locality: '12', state: 'NLE'},
    'San Felipe Jalapa de Díaz': {locality: '12', state: 'OAX'},
    'Tepeaca': {locality: '12', state: 'PUE'},
    'Villa Unión': {locality: '12', state: 'SIN'},
    'Tamasopo': {locality: '12', state: 'SLP'},
    'Heroica Ciudad de Cananea': {locality: '12', state: 'SON'},
    'Cunduacán': {locality: '12', state: 'TAB'},
    'González': {locality: '12', state: 'TAM'},
    'Orizaba': {locality: '12', state: 'VER'},
    'Víctor Rosales': {locality: '12', state: 'ZAC'},
    'Francisco I. Madero (Chávez)': {locality: '13', state: 'COA'},
    'Manuel Ojinaga': {locality: '13', state: 'CHH'},
    'Mapastepec': {locality: '13', state: 'CHP'},
    //'Ciudad de México': {locality: '13', state: 'DIF'},
    'Cutzamala de Pinzón': {locality: '13', state: 'GRO'},
    'Santiago Maravatío': {locality: '13', state: 'GUA'},
    'Tepeji del Rio': {locality: '13', state: 'HID'},
    //'Tuxpan': {locality: '13', state: 'JAL'},
    'Tepotzotlán': {locality: '13', state: 'MEX'},
    'Paracho de Verduzco': {locality: '13', state: 'MIC'},
    'Las Varas': {locality: '13', state: 'NAY'},
    'Hualahuises': {locality: '13', state: 'NLE'},
    'Bahias de Huatulco': {locality: '13', state: 'OAX'},
    'Tecamachalco': {locality: '13', state: 'PUE'},
    'Sinaloa de Leyva': {locality: '13', state: 'SIN'},
    'Ciudad del Maíz': {locality: '13', state: 'SLP'},
    'Sonoita': {locality: '13', state: 'SON'},
    'Huimanguillo': {locality: '13', state: 'TAB'},
    'Jaumave': {locality: '13', state: 'TAM'},
    'Papantla de Olarte': {locality: '13', state: 'VER'},
    'Valparaíso': {locality: '13', state: 'ZAC'},
    'Cuatro Ciénegas de Carranza': {locality: '14', state: 'COA'},
    'Bachíniva': {locality: '14', state: 'CHH'},
    'Las Rosas': {locality: '14', state: 'CHP'},
    //'Ciudad de México': {locality: '14', state: 'DIF'},
    'Coyuca de Catalán': {locality: '14', state: 'GRO'},
    'Romita': {locality: '14', state: 'GUA'},
    'Cruz Azul': {locality: '14', state: 'HID'},
    'Tototlán': {locality: '14', state: 'JAL'},
    'Tlalnepantla de Baz': {locality: '14', state: 'MEX'},
    'Tangancícuaro de Arista': {locality: '14', state: 'MIC'},
    'Xalisco': {locality: '14', state: 'NAY'},
    'Putla Villa de Guerrero': {locality: '14', state: 'OAX'},
    'Zacatlán': {locality: '14', state: 'PUE'},
    'Mocorito': {locality: '14', state: 'SIN'},
    'Cedral': {locality: '14', state: 'SLP'},
    'Magdalena de Kino': {locality: '14', state: 'SON'},
    'Ciudad Gustavo Díaz Ordaz': {locality: '14', state: 'TAM'},
    'Poza Rica de Hidalgo': {locality: '14', state: 'VER'},
    'Luis Moya': {locality: '14', state: 'ZAC'},
    'Nadadores': {locality: '15', state: 'COA'},
    'Saucillo': {locality: '15', state: 'CHH'},
    'Chiapa de Corzo': {locality: '15', state: 'CHP'},
    //'Ciudad de México': {locality: '15', state: 'DIF'},
    'Tierra Colorada': {locality: '15', state: 'GRO'},
    'Tarandacuao': {locality: '15', state: 'GUA'},
    'Tepeapulco': {locality: '15', state: 'HID'},
    'San Diego de Alejandría': {locality: '15', state: 'JAL'},
    'Santa Maria Tultepec': {locality: '15', state: 'MEX'},
    'Maravatío de Ocampo': {locality: '15', state: 'MIC'},
    'San pedro Lagunillas': {locality: '15', state: 'NAY'},
    'Cadereyta Jiménez': {locality: '15', state: 'NLE'},
    'Cosolapa': {locality: '15', state: 'OAX'},
    'Xicotepec': {locality: '15', state: 'PUE'},
    'Angostura': {locality: '15', state: 'SIN'},
    'Tierra Nueva': {locality: '15', state: 'SLP'},
    'Estación Manuel (Úrsulo Galván)': {locality: '15', state: 'TAM'},
    'San Andrés Tuxtla': {locality: '15', state: 'VER'},
    'Moyahua de Estrada': {locality: '15', state: 'ZAC'},
    'Ramos Arizpe': {locality: '16', state: 'COA'},
    'Cacahoatán': {locality: '16', state: 'CHP'},
    //'Ciudad de México': {locality: '16', state: 'DIF'},
    'Coyuca de Benítez': {locality: '16', state: 'GRO'},
    'Huanímaro': {locality: '16', state: 'GUA'},
    'La Resolana': {locality: '16', state: 'JAL'},
    'Tultitlán de Mariano Escobedo': {locality: '16', state: 'MEX'},
    'Zinapécuaro de Figueroa': {locality: '16', state: 'MIC'},
    'La peñita de Jaltemba': {locality: '16', state: 'NAY'},
    'Tlacolula de Matamoros': {locality: '16', state: 'OAX'},
    'Ciudad Serdán': {locality: '16', state: 'PUE'},
    //'San Blas': {locality: '16', state: 'SIN'},
    'Villa de Reyes': {locality: '16', state: 'SLP'},
    'Xicoténcatl': {locality: '16', state: 'TAM'},
    'Túxpam de Rodríguez Cano': {locality: '16', state: 'VER'},
    'Sombrerete': {locality: '16', state: 'ZAC'},
    'Nava': {locality: '17', state: 'COA'},
    'Ocozocoautla de Espinosa': {locality: '17', state: 'CHP'},
    'Olinalá': {locality: '17', state: 'GRO'},
    'Comonfort': {locality: '17', state: 'GUA'},
    'Atotonilco el Alto': {locality: '17', state: 'JAL'},
    'Cuautitlán': {locality: '17', state: 'MEX'},
    'Puruándiro': {locality: '17', state: 'MIC'},
    'Jala': {locality: '17', state: 'NAY'},
    'Santiago': {locality: '17', state: 'NLE'},
    'San Pablo Villa de Mitla': {locality: '17', state: 'OAX'},
    'Amozoc': {locality: '17', state: 'PUE'},
    'La Cruz': {locality: '17', state: 'SIN'},
    'Fracción el Refugio': {locality: '17', state: 'SLP'},
    'Ciudad Miguel Alemán': {locality: '17', state: 'TAM'},
    'Veracruz': {locality: '17', state: 'VER'},
    'Jalpa': {locality: '17', state: 'ZAC'},
    'Zaragoza': {locality: '18', state: 'COA'},
    'Cintalapa de Figueroa': {locality: '18', state: 'CHP'},
    'Marquelia': {locality: '18', state: 'GRO'},
    'Uriangato': {locality: '18', state: 'GUA'},
    'Jalostotitlán': {locality: '18', state: 'JAL'},
    'Ixtapaluca': {locality: '18', state: 'MEX'},
    'Yurécuaro': {locality: '18', state: 'MIC'},
    'Ahuacatlán': {locality: '18', state: 'NAY'},
    'El cercado': {locality: '18', state: 'NLE'},
    'Natividad': {locality: '18', state: 'OAX'},
    'El rosario': {locality: '18', state: 'SIN'},
    'Tamazunchale': {locality: '18', state: 'SLP'},
    'Soto la Marina': {locality: '18', state: 'TAM'},
    'Tierra Blanca': {locality: '18', state: 'VER'},
    //'Loreto': {locality: '18', state: 'ZAC'},
    'San Buenaventura': {locality: '19', state: 'COA'},
    'Pichucalco': {locality: '19', state: 'CHP'},
    'Zumpango del Río': {locality: '19', state: 'GRO'},
    'Pénjamo': {locality: '19', state: 'GUA'},
    'Poncitlán': {locality: '19', state: 'JAL'},
    'Texcoco de Mora': {locality: '19', state: 'MEX'},
    'Huetamo de Núñez': {locality: '19', state: 'MIC'},
    'Teotitlán de Flores Magón': {locality: '19', state: 'OAX'},
    'Estación Naranjo': {locality: '19', state: 'SIN'},
    'Santa María del Río': {locality: '19', state: 'SLP'},
    'Ciudad Tula': {locality: '19', state: 'TAM'},
    'Cosamaloapan': {locality: '19', state: 'VER'},
    //'Juan Aldama': {locality: '19', state: 'ZAC'},
    'Ciudad Melchor Múzquiz': {locality: '20', state: 'COA'},
    'Puerto Madero (San Benito)': {locality: '20', state: 'CHP'},
    'San Luis de la Loma': {locality: '20', state: 'GRO'},
    'Cuerámaro': {locality: '20', state: 'GUA'},
    'Arandas': {locality: '20', state: 'JAL'},
    'Toluca de Lerdo': {locality: '20', state: 'MEX'},
    'Tacámbaro de Codallos': {locality: '20', state: 'MIC'},
    'Anáhuac': {locality: '20', state: 'NLE'},
    'Santa María Huatulco': {locality: '20', state: 'OAX'},
    'Aguaruto': {locality: '20', state: 'SIN'},
    'El Naranjo': {locality: '20', state: 'SLP'},
    'Nueva Ciudad Guerrero': {locality: '20', state: 'TAM'},
    'Carlos A. Carrillo': {locality: '20', state: 'VER'},
    'Viesca': {locality: '21', state: 'COA'},
    'Pijijiapan': {locality: '21', state: 'CHP'},
    'Petatlán': {locality: '21', state: 'GRO'},
    'Empalme Escobedo (Escobedo)': {locality: '21', state: 'GUA'},
    'Talpa de Allende': {locality: '21', state: 'JAL'},
    'Valle de Chalco Solidaridad': {locality: '21', state: 'MEX'},
    'Ciudad Lázaro Cárdenas': {locality: '21', state: 'MIC'},
    'García': {locality: '21', state: 'NLE'},
    'San Juan Bautista Cuicatlán': {locality: '21', state: 'OAX'},
    'Cosalá': {locality: '21', state: 'SIN'},
    'Valle Hermoso': {locality: '21', state: 'TAM'},
    'Pánuco': {locality: '21', state: 'VER'},
    'Morelos': {locality: '22', state: 'COA'},
    'Reforma': {locality: '22', state: 'CHP'},
    'La Unión': {locality: '22', state: 'GRO'},
    'San Luis de la Paz': {locality: '22', state: 'GUA'},
    'Etzatlán': {locality: '22', state: 'JAL'},
    'Tejupilco de Hidalgo': {locality: '22', state: 'MEX'},
    'Las Guacamayas': {locality: '22', state: 'MIC'},
    'Ciudad Benito Juárez': {locality: '22', state: 'NLE'},
    'Villa Sola de Vega': {locality: '22', state: 'OAX'},
    //'San Ignacio': {locality: '22', state: 'SIN'},
    'Tampico Alto': {locality: '22', state: 'VER'},
    'Arteaga': {locality: '23', state: 'COA'},
    'Huixtla': {locality: '23', state: 'CHP'},
    'San Luis San Pedro': {locality: '23', state: 'GRO'},
    'Valle de Santiago': {locality: '23', state: 'GUA'},
    'Sayula': {locality: '23', state: 'JAL'},
    'Chalco de Díaz Covarrubias': {locality: '23', state: 'MEX'},
    'Jiquilpan de Juárez': {locality: '23', state: 'MIC'},
    'Ocotlán de Morelos': {locality: '23', state: 'OAX'},
    'Topolobampo': {locality: '23', state: 'SIN'},
    'Tempoal de Sánchez': {locality: '23', state: 'VER'},
    'Allende': {locality: '24', state: 'COA'},
    'Motozintla de Mendoza': {locality: '24', state: 'CHP'},
    'Teloloapan': {locality: '24', state: 'GRO'},
    'Abasolo': {locality: '24', state: 'GUA'},
    'Ahualulco de Mercado': {locality: '24', state: 'JAL'},
    'Amatepec': {locality: '24', state: 'MEX'},
    //'Tuxpan': {locality: '24', state: 'MIC'},
    'Villa de Zaachila': {locality: '24', state: 'OAX'},
    'Lic. Benito Juárez (Campo Gobierno)': {locality: '24', state: 'SIN'},
    'Tantoyuca': {locality: '24', state: 'VER'},
    'Acala': {locality: '25', state: 'CHP'},
    'Técpan de Galeana': {locality: '25', state: 'GRO'},
    'Rincón de Tamayo': {locality: '25', state: 'GUA'},
    'Autlán de Navarro': {locality: '25', state: 'JAL'},
    'Cotija de la Paz': {locality: '25', state: 'MIC'},
    'Miahuatlán de Porfirio Díaz': {locality: '25', state: 'OAX'},
    'Gutiérrez Zamora': {locality: '25', state: 'VER'},
    'Huitzuco': {locality: '26', state: 'GRO'},
    'Villagrán': {locality: '26', state: 'GUA'},
    'Magdalena': {locality: '26', state: 'JAL'},
    'Melchor Ocampo': {locality: '26', state: 'MEX'},
    'Nueva Italia de Ruiz': {locality: '26', state: 'MIC'},
    'Unión Hidalgo': {locality: '26', state: 'OAX'},
    'Platón Sánchez': {locality: '26', state: 'VER'},
    'Tixtla de Guerrero': {locality: '27', state: 'GRO'},
    'Yuriria': {locality: '27', state: 'GUA'},
    'San Julián': {locality: '27', state: 'JAL'},
    'San Vicente Chicoloapan de Juárez': {locality: '27', state: 'MEX'},
    'Cuitzeo del Porvenir': {locality: '27', state: 'MIC'},
    'El Camarón': {locality: '27', state: 'OAX'},
    'Juan Rodríguez Clara': {locality: '27', state: 'VER'},
    'Tepecoacuilco de Trujano': {locality: '28', state: 'GRO'},
    'Apaseo el Grande': {locality: '28', state: 'GUA'},
    'Cocula': {locality: '28', state: 'JAL'},
    'Capulhuac': {locality: '28', state: 'MEX'},
    'San Pedro Mixtepec -Dto. 22-': {locality: '28', state: 'OAX'},
    'Huatusco de Chicuellar': {locality: '28', state: 'VER'},
    'San Marcos': {locality: '29', state: 'GRO'},
    'Purísima de Bustos': {locality: '29', state: 'GUA'},
    'El Grullo': {locality: '29', state: 'JAL'},
    'Juchitepec de Mariano Riva Palacio': {locality: '29', state: 'MEX'},
    'Santa Cruz Itundujia': {locality: '29', state: 'OAX'},
    'Ixtaczoquitlán': {locality: '29', state: 'VER'},
    'Azoyú': {locality: '30', state: 'GRO'},
    'Salvatierra': {locality: '30', state: 'GUA'},
    'San Miguel el Alto': {locality: '30', state: 'JAL'},
    'Tequixquiac': {locality: '30', state: 'MEX'},
    'Chahuites': {locality: '30', state: 'OAX'},
    'Río Blanco': {locality: '30', state: 'VER'},
    'Tlapehuala': {locality: '31', state: 'GRO'},
    'Marfil': {locality: '31', state: 'GUA'},
    'Tala': {locality: '31', state: 'JAL'},
    'Xonacatlán': {locality: '31', state: 'MEX'},
    'Heroica Ciudad de Ejutla de Crespo': {locality: '31', state: 'OAX'},
    'Isla': {locality: '31', state: 'VER'},
    'San Luis Acatlán': {locality: '32', state: 'GRO'},
    'San José Iturbide': {locality: '32', state: 'GUA'},
    'La Barca': {locality: '32', state: 'JAL'},
    'San Mateo Atenco': {locality: '32', state: 'MEX'},
    'San Pedro Tapanatepec': {locality: '32', state: 'OAX'},
    'Cuitláhuac': {locality: '32', state: 'VER'},
    'Chilapa de Álvarez': {locality: '33', state: 'GRO'},
    'Apaseo el Alto': {locality: '33', state: 'GUA'},
    'Jamay': {locality: '33', state: 'JAL'},
    'Vicente Camalote': {locality: '33', state: 'OAX'},
    'Fortín de las Flores': {locality: '33', state: 'VER'},
    'Tlapa de Comonfort': {locality: '34', state: 'GRO'},
    'Ciudad Manuel Doblado': {locality: '34', state: 'GUA'},
    'Yahualica de González Gallo': {locality: '34', state: 'JAL'},
    'Villa de Tamazulápam del Progreso': {locality: '34', state: 'OAX'},
    'Alvarado': {locality: '34', state: 'VER'},
    'Tlalixtaquilla': {locality: '35', state: 'GRO'},
    'Jaral del Progreso': {locality: '35', state: 'GUA'},
    'Colotlán': {locality: '35', state: 'JAL'},
    'San Juan Bautista lo de Soto': {locality: '35', state: 'OAX'},
    'José Cardel': {locality: '35', state: 'VER'},
    'Cuajinicuilapa': {locality: '36', state: 'GRO'},
    'San Diego de la Unión': {locality: '36', state: 'GUA'},
    'Cihuatlán': {locality: '36', state: 'JAL'},
    'Chiconcuac': {locality: '36', state: 'MEX'},
    'San Juan Cacahuatepec': {locality: '36', state: 'OAX'},
    'Banderilla': {locality: '36', state: 'VER'},
    'Huamuxtitlan': {locality: '37', state: 'GRO'},
    'Santa Cruz Juventino Rosas': {locality: '37', state: 'GUA'},
    'Zapotiltic': {locality: '37', state: 'JAL'},
    'San Pedro Totolapa': {locality: '37', state: 'OAX'},
    'Paraje Nuevo': {locality: '37', state: 'VER'},
    'Cruz Grande': {locality: '38', state: 'GRO'},
    'Doctor Mora': {locality: '38', state: 'GUA'},
    'Villa Corona': {locality: '38', state: 'JAL'},
    'San Miguel el Grande': {locality: '38', state: 'OAX'},
    'Playa Vicente': {locality: '38', state: 'VER'},
    'Ocotito': {locality: '39', state: 'GRO'},
    'Dolores Hgo. Cuna de la Indep. Nal.': {locality: '39', state: 'GUA'},
    'Teocaltiche': {locality: '39', state: 'JAL'},
    'Almoloya de Juárez': {locality: '39', state: 'MEX'},
    'Zimatlán de Álvarez': {locality: '39', state: 'OAX'},
    'Altotonga': {locality: '39', state: 'VER'},
    'Copala': {locality: '40', state: 'GRO'},
    'Ocoyoacac': {locality: '40', state: 'MEX'},
    'San Pablo Huitzo': {locality: '40', state: 'OAX'},
    'Juan Díaz Covarrubias': {locality: '40', state: 'VER'},
    'Zihuatanejo': {locality: '41', state: 'GRO'},
    'Tequila': {locality: '41', state: 'JAL'},
    'Zumpango': {locality: '41', state: 'MEX'},
    'San Francisco Telixtlahuaca': {locality: '41', state: 'OAX'},
    'Cuichapa': {locality: '41', state: 'VER'},
    'El Quince (San José el Quince)': {locality: '42', state: 'JAL'},
    'Mariscala de Juárez': {locality: '42', state: 'OAX'},
    'Santiago Tuxtla': {locality: '42', state: 'VER'},
    'San José el Verde (El Verde)': {locality: '43', state: 'JAL'},
    'Santiago Pinotepa Nacional': {locality: '43', state: 'OAX'},
    'Huayacocotla': {locality: '43', state: 'VER'},
    'Jocotepec': {locality: '44', state: 'JAL'},
    'Santiago Jamiltepec': {locality: '44', state: 'OAX'},
    'Paso de Ovejas': {locality: '44', state: 'VER'},
    'Tecalitlán': {locality: '45', state: 'JAL'},
    'San Pedro Pochutla': {locality: '45', state: 'OAX'},
    'Catemaco': {locality: '45', state: 'VER'},
    'Chapala': {locality: '46', state: 'JAL'},
    'Heroica Ciudad de Tlaxiaco': {locality: '46', state: 'OAX'},
    'Nogales': {locality: '46', state: 'VER'},
    'Ajijic': {locality: '47', state: 'JAL'},
    'San Juan Bautista Valle Nacional': {locality: '47', state: 'OAX'},
    'Las Choapas': {locality: '47', state: 'VER'},
    'San Ignacio Cerro Gordo': {locality: '48', state: 'JAL'},
    'Lagunas': {locality: '48', state: 'OAX'},
    'General Miguel Alemán (Potrero Nuevo)': {locality: '48', state: 'VER'},
    'Zacoalco de Torres': {locality: '49', state: 'JAL'},
    'Ciudad Ixtepec': {locality: '49', state: 'OAX'},
    'Coatzintla': {locality: '49', state: 'VER'},
    'Huejuquilla el Alto': {locality: '50', state: 'JAL'},
    'Santiago Juxtlahuaca': {locality: '50', state: 'OAX'},
    'Ángel R. Cabada': {locality: '50', state: 'VER'},
    //'Villa Hidalgo': {locality: '51', state: 'JAL'},
    'San Sebastián Tecomaxtlahuaca': {locality: '51', state: 'OAX'},
    'San Rafael': {locality: '51', state: 'VER'},
    'Unión de San Antonio': {locality: '52', state: 'JAL'},
    'Asunción Nochixtlán': {locality: '52', state: 'OAX'},
    'Tlacojalpan': {locality: '52', state: 'VER'},
    'Las Pintitas': {locality: '53', state: 'JAL'},
    'San Francisco Ixhuatán': {locality: '53', state: 'OAX'},
    'Cosoleacaque': {locality: '53', state: 'VER'},
    'Tamazula de Gordiano': {locality: '54', state: 'JAL'},
    'San Blas Atempa': {locality: '54', state: 'OAX'},
    'Lerdo de Tejada': {locality: '54', state: 'VER'},
    'Acatlán de Juárez': {locality: '55', state: 'JAL'},
    'Santo Domingo Tehuantepec': {locality: '55', state: 'OAX'},
    'Tihuatlán': {locality: '55', state: 'VER'},
    'Valle de Guadalupe': {locality: '56', state: 'JAL'},
    'Cuilápam de Guerrero': {locality: '56', state: 'OAX'},
    'Atoyac': {locality: '56', state: 'VER'},
    'El Rosario': {locality: '57', state: 'OAX'},
    'Huiloapan de Cuauhtémoc': {locality: '57', state: 'VER'},
    'Santa Lucia del Camino': {locality: '58', state: 'OAX'},
    'Cazones de Herrera': {locality: '58', state: 'VER'},
    'San Antonio de la Cal': {locality: '59', state: 'OAX'},
    'Yecuatla': {locality: '59', state: 'VER'},
    'Soledad de Doblado': {locality: '60', state: 'VER'},
    'Cerro Azul': {locality: '61', state: 'VER'},
    'Tezonapa': {locality: '62', state: 'VER'},
    'Sihuapan': {locality: '66', state: 'VER'},
    'El Higo': {locality: '67', state: 'VER'},
    'Paso del Macho': {locality: '68', state: 'VER'},
    'Tlapacoyan': {locality: '69', state: 'VER'},
  };
  public static MUNICIPALITYS = {
    'Aguascalientes': {municipality: '001', state: 'AGU'},
    'Ensenada': {municipality: '001', state: 'BCN'},
    'Comondú': {municipality: '001', state: 'BCS'},
    'Calkiní': {municipality: '001', state: 'CAM'},
    'Abasolo': {municipality: '001', state: 'COA'},
    'Armería': {municipality: '001', state: 'COL'},
    'Ahumada': {municipality: '001', state: 'CHH'},
    'Acacoyagua': {municipality: '001', state: 'CHP'},
    'Canatlán': {municipality: '001', state: 'DUR'},
    'Acapulco de Juárez': {municipality: '001', state: 'GRO'},
    //'Abasolo': {municipality: '001', state: 'GUA'},
    'Acatlán': {municipality: '001', state: 'HID'},
    'Acatic': {municipality: '001', state: 'JAL'},
    'Acambay de Ruíz Castañeda': {municipality: '001', state: 'MEX'},
    'Acuitzio': {municipality: '001', state: 'MIC'},
    'Amacuzac': {municipality: '001', state: 'MOR'},
    'Acaponeta': {municipality: '001', state: 'NAY'},
    //'Abasolo': {municipality: '001', state: 'NLE'},
    'Abejones': {municipality: '001', state: 'OAX'},
    'Acajete': {municipality: '001', state: 'PUE'},
    'Amealco de Bonfil': {municipality: '001', state: 'QUE'},
    'Cozumel': {municipality: '001', state: 'ROO'},
    'Ahome': {municipality: '001', state: 'SIN'},
    'Ahualulco': {municipality: '001', state: 'SLP'},
    'Aconchi': {municipality: '001', state: 'SON'},
    'Balancán': {municipality: '001', state: 'TAB'},
    //'Abasolo': {municipality: '001', state: 'TAM'},
    'Amaxac de Guerrero': {municipality: '001', state: 'TLA'},
    //'Acajete': {municipality: '001', state: 'VER'},
    'Abalá': {municipality: '001', state: 'YUC'},
    'Apozol': {municipality: '001', state: 'ZAC'},
    'Asientos': {municipality: '002', state: 'AGU'},
    'Mexicali': {municipality: '002', state: 'BCN'},
    'Mulegé': {municipality: '002', state: 'BCS'},
    'Campeche': {municipality: '002', state: 'CAM'},
    'Acuña': {municipality: '002', state: 'COA'},
    'Colima': {municipality: '002', state: 'COL'},
    'Aldama': {municipality: '002', state: 'CHH'},
    'Acala': {municipality: '002', state: 'CHP'},
    'Azcapotzalco': {municipality: '002', state: 'DIF'},
    'Canelas': {municipality: '002', state: 'DUR'},
    'Ahuacuotzingo': {municipality: '002', state: 'GRO'},
    'Acámbaro': {municipality: '002', state: 'GUA'},
    'Acaxochitlán': {municipality: '002', state: 'HID'},
    'Acatlán de Juárez': {municipality: '002', state: 'JAL'},
    'Acolman': {municipality: '002', state: 'MEX'},
    'Aguililla': {municipality: '002', state: 'MIC'},
    'Atlatlahucan': {municipality: '002', state: 'MOR'},
    'Ahuacatlán': {municipality: '002', state: 'NAY'},
    'Agualeguas': {municipality: '002', state: 'NLE'},
    'Acatlán de Pérez Figueroa': {municipality: '002', state: 'OAX'},
    'Acateno': {municipality: '002', state: 'PUE'},
    'Pinal de Amoles': {municipality: '002', state: 'QUE'},
    'Felipe Carrillo Puerto': {municipality: '002', state: 'ROO'},
    'Angostura': {municipality: '002', state: 'SIN'},
    'Alaquines': {municipality: '002', state: 'SLP'},
    'Agua Prieta': {municipality: '002', state: 'SON'},
    'Cárdenas': {municipality: '002', state: 'TAB'},
    //'Aldama': {municipality: '002', state: 'TAM'},
    'Apetatitlán de Antonio Carvajal': {municipality: '002', state: 'TLA'},
    //'Acatlán': {municipality: '002', state: 'VER'},
    'Acanceh': {municipality: '002', state: 'YUC'},
    'Apulco': {municipality: '002', state: 'ZAC'},
    'Calvillo': {municipality: '003', state: 'AGU'},
    'Tecate': {municipality: '003', state: 'BCN'},
    'La Paz': {municipality: '003', state: 'BCS'},
    'Carmen': {municipality: '003', state: 'CAM'},
    'Allende': {municipality: '003', state: 'COA'},
    'Comala': {municipality: '003', state: 'COL'},
    //'Allende': {municipality: '003', state: 'CHH'},
    'Acapetahua': {municipality: '003', state: 'CHP'},
    'Coyoacán': {municipality: '003', state: 'DIF'},
    'Coneto de Comonfort': {municipality: '003', state: 'DUR'},
    'Ajuchitlán del Progreso': {municipality: '003', state: 'GRO'},
    'San Miguel de Allende': {municipality: '003', state: 'GUA'},
    'Actopan': {municipality: '003', state: 'HID'},
    'Ahualulco de Mercado': {municipality: '003', state: 'JAL'},
    'Aculco': {municipality: '003', state: 'MEX'},
    'Álvaro Obregón': {municipality: '003', state: 'MIC'},
    'Axochiapan': {municipality: '003', state: 'MOR'},
    'Amatlán de Cañas': {municipality: '003', state: 'NAY'},
    'Los Aldamas': {municipality: '003', state: 'NLE'},
    'Asunción Cacalotepec': {municipality: '003', state: 'OAX'},
    //'Acatlán': {municipality: '003', state: 'PUE'},
    'Arroyo Seco': {municipality: '003', state: 'QUE'},
    'Isla Mujeres': {municipality: '003', state: 'ROO'},
    'Badiraguato': {municipality: '003', state: 'SIN'},
    'Aquismón': {municipality: '003', state: 'SLP'},
    'Alamos': {municipality: '003', state: 'SON'},
    'Centla': {municipality: '003', state: 'TAB'},
    'Altamira': {municipality: '003', state: 'TAM'},
    'Atlangatepec': {municipality: '003', state: 'TLA'},
    'Acayucan': {municipality: '003', state: 'VER'},
    'Akil': {municipality: '003', state: 'YUC'},
    'Atolinga': {municipality: '003', state: 'ZAC'},
    'Cosío': {municipality: '004', state: 'AGU'},
    'Tijuana': {municipality: '004', state: 'BCN'},
    'Champotón': {municipality: '004', state: 'CAM'},
    'Arteaga': {municipality: '004', state: 'COA'},
    'Coquimatlán': {municipality: '004', state: 'COL'},
    'Aquiles Serdán': {municipality: '004', state: 'CHH'},
    'Altamirano': {municipality: '004', state: 'CHP'},
    'Cuajimalpa de Morelos': {municipality: '004', state: 'DIF'},
    'Cuencamé': {municipality: '004', state: 'DUR'},
    'Alcozauca de Guerrero': {municipality: '004', state: 'GRO'},
    'Apaseo el Alto': {municipality: '004', state: 'GUA'},
    'Agua Blanca de Iturbide': {municipality: '004', state: 'HID'},
    'Amacueca': {municipality: '004', state: 'JAL'},
    'Almoloya de Alquisiras': {municipality: '004', state: 'MEX'},
    'Angamacutiro': {municipality: '004', state: 'MIC'},
    'Ayala': {municipality: '004', state: 'MOR'},
    'Compostela': {municipality: '004', state: 'NAY'},
    //'Allende': {municipality: '004', state: 'NLE'},
    'Asunción Cuyotepeji': {municipality: '004', state: 'OAX'},
    'Acatzingo': {municipality: '004', state: 'PUE'},
    'Cadereyta de Montes': {municipality: '004', state: 'QUE'},
    'Othón P. Blanco': {municipality: '004', state: 'ROO'},
    'Concordia': {municipality: '004', state: 'SIN'},
    'Armadillo de los Infante': {municipality: '004', state: 'SLP'},
    'Altar': {municipality: '004', state: 'SON'},
    'Centro': {municipality: '004', state: 'TAB'},
    'Antiguo Morelos': {municipality: '004', state: 'TAM'},
    'Atltzayanca': {municipality: '004', state: 'TLA'},
    //'Actopan': {municipality: '004', state: 'VER'},
    'Baca': {municipality: '004', state: 'YUC'},
    'Benito Juárez': {municipality: '004', state: 'ZAC'},
    'Jesús María': {municipality: '005', state: 'AGU'},
    'Playas de Rosarito': {municipality: '005', state: 'BCN'},
    'Hecelchakán': {municipality: '005', state: 'CAM'},
    'Candela': {municipality: '005', state: 'COA'},
    'Cuauhtémoc': {municipality: '005', state: 'COL'},
    'Ascensión': {municipality: '005', state: 'CHH'},
    'Amatán': {municipality: '005', state: 'CHP'},
    'Gustavo A. Madero': {municipality: '005', state: 'DIF'},
    'Durango': {municipality: '005', state: 'DUR'},
    'Alpoyeca': {municipality: '005', state: 'GRO'},
    'Apaseo el Grande': {municipality: '005', state: 'GUA'},
    'Ajacuba': {municipality: '005', state: 'HID'},
    'Amatitán': {municipality: '005', state: 'JAL'},
    'Almoloya de Juárez': {municipality: '005', state: 'MEX'},
    'Angangueo': {municipality: '005', state: 'MIC'},
    'Coatlán del Río': {municipality: '005', state: 'MOR'},
    'Huajicori': {municipality: '005', state: 'NAY'},
    'Anáhuac': {municipality: '005', state: 'NLE'},
    'Asunción Ixtaltepec': {municipality: '005', state: 'OAX'},
    'Acteopan': {municipality: '005', state: 'PUE'},
    'Colón': {municipality: '005', state: 'QUE'},
    //'Benito Juárez': {municipality: '005', state: 'ROO'},
    'Cosalá': {municipality: '005', state: 'SIN'},
    //'Cárdenas': {municipality: '005', state: 'SLP'},
    'Arivechi': {municipality: '005', state: 'SON'},
    'Comalcalco': {municipality: '005', state: 'TAB'},
    'Burgos': {municipality: '005', state: 'TAM'},
    'Apizaco': {municipality: '005', state: 'TLA'},
    'Acula': {municipality: '005', state: 'VER'},
    'Bokobá': {municipality: '005', state: 'YUC'},
    'Calera': {municipality: '005', state: 'ZAC'},
    'Pabellón de Arteaga': {municipality: '006', state: 'AGU'},
    'Hopelchén': {municipality: '006', state: 'CAM'},
    'Castaños': {municipality: '006', state: 'COA'},
    'Ixtlahuacán': {municipality: '006', state: 'COL'},
    'Bachíniva': {municipality: '006', state: 'CHH'},
    'Amatenango de la Frontera': {municipality: '006', state: 'CHP'},
    'Iztacalco': {municipality: '006', state: 'DIF'},
    'General Simón Bolívar': {municipality: '006', state: 'DUR'},
    'Apaxtla': {municipality: '006', state: 'GRO'},
    'Atarjea': {municipality: '006', state: 'GUA'},
    'Alfajayucan': {municipality: '006', state: 'HID'},
    'Ameca': {municipality: '006', state: 'JAL'},
    'Almoloya del Río': {municipality: '006', state: 'MEX'},
    'Apatzingán': {municipality: '006', state: 'MIC'},
    'Cuautla': {municipality: '006', state: 'MOR'},
    'Ixtlán del Río': {municipality: '006', state: 'NAY'},
    'Apodaca': {municipality: '006', state: 'NLE'},
    'Asunción Nochixtlán': {municipality: '006', state: 'OAX'},
    //'Ahuacatlán': {municipality: '006', state: 'PUE'},
    'Corregidora': {municipality: '006', state: 'QUE'},
    'José María Morelos': {municipality: '006', state: 'ROO'},
    'Culiacán': {municipality: '006', state: 'SIN'},
    'Catorce': {municipality: '006', state: 'SLP'},
    'Arizpe': {municipality: '006', state: 'SON'},
    'Cunduacán': {municipality: '006', state: 'TAB'},
    'Bustamante': {municipality: '006', state: 'TAM'},
    'Calpulalpan': {municipality: '006', state: 'TLA'},
    'Acultzingo': {municipality: '006', state: 'VER'},
    'Buctzotz': {municipality: '006', state: 'YUC'},
    'Cañitas de Felipe Pescador': {municipality: '006', state: 'ZAC'},
    'Rincón de Romos': {municipality: '007', state: 'AGU'},
    'Palizada': {municipality: '007', state: 'CAM'},
    'Cuatro Ciénegas': {municipality: '007', state: 'COA'},
    'Manzanillo': {municipality: '007', state: 'COL'},
    'Balleza': {municipality: '007', state: 'CHH'},
    'Amatenango del Valle': {municipality: '007', state: 'CHP'},
    'Iztapalapa': {municipality: '007', state: 'DIF'},
    'Gómez Palacio': {municipality: '007', state: 'DUR'},
    'Arcelia': {municipality: '007', state: 'GRO'},
    'Celaya': {municipality: '007', state: 'GUA'},
    'Almoloya': {municipality: '007', state: 'HID'},
    'San Juanito de Escobedo': {municipality: '007', state: 'JAL'},
    'Amanalco': {municipality: '007', state: 'MEX'},
    'Aporo': {municipality: '007', state: 'MIC'},
    'Cuernavaca': {municipality: '007', state: 'MOR'},
    'Jala': {municipality: '007', state: 'NAY'},
    'Aramberri': {municipality: '007', state: 'NLE'},
    'Asunción Ocotlán': {municipality: '007', state: 'OAX'},
    'Ahuatlán': {municipality: '007', state: 'PUE'},
    'Ezequiel Montes': {municipality: '007', state: 'QUE'},
    'Lázaro Cárdenas': {municipality: '007', state: 'ROO'},
    'Choix': {municipality: '007', state: 'SIN'},
    'Cedral': {municipality: '007', state: 'SLP'},
    'Atil': {municipality: '007', state: 'SON'},
    'Emiliano Zapata': {municipality: '007', state: 'TAB'},
    'Camargo': {municipality: '007', state: 'TAM'},
    'El Carmen Tequexquitla': {municipality: '007', state: 'TLA'},
    'Camarón de Tejeda': {municipality: '007', state: 'VER'},
    'Cacalchén': {municipality: '007', state: 'YUC'},
    'Concepción del Oro': {municipality: '007', state: 'ZAC'},
    'San José de Gracia': {municipality: '008', state: 'AGU'},
    'Los Cabos': {municipality: '008', state: 'BCS'},
    'Tenabo': {municipality: '008', state: 'CAM'},
    'Escobedo': {municipality: '008', state: 'COA'},
    'Minatitlán': {municipality: '008', state: 'COL'},
    'Batopilas': {municipality: '008', state: 'CHH'},
    'Angel Albino Corzo': {municipality: '008', state: 'CHP'},
    'La Magdalena Contreras': {municipality: '008', state: 'DIF'},
    'Guadalupe Victoria': {municipality: '008', state: 'DUR'},
    'Atenango del Río': {municipality: '008', state: 'GRO'},
    'Manuel Doblado': {municipality: '008', state: 'GUA'},
    'Apan': {municipality: '008', state: 'HID'},
    'Arandas': {municipality: '008', state: 'JAL'},
    'Amatepec': {municipality: '008', state: 'MEX'},
    'Aquila': {municipality: '008', state: 'MIC'},
    //'Emiliano Zapata': {municipality: '008', state: 'MOR'},
    'Xalisco': {municipality: '008', state: 'NAY'},
    //'Bustamante': {municipality: '008', state: 'NLE'},
    'Asunción Tlacolulita': {municipality: '008', state: 'OAX'},
    'Ahuazotepec': {municipality: '008', state: 'PUE'},
    'Huimilpan': {municipality: '008', state: 'QUE'},
    'Solidaridad': {municipality: '008', state: 'ROO'},
    'Elota': {municipality: '008', state: 'SIN'},
    'Cerritos': {municipality: '008', state: 'SLP'},
    'Bacadéhuachi': {municipality: '008', state: 'SON'},
    'Huimanguillo': {municipality: '008', state: 'TAB'},
    'Casas': {municipality: '008', state: 'TAM'},
    'Cuapiaxtla': {municipality: '008', state: 'TLA'},
    'Alpatláhuac': {municipality: '008', state: 'VER'},
    'Calotmul': {municipality: '008', state: 'YUC'},
    //'Cuauhtémoc': {municipality: '008', state: 'ZAC'},
    'Tepezalá': {municipality: '009', state: 'AGU'},
    'Loreto': {municipality: '009', state: 'BCS'},
    'Escárcega': {municipality: '009', state: 'CAM'},
    'Francisco I. Madero': {municipality: '009', state: 'COA'},
    'Tecomán': {municipality: '009', state: 'COL'},
    'Bocoyna': {municipality: '009', state: 'CHH'},
    'Arriaga': {municipality: '009', state: 'CHP'},
    'Milpa Alta': {municipality: '009', state: 'DIF'},
    'Guanaceví': {municipality: '009', state: 'DUR'},
    'Atlamajalcingo del Monte': {municipality: '009', state: 'GRO'},
    'Comonfort': {municipality: '009', state: 'GUA'},
    'El Arenal': {municipality: '009', state: 'HID'},
    //'El Arenal': {municipality: '009', state: 'JAL'},
    'Amecameca': {municipality: '009', state: 'MEX'},
    'Ario': {municipality: '009', state: 'MIC'},
    'Huitzilac': {municipality: '009', state: 'MOR'},
    'Del Nayar': {municipality: '009', state: 'NAY'},
    'Cadereyta Jiménez': {municipality: '009', state: 'NLE'},
    'Ayotzintepec': {municipality: '009', state: 'OAX'},
    'Ahuehuetitla': {municipality: '009', state: 'PUE'},
    'Jalpan de Serra': {municipality: '009', state: 'QUE'},
    'Tulum': {municipality: '009', state: 'ROO'},
    'Escuinapa': {municipality: '009', state: 'SIN'},
    'Cerro de San Pedro': {municipality: '009', state: 'SLP'},
    'Bacanora': {municipality: '009', state: 'SON'},
    'Jalapa': {municipality: '009', state: 'TAB'},
    'Ciudad Madero': {municipality: '009', state: 'TAM'},
    'Cuaxomulco': {municipality: '009', state: 'TLA'},
    'Alto Lucero de Gutiérrez Barrios': {municipality: '009', state: 'VER'},
    'Cansahcab': {municipality: '009', state: 'YUC'},
    'Chalchihuites': {municipality: '009', state: 'ZAC'},
    'El Llano': {municipality: '010', state: 'AGU'},
    'Calakmul': {municipality: '010', state: 'CAM'},
    'Frontera': {municipality: '010', state: 'COA'},
    'Villa de Álvarez': {municipality: '010', state: 'COL'},
    'Buenaventura': {municipality: '010', state: 'CHH'},
    'Bejucal de Ocampo': {municipality: '010', state: 'CHP'},
    //'Álvaro Obregón': {municipality: '010', state: 'DIF'},
    'Hidalgo': {municipality: '010', state: 'DUR'},
    'Atlixtac': {municipality: '010', state: 'GRO'},
    'Coroneo': {municipality: '010', state: 'GUA'},
    'Atitalaquia': {municipality: '010', state: 'HID'},
    'Atemajac de Brizuela': {municipality: '010', state: 'JAL'},
    'Apaxco': {municipality: '010', state: 'MEX'},
    //'Arteaga': {municipality: '010', state: 'MIC'},
    'Jantetelco': {municipality: '010', state: 'MOR'},
    'Rosamorada': {municipality: '010', state: 'NAY'},
    'El Carmen': {municipality: '010', state: 'NLE'},
    'El Barrio de la Soledad': {municipality: '010', state: 'OAX'},
    'Ajalpan': {municipality: '010', state: 'PUE'},
    'Landa de Matamoros': {municipality: '010', state: 'QUE'},
    'Bacalar': {municipality: '010', state: 'ROO'},
    'El Fuerte': {municipality: '010', state: 'SIN'},
    'Ciudad del Maíz': {municipality: '010', state: 'SLP'},
    'Bacerac': {municipality: '010', state: 'SON'},
    'Jalpa de Méndez': {municipality: '010', state: 'TAB'},
    'Cruillas': {municipality: '010', state: 'TAM'},
    'Chiautempan': {municipality: '010', state: 'TLA'},
    'Altotonga': {municipality: '010', state: 'VER'},
    'Cantamayec': {municipality: '010', state: 'YUC'},
    'Fresnillo': {municipality: '010', state: 'ZAC'},
    'San Francisco de los Romo': {municipality: '011', state: 'AGU'},
    'Candelaria': {municipality: '011', state: 'CAM'},
    'General Cepeda': {municipality: '011', state: 'COA'},
    //'Camargo': {municipality: '011', state: 'CHH'},
    'Bella Vista': {municipality: '011', state: 'CHP'},
    'Tláhuac': {municipality: '011', state: 'DIF'},
    'Indé': {municipality: '011', state: 'DUR'},
    'Atoyac de Álvarez': {municipality: '011', state: 'GRO'},
    'Cortazar': {municipality: '011', state: 'GUA'},
    'Atlapexco': {municipality: '011', state: 'HID'},
    'Atengo': {municipality: '011', state: 'JAL'},
    'Atenco': {municipality: '011', state: 'MEX'},
    'Briseñas': {municipality: '011', state: 'MIC'},
    'Jiutepec': {municipality: '011', state: 'MOR'},
    'Ruíz': {municipality: '011', state: 'NAY'},
    'Cerralvo': {municipality: '011', state: 'NLE'},
    'Calihualá': {municipality: '011', state: 'OAX'},
    'Albino Zertuche': {municipality: '011', state: 'PUE'},
    'El Marqués': {municipality: '011', state: 'QUE'},
    'Puerto Morelos': {municipality: '011', state: 'ROO'},
    'Guasave': {municipality: '011', state: 'SIN'},
    'Ciudad Fernández': {municipality: '011', state: 'SLP'},
    'Bacoachi': {municipality: '011', state: 'SON'},
    'Jonuta': {municipality: '011', state: 'TAB'},
    'Gómez Farías': {municipality: '011', state: 'TAM'},
    'Muñoz de Domingo Arenas': {municipality: '011', state: 'TLA'},
    'Alvarado': {municipality: '011', state: 'VER'},
    'Celestún': {municipality: '011', state: 'YUC'},
    'Trinidad García de la Cadena': {municipality: '011', state: 'ZAC'},
    'Guerrero': {municipality: '012', state: 'COA'},
    'Carichí': {municipality: '012', state: 'CHH'},
    'Berriozábal': {municipality: '012', state: 'CHP'},
    'Tlalpan': {municipality: '012', state: 'DIF'},
    'Lerdo': {municipality: '012', state: 'DUR'},
    'Ayutla de los Libres': {municipality: '012', state: 'GRO'},
    'Cuerámaro': {municipality: '012', state: 'GUA'},
    'Atotonilco el Grande': {municipality: '012', state: 'HID'},
    'Atenguillo': {municipality: '012', state: 'JAL'},
    'Atizapán': {municipality: '012', state: 'MEX'},
    'Buenavista': {municipality: '012', state: 'MIC'},
    'Jojutla': {municipality: '012', state: 'MOR'},
    'San Blas': {municipality: '012', state: 'NAY'},
    'Ciénega de Flores': {municipality: '012', state: 'NLE'},
    'Candelaria Loxicha': {municipality: '012', state: 'OAX'},
    'Aljojuca': {municipality: '012', state: 'PUE'},
    'Pedro Escobedo': {municipality: '012', state: 'QUE'},
    'Mazatlán': {municipality: '012', state: 'SIN'},
    'Tancanhuitz': {municipality: '012', state: 'SLP'},
    'Bácum': {municipality: '012', state: 'SON'},
    'Macuspana': {municipality: '012', state: 'TAB'},
    'González': {municipality: '012', state: 'TAM'},
    'Españita': {municipality: '012', state: 'TLA'},
    'Amatitlán': {municipality: '012', state: 'VER'},
    'Cenotillo': {municipality: '012', state: 'YUC'},
    'Genaro Codina': {municipality: '012', state: 'ZAC'},
    //'Hidalgo': {municipality: '013', state: 'COA'},
    'Casas Grandes': {municipality: '013', state: 'CHH'},
    'Bochil': {municipality: '013', state: 'CHP'},
    'Xochimilco': {municipality: '013', state: 'DIF'},
    'Mapimí': {municipality: '013', state: 'DUR'},
    'Azoyú': {municipality: '013', state: 'GRO'},
    'Doctor Mora': {municipality: '013', state: 'GUA'},
    'Atotonilco de Tula': {municipality: '013', state: 'HID'},
    'Atotonilco el Alto': {municipality: '013', state: 'JAL'},
    'Atizapán de Zaragoza': {municipality: '013', state: 'MEX'},
    'Carácuaro': {municipality: '013', state: 'MIC'},
    'Jonacatepec': {municipality: '013', state: 'MOR'},
    'San Pedro Lagunillas': {municipality: '013', state: 'NAY'},
    'China': {municipality: '013', state: 'NLE'},
    'Ciénega de Zimatlán': {municipality: '013', state: 'OAX'},
    'Altepexi': {municipality: '013', state: 'PUE'},
    'Peñamiller': {municipality: '013', state: 'QUE'},
    'Mocorito': {municipality: '013', state: 'SIN'},
    'Ciudad Valles': {municipality: '013', state: 'SLP'},
    'Banámichi': {municipality: '013', state: 'SON'},
    'Nacajuca': {municipality: '013', state: 'TAB'},
    'Güémez': {municipality: '013', state: 'TAM'},
    'Huamantla': {municipality: '013', state: 'TLA'},
    'Naranjos Amatlán': {municipality: '013', state: 'VER'},
    'Conkal': {municipality: '013', state: 'YUC'},
    'General Enrique Estrada': {municipality: '013', state: 'ZAC'},
    'Jiménez': {municipality: '014', state: 'COA'},
    'Coronado': {municipality: '014', state: 'CHH'},
    'El Bosque': {municipality: '014', state: 'CHP'},
    //'Benito Juárez': {municipality: '014', state: 'DIF'},
    'Mezquital': {municipality: '014', state: 'DUR'},
    //'Benito Juárez': {municipality: '014', state: 'GRO'},
    'Dolores Hidalgo Cuna de la Independencia Nacional': {municipality: '014', state: 'GUA'},
    'Calnali': {municipality: '014', state: 'HID'},
    'Atoyac': {municipality: '014', state: 'JAL'},
    'Atlacomulco': {municipality: '014', state: 'MEX'},
    'Coahuayana': {municipality: '014', state: 'MIC'},
    'Mazatepec': {municipality: '014', state: 'MOR'},
    'Santa María del Oro': {municipality: '014', state: 'NAY'},
    'Doctor Arroyo': {municipality: '014', state: 'NLE'},
    'Ciudad Ixtepec': {municipality: '014', state: 'OAX'},
    'Amixtlán': {municipality: '014', state: 'PUE'},
    'Querétaro': {municipality: '014', state: 'QUE'},
    'Rosario': {municipality: '014', state: 'SIN'},
    'Coxcatlán': {municipality: '014', state: 'SLP'},
    'Baviácora': {municipality: '014', state: 'SON'},
    'Paraíso': {municipality: '014', state: 'TAB'},
    //'Guerrero': {municipality: '014', state: 'TAM'},
    'Hueyotlipan': {municipality: '014', state: 'TLA'},
    'Amatlán de los Reyes': {municipality: '014', state: 'VER'},
    'Cuncunul': {municipality: '014', state: 'YUC'},
    'General Francisco R. Murguía': {municipality: '014', state: 'ZAC'},
    'Juárez': {municipality: '015', state: 'COA'},
    'Coyame del Sotol': {municipality: '015', state: 'CHH'},
    'Cacahoatán': {municipality: '015', state: 'CHP'},
    //'Cuauhtémoc': {municipality: '015', state: 'DIF'},
    'Nazas': {municipality: '015', state: 'DUR'},
    'Buenavista de Cuéllar': {municipality: '015', state: 'GRO'},
    'Guanajuato': {municipality: '015', state: 'GUA'},
    'Cardonal': {municipality: '015', state: 'HID'},
    'Autlán de Navarro': {municipality: '015', state: 'JAL'},
    'Atlautla': {municipality: '015', state: 'MEX'},
    'Coalcomán de Vázquez Pallares': {municipality: '015', state: 'MIC'},
    'Miacatlán': {municipality: '015', state: 'MOR'},
    'Santiago Ixcuintla': {municipality: '015', state: 'NAY'},
    'Doctor Coss': {municipality: '015', state: 'NLE'},
    'Coatecas Altas': {municipality: '015', state: 'OAX'},
    'Amozoc': {municipality: '015', state: 'PUE'},
    'San Joaquín': {municipality: '015', state: 'QUE'},
    'Salvador Alvarado': {municipality: '015', state: 'SIN'},
    'Charcas': {municipality: '015', state: 'SLP'},
    'Bavispe': {municipality: '015', state: 'SON'},
    'Tacotalpa': {municipality: '015', state: 'TAB'},
    'Gustavo Díaz Ordaz': {municipality: '015', state: 'TAM'},
    'Ixtacuixtla de Mariano Matamoros': {municipality: '015', state: 'TLA'},
    'Angel R. Cabada': {municipality: '015', state: 'VER'},
    'Cuzamá': {municipality: '015', state: 'YUC'},
    'El Plateado de Joaquín Amaro': {municipality: '015', state: 'ZAC'},
    'Lamadrid': {municipality: '016', state: 'COA'},
    'La Cruz': {municipality: '016', state: 'CHH'},
    'Catazajá': {municipality: '016', state: 'CHP'},
    'Miguel Hidalgo': {municipality: '016', state: 'DIF'},
    'Nombre de Dios': {municipality: '016', state: 'DUR'},
    'Coahuayutla de José María Izazaga': {municipality: '016', state: 'GRO'},
    'Huanímaro': {municipality: '016', state: 'GUA'},
    'Cuautepec de Hinojosa': {municipality: '016', state: 'HID'},
    'Ayotlán': {municipality: '016', state: 'JAL'},
    'Axapusco': {municipality: '016', state: 'MEX'},
    'Coeneo': {municipality: '016', state: 'MIC'},
    'Ocuituco': {municipality: '016', state: 'MOR'},
    'Tecuala': {municipality: '016', state: 'NAY'},
    'Doctor González': {municipality: '016', state: 'NLE'},
    'Coicoyán de las Flores': {municipality: '016', state: 'OAX'},
    'Aquixtla': {municipality: '016', state: 'PUE'},
    'San Juan del Río': {municipality: '016', state: 'QUE'},
    'San Ignacio': {municipality: '016', state: 'SIN'},
    'Ebano': {municipality: '016', state: 'SLP'},
    'Benjamín Hill': {municipality: '016', state: 'SON'},
    'Teapa': {municipality: '016', state: 'TAB'},
    //'Hidalgo': {municipality: '016', state: 'TAM'},
    'Ixtenco': {municipality: '016', state: 'TLA'},
    'La Antigua': {municipality: '016', state: 'VER'},
    'Chacsinkín': {municipality: '016', state: 'YUC'},
    'General Pánfilo Natera': {municipality: '016', state: 'ZAC'},
    'Matamoros': {municipality: '017', state: 'COA'},
    //'Cuauhtémoc': {municipality: '017', state: 'CHH'},
    'Cintalapa': {municipality: '017', state: 'CHP'},
    'Venustiano Carranza': {municipality: '017', state: 'DIF'},
    'Ocampo': {municipality: '017', state: 'DUR'},
    'Cocula': {municipality: '017', state: 'GRO'},
    'Irapuato': {municipality: '017', state: 'GUA'},
    'Chapantongo': {municipality: '017', state: 'HID'},
    'Ayutla': {municipality: '017', state: 'JAL'},
    'Ayapango': {municipality: '017', state: 'MEX'},
    'Contepec': {municipality: '017', state: 'MIC'},
    'Puente de Ixtla': {municipality: '017', state: 'MOR'},
    'Tepic': {municipality: '017', state: 'NAY'},
    'Galeana': {municipality: '017', state: 'NLE'},
    'La Compañía': {municipality: '017', state: 'OAX'},
    'Atempan': {municipality: '017', state: 'PUE'},
    'Tequisquiapan': {municipality: '017', state: 'QUE'},
    'Sinaloa': {municipality: '017', state: 'SIN'},
    'Guadalcázar': {municipality: '017', state: 'SLP'},
    'Caborca': {municipality: '017', state: 'SON'},
    'Tenosique': {municipality: '017', state: 'TAB'},
    'Jaumave': {municipality: '017', state: 'TAM'},
    'Mazatecochco de José María Morelos': {municipality: '017', state: 'TLA'},
    'Apazapan': {municipality: '017', state: 'VER'},
    'Chankom': {municipality: '017', state: 'YUC'},
    'Guadalupe': {municipality: '017', state: 'ZAC'},
    'Monclova': {municipality: '018', state: 'COA'},
    'Cusihuiriachi': {municipality: '018', state: 'CHH'},
    'Coapilla': {municipality: '018', state: 'CHP'},
    'El Oro': {municipality: '018', state: 'DUR'},
    'Copala': {municipality: '018', state: 'GRO'},
    'Jaral del Progreso': {municipality: '018', state: 'GUA'},
    'Chapulhuacán': {municipality: '018', state: 'HID'},
    'La Barca': {municipality: '018', state: 'JAL'},
    'Calimaya': {municipality: '018', state: 'MEX'},
    'Copándaro': {municipality: '018', state: 'MIC'},
    'Temixco': {municipality: '018', state: 'MOR'},
    'Tuxpan': {municipality: '018', state: 'NAY'},
    'García': {municipality: '018', state: 'NLE'},
    'Concepción Buenavista': {municipality: '018', state: 'OAX'},
    'Atexcal': {municipality: '018', state: 'PUE'},
    'Tolimán': {municipality: '018', state: 'QUE'},
    'Navolato': {municipality: '018', state: 'SIN'},
    'Huehuetlán': {municipality: '018', state: 'SLP'},
    'Cajeme': {municipality: '018', state: 'SON'},
    //'Jiménez': {municipality: '018', state: 'TAM'},
    'Contla de Juan Cuamatzi': {municipality: '018', state: 'TLA'},
    //'Aquila': {municipality: '018', state: 'VER'},
    'Chapab': {municipality: '018', state: 'YUC'},
    'Huanusco': {municipality: '018', state: 'ZAC'},
    'Morelos': {municipality: '019', state: 'COA'},
    'Chihuahua': {municipality: '019', state: 'CHH'},
    'Comitán de Domínguez': {municipality: '019', state: 'CHP'},
    'Otáez': {municipality: '019', state: 'DUR'},
    'Copalillo': {municipality: '019', state: 'GRO'},
    'Jerécuaro': {municipality: '019', state: 'GUA'},
    'Chilcuautla': {municipality: '019', state: 'HID'},
    'Bolaños': {municipality: '019', state: 'JAL'},
    'Capulhuac': {municipality: '019', state: 'MEX'},
    'Cotija': {municipality: '019', state: 'MIC'},
    'Tepalcingo': {municipality: '019', state: 'MOR'},
    'La Yesca': {municipality: '019', state: 'NAY'},
    'San Pedro Garza García': {municipality: '019', state: 'NLE'},
    'Concepción Pápalo': {municipality: '019', state: 'OAX'},
    'Atlixco': {municipality: '019', state: 'PUE'},
    'Lagunillas': {municipality: '019', state: 'SLP'},
    'Cananea': {municipality: '019', state: 'SON'},
    'Llera': {municipality: '019', state: 'TAM'},
    'Tepetitla de Lardizábal': {municipality: '019', state: 'TLA'},
    'Astacinga': {municipality: '019', state: 'VER'},
    'Chemax': {municipality: '019', state: 'YUC'},
    'Jalpa': {municipality: '019', state: 'ZAC'},
    'Múzquiz': {municipality: '020', state: 'COA'},
    'Chínipas': {municipality: '020', state: 'CHH'},
    'La Concordia': {municipality: '020', state: 'CHP'},
    'Pánuco de Coronado': {municipality: '020', state: 'DUR'},
    'Copanatoyac': {municipality: '020', state: 'GRO'},
    'León': {municipality: '020', state: 'GUA'},
    'Eloxochitlán': {municipality: '020', state: 'HID'},
    'Cabo Corrientes': {municipality: '020', state: 'JAL'},
    'Coacalco de Berriozábal': {municipality: '020', state: 'MEX'},
    'Cuitzeo': {municipality: '020', state: 'MIC'},
    'Tepoztlán': {municipality: '020', state: 'MOR'},
    'Bahía de Banderas': {municipality: '020', state: 'NAY'},
    'General Bravo': {municipality: '020', state: 'NLE'},
    'Constancia del Rosario': {municipality: '020', state: 'OAX'},
    'Atoyatempan': {municipality: '020', state: 'PUE'},
    'Matehuala': {municipality: '020', state: 'SLP'},
    'Carbó': {municipality: '020', state: 'SON'},
    'Mainero': {municipality: '020', state: 'TAM'},
    'Sanctórum de Lázaro Cárdenas': {municipality: '020', state: 'TLA'},
    'Atlahuilco': {municipality: '020', state: 'VER'},
    'Chicxulub Pueblo': {municipality: '020', state: 'YUC'},
    'Jerez': {municipality: '020', state: 'ZAC'},
    'Nadadores': {municipality: '021', state: 'COA'},
    'Delicias': {municipality: '021', state: 'CHH'},
    'Copainalá': {municipality: '021', state: 'CHP'},
    'Peñón Blanco': {municipality: '021', state: 'DUR'},
    'Coyuca de Benítez': {municipality: '021', state: 'GRO'},
    'Moroleón': {municipality: '021', state: 'GUA'},
    //'Emiliano Zapata': {municipality: '021', state: 'HID'},
    'Casimiro Castillo': {municipality: '021', state: 'JAL'},
    'Coatepec Harinas': {municipality: '021', state: 'MEX'},
    'Charapan': {municipality: '021', state: 'MIC'},
    'Tetecala': {municipality: '021', state: 'MOR'},
    'General Escobedo': {municipality: '021', state: 'NLE'},
    'Cosolapa': {municipality: '021', state: 'OAX'},
    'Atzala': {municipality: '021', state: 'PUE'},
    'Mexquitic de Carmona': {municipality: '021', state: 'SLP'},
    'La Colorada': {municipality: '021', state: 'SON'},
    'El Mante': {municipality: '021', state: 'TAM'},
    'Nanacamilpa de Mariano Arista': {municipality: '021', state: 'TLA'},
    //'Atoyac': {municipality: '021', state: 'VER'},
    'Chichimilá': {municipality: '021', state: 'YUC'},
    'Jiménez del Teul': {municipality: '021', state: 'ZAC'},
    'Nava': {municipality: '022', state: 'COA'},
    'Dr. Belisario Domínguez': {municipality: '022', state: 'CHH'},
    'Chalchihuitán': {municipality: '022', state: 'CHP'},
    'Poanas': {municipality: '022', state: 'DUR'},
    'Coyuca de Catalán': {municipality: '022', state: 'GRO'},
    //'Ocampo': {municipality: '022', state: 'GUA'},
    'Epazoyucan': {municipality: '022', state: 'HID'},
    'Cihuatlán': {municipality: '022', state: 'JAL'},
    'Cocotitlán': {municipality: '022', state: 'MEX'},
    'Charo': {municipality: '022', state: 'MIC'},
    'Tetela del Volcán': {municipality: '022', state: 'MOR'},
    'General Terán': {municipality: '022', state: 'NLE'},
    'Cosoltepec': {municipality: '022', state: 'OAX'},
    'Atzitzihuacán': {municipality: '022', state: 'PUE'},
    'Moctezuma': {municipality: '022', state: 'SLP'},
    'Cucurpe': {municipality: '022', state: 'SON'},
    //'Matamoros': {municipality: '022', state: 'TAM'},
    'Acuamanala de Miguel Hidalgo': {municipality: '022', state: 'TLA'},
    'Atzacan': {municipality: '022', state: 'VER'},
    'Chikindzonot': {municipality: '022', state: 'YUC'},
    'Juan Aldama': {municipality: '022', state: 'ZAC'},
    //'Ocampo': {municipality: '023', state: 'COA'},
    //'Galeana': {municipality: '023', state: 'CHH'},
    'Chamula': {municipality: '023', state: 'CHP'},
    'Pueblo Nuevo': {municipality: '023', state: 'DUR'},
    'Cuajinicuilapa': {municipality: '023', state: 'GRO'},
    'Pénjamo': {municipality: '023', state: 'GUA'},
    //'Francisco I. Madero': {municipality: '023', state: 'HID'},
    'Zapotlán el Grande': {municipality: '023', state: 'JAL'},
    'Coyotepec': {municipality: '023', state: 'MEX'},
    'Chavinda': {municipality: '023', state: 'MIC'},
    'Tlalnepantla': {municipality: '023', state: 'MOR'},
    'General Treviño': {municipality: '023', state: 'NLE'},
    'Cuilápam de Guerrero': {municipality: '023', state: 'OAX'},
    'Atzitzintla': {municipality: '023', state: 'PUE'},
    'Rayón': {municipality: '023', state: 'SLP'},
    'Cumpas': {municipality: '023', state: 'SON'},
    'Méndez': {municipality: '023', state: 'TAM'},
    'Natívitas': {municipality: '023', state: 'TLA'},
    'Atzalan': {municipality: '023', state: 'VER'},
    'Chocholá': {municipality: '023', state: 'YUC'},
    'Juchipila': {municipality: '023', state: 'ZAC'},
    'Parras': {municipality: '024', state: 'COA'},
    'Santa Isabel': {municipality: '024', state: 'CHH'},
    'Chanal': {municipality: '024', state: 'CHP'},
    'Rodeo': {municipality: '024', state: 'DUR'},
    'Cualác': {municipality: '024', state: 'GRO'},
    //'Pueblo Nuevo': {municipality: '024', state: 'GUA'},
    'Huasca de Ocampo': {municipality: '024', state: 'HID'},
    //'Cocula': {municipality: '024', state: 'JAL'},
    'Cuautitlán': {municipality: '024', state: 'MEX'},
    'Cherán': {municipality: '024', state: 'MIC'},
    'Tlaltizapán de Zapata': {municipality: '024', state: 'MOR'},
    'General Zaragoza': {municipality: '024', state: 'NLE'},
    'Cuyamecalco Villa de Zaragoza': {municipality: '024', state: 'OAX'},
    'Axutla': {municipality: '024', state: 'PUE'},
    'Rioverde': {municipality: '024', state: 'SLP'},
    'Divisaderos': {municipality: '024', state: 'SON'},
    'Mier': {municipality: '024', state: 'TAM'},
    'Panotla': {municipality: '024', state: 'TLA'},
    'Tlaltetela': {municipality: '024', state: 'VER'},
    'Chumayel': {municipality: '024', state: 'YUC'},
    //'Loreto': {municipality: '024', state: 'ZAC'},
    'Piedras Negras': {municipality: '025', state: 'COA'},
    //'Gómez Farías': {municipality: '025', state: 'CHH'},
    'Chapultenango': {municipality: '025', state: 'CHP'},
    'San Bernardo': {municipality: '025', state: 'DUR'},
    'Cuautepec': {municipality: '025', state: 'GRO'},
    'Purísima del Rincón': {municipality: '025', state: 'GUA'},
    'Huautla': {municipality: '025', state: 'HID'},
    'Colotlán': {municipality: '025', state: 'JAL'},
    'Chalco': {municipality: '025', state: 'MEX'},
    'Chilchota': {municipality: '025', state: 'MIC'},
    'Tlaquiltenango': {municipality: '025', state: 'MOR'},
    'General Zuazua': {municipality: '025', state: 'NLE'},
    'Chahuites': {municipality: '025', state: 'OAX'},
    'Ayotoxco de Guerrero': {municipality: '025', state: 'PUE'},
    'Salinas': {municipality: '025', state: 'SLP'},
    'Empalme': {municipality: '025', state: 'SON'},
    'Miguel Alemán': {municipality: '025', state: 'TAM'},
    'San Pablo del Monte': {municipality: '025', state: 'TLA'},
    'Ayahualulco': {municipality: '025', state: 'VER'},
    'Dzán': {municipality: '025', state: 'YUC'},
    'Luis Moya': {municipality: '025', state: 'ZAC'},
    'Progreso': {municipality: '026', state: 'COA'},
    'Gran Morelos': {municipality: '026', state: 'CHH'},
    'Chenalhó': {municipality: '026', state: 'CHP'},
    'San Dimas': {municipality: '026', state: 'DUR'},
    'Cuetzala del Progreso': {municipality: '026', state: 'GRO'},
    'Romita': {municipality: '026', state: 'GUA'},
    'Huazalingo': {municipality: '026', state: 'HID'},
    'Concepción de Buenos Aires': {municipality: '026', state: 'JAL'},
    'Chapa de Mota': {municipality: '026', state: 'MEX'},
    'Chinicuila': {municipality: '026', state: 'MIC'},
    'Tlayacapan': {municipality: '026', state: 'MOR'},
    //'Guadalupe': {municipality: '026', state: 'NLE'},
    'Chalcatongo de Hidalgo': {municipality: '026', state: 'OAX'},
    'Calpan': {municipality: '026', state: 'PUE'},
    'San Antonio': {municipality: '026', state: 'SLP'},
    'Etchojoa': {municipality: '026', state: 'SON'},
    'Miquihuana': {municipality: '026', state: 'TAM'},
    'Santa Cruz Tlaxcala': {municipality: '026', state: 'TLA'},
    'Banderilla': {municipality: '026', state: 'VER'},
    'Dzemul': {municipality: '026', state: 'YUC'},
    'Mazapil': {municipality: '026', state: 'ZAC'},
    'Ramos Arizpe': {municipality: '027', state: 'COA'},
    'Guachochi': {municipality: '027', state: 'CHH'},
    'Chiapa de Corzo': {municipality: '027', state: 'CHP'},
    'San Juan de Guadalupe': {municipality: '027', state: 'DUR'},
    'Cutzamala de Pinzón': {municipality: '027', state: 'GRO'},
    'Salamanca': {municipality: '027', state: 'GUA'},
    'Huehuetla': {municipality: '027', state: 'HID'},
    'Cuautitlán de García Barragán': {municipality: '027', state: 'JAL'},
    'Chapultepec': {municipality: '027', state: 'MEX'},
    'Chucándiro': {municipality: '027', state: 'MIC'},
    'Totolapan': {municipality: '027', state: 'MOR'},
    'Los Herreras': {municipality: '027', state: 'NLE'},
    'Chiquihuitlán de Benito Juárez': {municipality: '027', state: 'OAX'},
    'Caltepec': {municipality: '027', state: 'PUE'},
    'San Ciro de Acosta': {municipality: '027', state: 'SLP'},
    'Fronteras': {municipality: '027', state: 'SON'},
    'Nuevo Laredo': {municipality: '027', state: 'TAM'},
    'Tenancingo': {municipality: '027', state: 'TLA'},
    //'Benito Juárez': {municipality: '027', state: 'VER'},
    'Dzidzantún': {municipality: '027', state: 'YUC'},
    'Melchor Ocampo': {municipality: '027', state: 'ZAC'},
    'Sabinas': {municipality: '028', state: 'COA'},
    //'Guadalupe': {municipality: '028', state: 'CHH'},
    'Chiapilla': {municipality: '028', state: 'CHP'},
    //'San Juan del Río': {municipality: '028', state: 'DUR'},
    'Chilapa de Álvarez': {municipality: '028', state: 'GRO'},
    'Salvatierra': {municipality: '028', state: 'GUA'},
    'Huejutla de Reyes': {municipality: '028', state: 'HID'},
    //'Cuautla': {municipality: '028', state: 'JAL'},
    'Chiautla': {municipality: '028', state: 'MEX'},
    'Churintzio': {municipality: '028', state: 'MIC'},
    'Xochitepec': {municipality: '028', state: 'MOR'},
    'Higueras': {municipality: '028', state: 'NLE'},
    'Heroica Ciudad de Ejutla de Crespo': {municipality: '028', state: 'OAX'},
    'Camocuautla': {municipality: '028', state: 'PUE'},
    'San Luis Potosí': {municipality: '028', state: 'SLP'},
    'Granados': {municipality: '028', state: 'SON'},
    'Nuevo Morelos': {municipality: '028', state: 'TAM'},
    'Teolocholco': {municipality: '028', state: 'TLA'},
    'Boca del Río': {municipality: '028', state: 'VER'},
    'Dzilam de Bravo': {municipality: '028', state: 'YUC'},
    'Mezquital del Oro': {municipality: '028', state: 'ZAC'},
    'Sacramento': {municipality: '029', state: 'COA'},
    'Guadalupe y Calvo': {municipality: '029', state: 'CHH'},
    'Chicoasén': {municipality: '029', state: 'CHP'},
    'San Luis del Cordero': {municipality: '029', state: 'DUR'},
    'Chilpancingo de los Bravo': {municipality: '029', state: 'GRO'},
    'San Diego de la Unión': {municipality: '029', state: 'GUA'},
    'Huichapan': {municipality: '029', state: 'HID'},
    'Cuquío': {municipality: '029', state: 'JAL'},
    'Chicoloapan': {municipality: '029', state: 'MEX'},
    'Churumuco': {municipality: '029', state: 'MIC'},
    'Yautepec': {municipality: '029', state: 'MOR'},
    'Hualahuises': {municipality: '029', state: 'NLE'},
    'Eloxochitlán de Flores Magón': {municipality: '029', state: 'OAX'},
    'Caxhuacan': {municipality: '029', state: 'PUE'},
    'San Martín Chalchicuautla': {municipality: '029', state: 'SLP'},
    'Guaymas': {municipality: '029', state: 'SON'},
    //'Ocampo': {municipality: '029', state: 'TAM'},
    'Tepeyanco': {municipality: '029', state: 'TLA'},
    'Calcahualco': {municipality: '029', state: 'VER'},
    'Dzilam González': {municipality: '029', state: 'YUC'},
    'Miguel Auza': {municipality: '029', state: 'ZAC'},
    'Saltillo': {municipality: '030', state: 'COA'},
    'Guazapares': {municipality: '030', state: 'CHH'},
    'Chicomuselo': {municipality: '030', state: 'CHP'},
    'San Pedro del Gallo': {municipality: '030', state: 'DUR'},
    'Florencio Villarreal': {municipality: '030', state: 'GRO'},
    'San Felipe': {municipality: '030', state: 'GUA'},
    'Ixmiquilpan': {municipality: '030', state: 'HID'},
    'Chapala': {municipality: '030', state: 'JAL'},
    'Chiconcuac': {municipality: '030', state: 'MEX'},
    'Ecuandureo': {municipality: '030', state: 'MIC'},
    'Yecapixtla': {municipality: '030', state: 'MOR'},
    'Iturbide': {municipality: '030', state: 'NLE'},
    'El Espinal': {municipality: '030', state: 'OAX'},
    'Coatepec': {municipality: '030', state: 'PUE'},
    'San Nicolás Tolentino': {municipality: '030', state: 'SLP'},
    'Hermosillo': {municipality: '030', state: 'SON'},
    'Padilla': {municipality: '030', state: 'TAM'},
    'Terrenate': {municipality: '030', state: 'TLA'},
    'Camerino Z. Mendoza': {municipality: '030', state: 'VER'},
    'Dzitás': {municipality: '030', state: 'YUC'},
    'Momax': {municipality: '030', state: 'ZAC'},
    'San Buenaventura': {municipality: '031', state: 'COA'},
    //'Guerrero': {municipality: '031', state: 'CHH'},
    'Chilón': {municipality: '031', state: 'CHP'},
    'Santa Clara': {municipality: '031', state: 'DUR'},
    'General Canuto A. Neri': {municipality: '031', state: 'GRO'},
    'San Francisco del Rincón': {municipality: '031', state: 'GUA'},
    'Jacala de Ledezma': {municipality: '031', state: 'HID'},
    'Chimaltitán': {municipality: '031', state: 'JAL'},
    'Chimalhuacán': {municipality: '031', state: 'MEX'},
    'Epitacio Huerta': {municipality: '031', state: 'MIC'},
    'Zacatepec': {municipality: '031', state: 'MOR'},
    //'Juárez': {municipality: '031', state: 'NLE'},
    'Tamazulápam del Espíritu Santo': {municipality: '031', state: 'OAX'},
    'Coatzingo': {municipality: '031', state: 'PUE'},
    'Santa Catarina': {municipality: '031', state: 'SLP'},
    'Huachinera': {municipality: '031', state: 'SON'},
    'Palmillas': {municipality: '031', state: 'TAM'},
    'Tetla de la Solidaridad': {municipality: '031', state: 'TLA'},
    'Carrillo Puerto': {municipality: '031', state: 'VER'},
    'Dzoncauich': {municipality: '031', state: 'YUC'},
    'Monte Escobedo': {municipality: '031', state: 'ZAC'},
    'San Juan de Sabinas': {municipality: '032', state: 'COA'},
    'Hidalgo del Parral': {municipality: '032', state: 'CHH'},
    'Escuintla': {municipality: '032', state: 'CHP'},
    'Santiago Papasquiaro': {municipality: '032', state: 'DUR'},
    'General Heliodoro Castillo': {municipality: '032', state: 'GRO'},
    'San José Iturbide': {municipality: '032', state: 'GUA'},
    'Jaltocán': {municipality: '032', state: 'HID'},
    'Chiquilistlán': {municipality: '032', state: 'JAL'},
    'Donato Guerra': {municipality: '032', state: 'MEX'},
    'Erongarícuaro': {municipality: '032', state: 'MIC'},
    'Zacualpan': {municipality: '032', state: 'MOR'},
    'Lampazos de Naranjo': {municipality: '032', state: 'NLE'},
    'Fresnillo de Trujano': {municipality: '032', state: 'OAX'},
    'Cohetzala': {municipality: '032', state: 'PUE'},
    'Santa María del Río': {municipality: '032', state: 'SLP'},
    'Huásabas': {municipality: '032', state: 'SON'},
    'Reynosa': {municipality: '032', state: 'TAM'},
    'Tetlatlahuca': {municipality: '032', state: 'TLA'},
    'Catemaco': {municipality: '032', state: 'VER'},
    'Espita': {municipality: '032', state: 'YUC'},
    //'Morelos': {municipality: '032', state: 'ZAC'},
    'San Pedro': {municipality: '033', state: 'COA'},
    'Huejotitán': {municipality: '033', state: 'CHH'},
    'Francisco León': {municipality: '033', state: 'CHP'},
    'Súchil': {municipality: '033', state: 'DUR'},
    'Huamuxtitlán': {municipality: '033', state: 'GRO'},
    'San Luis de la Paz': {municipality: '033', state: 'GUA'},
    'Juárez Hidalgo': {municipality: '033', state: 'HID'},
    'Degollado': {municipality: '033', state: 'JAL'},
    'Ecatepec de Morelos': {municipality: '033', state: 'MEX'},
    'Gabriel Zamora': {municipality: '033', state: 'MIC'},
    'Temoac': {municipality: '033', state: 'MOR'},
    'Linares': {municipality: '033', state: 'NLE'},
    'Guadalupe Etla': {municipality: '033', state: 'OAX'},
    'Cohuecan': {municipality: '033', state: 'PUE'},
    'Santo Domingo': {municipality: '033', state: 'SLP'},
    'Huatabampo': {municipality: '033', state: 'SON'},
    'Río Bravo': {municipality: '033', state: 'TAM'},
    'Tlaxcala': {municipality: '033', state: 'TLA'},
    'Cazones de Herrera': {municipality: '033', state: 'VER'},
    'Halachó': {municipality: '033', state: 'YUC'},
    'Moyahua de Estrada': {municipality: '033', state: 'ZAC'},
    'Sierra Mojada': {municipality: '034', state: 'COA'},
    'Ignacio Zaragoza': {municipality: '034', state: 'CHH'},
    'Frontera Comalapa': {municipality: '034', state: 'CHP'},
    'Tamazula': {municipality: '034', state: 'DUR'},
    'Huitzuco de los Figueroa': {municipality: '034', state: 'GRO'},
    //'Santa Catarina': {municipality: '034', state: 'GUA'},
    'Lolotla': {municipality: '034', state: 'HID'},
    'Ejutla': {municipality: '034', state: 'JAL'},
    'Ecatzingo': {municipality: '034', state: 'MEX'},
    //'Hidalgo': {municipality: '034', state: 'MIC'},
    'Marín': {municipality: '034', state: 'NLE'},
    'Guadalupe de Ramírez': {municipality: '034', state: 'OAX'},
    'Coronango': {municipality: '034', state: 'PUE'},
    'San Vicente Tancuayalab': {municipality: '034', state: 'SLP'},
    'Huépac': {municipality: '034', state: 'SON'},
    'San Carlos': {municipality: '034', state: 'TAM'},
    'Tlaxco': {municipality: '034', state: 'TLA'},
    'Cerro Azul': {municipality: '034', state: 'VER'},
    'Hocabá': {municipality: '034', state: 'YUC'},
    'Nochistlán de Mejía': {municipality: '034', state: 'ZAC'},
    'Torreón': {municipality: '035', state: 'COA'},
    'Janos': {municipality: '035', state: 'CHH'},
    'Frontera Hidalgo': {municipality: '035', state: 'CHP'},
    'Tepehuanes': {municipality: '035', state: 'DUR'},
    'Iguala de la Independencia': {municipality: '035', state: 'GRO'},
    'Santa Cruz de Juventino Rosas': {municipality: '035', state: 'GUA'},
    'Metepec': {municipality: '035', state: 'HID'},
    'Encarnación de Díaz': {municipality: '035', state: 'JAL'},
    'Huehuetoca': {municipality: '035', state: 'MEX'},
    'La Huacana': {municipality: '035', state: 'MIC'},
    //'Melchor Ocampo': {municipality: '035', state: 'NLE'},
    'Guelatao de Juárez': {municipality: '035', state: 'OAX'},
    //'Coxcatlán': {municipality: '035', state: 'PUE'},
    'Soledad de Graciano Sánchez': {municipality: '035', state: 'SLP'},
    'Imuris': {municipality: '035', state: 'SON'},
    'San Fernando': {municipality: '035', state: 'TAM'},
    'Tocatlán': {municipality: '035', state: 'TLA'},
    'Citlaltépetl': {municipality: '035', state: 'VER'},
    'Hoctún': {municipality: '035', state: 'YUC'},
    'Noria de Ángeles': {municipality: '035', state: 'ZAC'},
    'Viesca': {municipality: '036', state: 'COA'},
    //'Jiménez': {municipality: '036', state: 'CHH'},
    'La Grandeza': {municipality: '036', state: 'CHP'},
    'Tlahualilo': {municipality: '036', state: 'DUR'},
    'Igualapa': {municipality: '036', state: 'GRO'},
    'Santiago Maravatío': {municipality: '036', state: 'GUA'},
    'San Agustín Metzquititlán': {municipality: '036', state: 'HID'},
    'Etzatlán': {municipality: '036', state: 'JAL'},
    'Hueypoxtla': {municipality: '036', state: 'MEX'},
    'Huandacareo': {municipality: '036', state: 'MIC'},
    'Mier y Noriega': {municipality: '036', state: 'NLE'},
    'Guevea de Humboldt': {municipality: '036', state: 'OAX'},
    'Coyomeapan': {municipality: '036', state: 'PUE'},
    'Tamasopo': {municipality: '036', state: 'SLP'},
    'Magdalena': {municipality: '036', state: 'SON'},
    'San Nicolás': {municipality: '036', state: 'TAM'},
    'Totolac': {municipality: '036', state: 'TLA'},
    'Coacoatzintla': {municipality: '036', state: 'VER'},
    'Homún': {municipality: '036', state: 'YUC'},
    'Ojocaliente': {municipality: '036', state: 'ZAC'},
    'Villa Unión': {municipality: '037', state: 'COA'},
    //'Juárez': {municipality: '037', state: 'CHH'},
    'Huehuetán': {municipality: '037', state: 'CHP'},
    'Topia': {municipality: '037', state: 'DUR'},
    'Ixcateopan de Cuauhtémoc': {municipality: '037', state: 'GRO'},
    'Silao de la Victoria': {municipality: '037', state: 'GUA'},
    'Metztitlán': {municipality: '037', state: 'HID'},
    'El Grullo': {municipality: '037', state: 'JAL'},
    'Huixquilucan': {municipality: '037', state: 'MEX'},
    'Huaniqueo': {municipality: '037', state: 'MIC'},
    'Mina': {municipality: '037', state: 'NLE'},
    'Mesones Hidalgo': {municipality: '037', state: 'OAX'},
    //'Coyotepec': {municipality: '037', state: 'PUE'},
    'Tamazunchale': {municipality: '037', state: 'SLP'},
    'Mazatán': {municipality: '037', state: 'SON'},
    'Soto la Marina': {municipality: '037', state: 'TAM'},
    'Ziltlaltépec de Trinidad Sánchez Santos': {municipality: '037', state: 'TLA'},
    'Coahuitlán': {municipality: '037', state: 'VER'},
    'Huhí': {municipality: '037', state: 'YUC'},
    'Pánuco': {municipality: '037', state: 'ZAC'},
    'Zaragoza': {municipality: '038', state: 'COA'},
    'Julimes': {municipality: '038', state: 'CHH'},
    'Huixtán': {municipality: '038', state: 'CHP'},
    'Vicente Guerrero': {municipality: '038', state: 'DUR'},
    'Zihuatanejo de Azueta': {municipality: '038', state: 'GRO'},
    'Tarandacuao': {municipality: '038', state: 'GUA'},
    'Mineral del Chico': {municipality: '038', state: 'HID'},
    'Guachinango': {municipality: '038', state: 'JAL'},
    'Isidro Fabela': {municipality: '038', state: 'MEX'},
    'Huetamo': {municipality: '038', state: 'MIC'},
    'Montemorelos': {municipality: '038', state: 'NLE'},
    'Villa Hidalgo': {municipality: '038', state: 'OAX'},
    'Cuapiaxtla de Madero': {municipality: '038', state: 'PUE'},
    'Tampacán': {municipality: '038', state: 'SLP'},
    //'Moctezuma': {municipality: '038', state: 'SON'},
    'Tampico': {municipality: '038', state: 'TAM'},
    'Tzompantepec': {municipality: '038', state: 'TLA'},
    //'Coatepec': {municipality: '038', state: 'VER'},
    'Hunucmá': {municipality: '038', state: 'YUC'},
    'Pinos': {municipality: '038', state: 'ZAC'},
    'López': {municipality: '039', state: 'CHH'},
    'Huitiupán': {municipality: '039', state: 'CHP'},
    'Nuevo Ideal': {municipality: '039', state: 'DUR'},
    'Juan R. Escudero': {municipality: '039', state: 'GRO'},
    'Tarimoro': {municipality: '039', state: 'GUA'},
    'Mineral del Monte': {municipality: '039', state: 'HID'},
    'Guadalajara': {municipality: '039', state: 'JAL'},
    'Ixtapaluca': {municipality: '039', state: 'MEX'},
    'Huiramba': {municipality: '039', state: 'MIC'},
    'Monterrey': {municipality: '039', state: 'NLE'},
    'Heroica Ciudad de Huajuapan de León': {municipality: '039', state: 'OAX'},
    'Cuautempan': {municipality: '039', state: 'PUE'},
    'Tampamolón Corona': {municipality: '039', state: 'SLP'},
    'Naco': {municipality: '039', state: 'SON'},
    'Tula': {municipality: '039', state: 'TAM'},
    'Xaloztoc': {municipality: '039', state: 'TLA'},
    'Coatzacoalcos': {municipality: '039', state: 'VER'},
    'Ixil': {municipality: '039', state: 'YUC'},
    'Río Grande': {municipality: '039', state: 'ZAC'},
    'Madera': {municipality: '040', state: 'CHH'},
    'Huixtla': {municipality: '040', state: 'CHP'},
    'Leonardo Bravo': {municipality: '040', state: 'GRO'},
    'Tierra Blanca': {municipality: '040', state: 'GUA'},
    'La Misión': {municipality: '040', state: 'HID'},
    'Hostotipaquillo': {municipality: '040', state: 'JAL'},
    'Ixtapan de la Sal': {municipality: '040', state: 'MEX'},
    'Indaparapeo': {municipality: '040', state: 'MIC'},
    'Parás': {municipality: '040', state: 'NLE'},
    'Huautepec': {municipality: '040', state: 'OAX'},
    'Cuautinchán': {municipality: '040', state: 'PUE'},
    'Tamuín': {municipality: '040', state: 'SLP'},
    'Nácori Chico': {municipality: '040', state: 'SON'},
    'Valle Hermoso': {municipality: '040', state: 'TAM'},
    'Xaltocan': {municipality: '040', state: 'TLA'},
    'Coatzintla': {municipality: '040', state: 'VER'},
    'Izamal': {municipality: '040', state: 'YUC'},
    'Sain Alto': {municipality: '040', state: 'ZAC'},
    'Maguarichi': {municipality: '041', state: 'CHH'},
    'La Independencia': {municipality: '041', state: 'CHP'},
    'Malinaltepec': {municipality: '041', state: 'GRO'},
    'Uriangato': {municipality: '041', state: 'GUA'},
    'Mixquiahuala de Juárez': {municipality: '041', state: 'HID'},
    'Huejúcar': {municipality: '041', state: 'JAL'},
    'Ixtapan del Oro': {municipality: '041', state: 'MEX'},
    'Irimbo': {municipality: '041', state: 'MIC'},
    'Pesquería': {municipality: '041', state: 'NLE'},
    'Huautla de Jiménez': {municipality: '041', state: 'OAX'},
    'Cuautlancingo': {municipality: '041', state: 'PUE'},
    'Tanlajás': {municipality: '041', state: 'SLP'},
    'Nacozari de García': {municipality: '041', state: 'SON'},
    'Victoria': {municipality: '041', state: 'TAM'},
    'Papalotla de Xicohténcatl': {municipality: '041', state: 'TLA'},
    'Coetzala': {municipality: '041', state: 'VER'},
    'Kanasín': {municipality: '041', state: 'YUC'},
    'El Salvador': {municipality: '041', state: 'ZAC'},
    'Manuel Benavides': {municipality: '042', state: 'CHH'},
    'Ixhuatán': {municipality: '042', state: 'CHP'},
    'Mártir de Cuilapan': {municipality: '042', state: 'GRO'},
    'Valle de Santiago': {municipality: '042', state: 'GUA'},
    'Molango de Escamilla': {municipality: '042', state: 'HID'},
    'Huejuquilla el Alto': {municipality: '042', state: 'JAL'},
    'Ixtlahuaca': {municipality: '042', state: 'MEX'},
    'Ixtlán': {municipality: '042', state: 'MIC'},
    'Los Ramones': {municipality: '042', state: 'NLE'},
    'Ixtlán de Juárez': {municipality: '042', state: 'OAX'},
    'Cuayuca de Andrade': {municipality: '042', state: 'PUE'},
    'Tanquián de Escobedo': {municipality: '042', state: 'SLP'},
    'Navojoa': {municipality: '042', state: 'SON'},
    'Villagrán': {municipality: '042', state: 'TAM'},
    'Xicohtzinco': {municipality: '042', state: 'TLA'},
    'Colipa': {municipality: '042', state: 'VER'},
    'Kantunil': {municipality: '042', state: 'YUC'},
    'Sombrerete': {municipality: '042', state: 'ZAC'},
    'Matachí': {municipality: '043', state: 'CHH'},
    'Ixtacomitán': {municipality: '043', state: 'CHP'},
    'Metlatónoc': {municipality: '043', state: 'GRO'},
    //'Victoria': {municipality: '043', state: 'GUA'},
    'Nicolás Flores': {municipality: '043', state: 'HID'},
    'La Huerta': {municipality: '043', state: 'JAL'},
    'Xalatlaco': {municipality: '043', state: 'MEX'},
    'Jacona': {municipality: '043', state: 'MIC'},
    'Rayones': {municipality: '043', state: 'NLE'},
    'Heroica Ciudad de Juchitán de Zaragoza': {municipality: '043', state: 'OAX'},
    'Cuetzalan del Progreso': {municipality: '043', state: 'PUE'},
    'Tierra Nueva': {municipality: '043', state: 'SLP'},
    'Nogales': {municipality: '043', state: 'SON'},
    'Xicoténcatl': {municipality: '043', state: 'TAM'},
    'Yauhquemehcan': {municipality: '043', state: 'TLA'},
    'Comapa': {municipality: '043', state: 'VER'},
    'Kaua': {municipality: '043', state: 'YUC'},
    'Susticacán': {municipality: '043', state: 'ZAC'},
    //'Matamoros': {municipality: '044', state: 'CHH'},
    'Ixtapa': {municipality: '044', state: 'CHP'},
    'Mochitlán': {municipality: '044', state: 'GRO'},
    //'Villagrán': {municipality: '044', state: 'GUA'},
    'Nopala de Villagrán': {municipality: '044', state: 'HID'},
    'Ixtlahuacán de los Membrillos': {municipality: '044', state: 'JAL'},
    'Jaltenco': {municipality: '044', state: 'MEX'},
    //'Jiménez': {municipality: '044', state: 'MIC'},
    'Sabinas Hidalgo': {municipality: '044', state: 'NLE'},
    'Loma Bonita': {municipality: '044', state: 'OAX'},
    'Cuyoaco': {municipality: '044', state: 'PUE'},
    'Vanegas': {municipality: '044', state: 'SLP'},
    'Onavas': {municipality: '044', state: 'SON'},
    'Zacatelco': {municipality: '044', state: 'TLA'},
    'Córdoba': {municipality: '044', state: 'VER'},
    'Kinchil': {municipality: '044', state: 'YUC'},
    'Tabasco': {municipality: '044', state: 'ZAC'},
    'Meoqui': {municipality: '045', state: 'CHH'},
    'Ixtapangajoya': {municipality: '045', state: 'CHP'},
    'Olinalá': {municipality: '045', state: 'GRO'},
    'Xichú': {municipality: '045', state: 'GUA'},
    'Omitlán de Juárez': {municipality: '045', state: 'HID'},
    'Ixtlahuacán del Río': {municipality: '045', state: 'JAL'},
    'Jilotepec': {municipality: '045', state: 'MEX'},
    'Jiquilpan': {municipality: '045', state: 'MIC'},
    'Salinas Victoria': {municipality: '045', state: 'NLE'},
    'Magdalena Apasco': {municipality: '045', state: 'OAX'},
    'Chalchicomula de Sesma': {municipality: '045', state: 'PUE'},
    'Venado': {municipality: '045', state: 'SLP'},
    'Opodepe': {municipality: '045', state: 'SON'},
    //'Benito Juárez': {municipality: '045', state: 'TLA'},
    'Cosamaloapan de Carpio': {municipality: '045', state: 'VER'},
    'Kopomá': {municipality: '045', state: 'YUC'},
    'Tepechitlán': {municipality: '045', state: 'ZAC'},
    //'Morelos': {municipality: '046', state: 'CHH'},
    'Jiquipilas': {municipality: '046', state: 'CHP'},
    'Ometepec': {municipality: '046', state: 'GRO'},
    'Yuriria': {municipality: '046', state: 'GUA'},
    'San Felipe Orizatlán': {municipality: '046', state: 'HID'},
    'Jalostotitlán': {municipality: '046', state: 'JAL'},
    'Jilotzingo': {municipality: '046', state: 'MEX'},
    //'Juárez': {municipality: '046', state: 'MIC'},
    'San Nicolás de los Garza': {municipality: '046', state: 'NLE'},
    'Magdalena Jaltepec': {municipality: '046', state: 'OAX'},
    'Chapulco': {municipality: '046', state: 'PUE'},
    'Villa de Arriaga': {municipality: '046', state: 'SLP'},
    'Oquitoa': {municipality: '046', state: 'SON'},
    //'Emiliano Zapata': {municipality: '046', state: 'TLA'},
    'Cosautlán de Carvajal': {municipality: '046', state: 'VER'},
    'Mama': {municipality: '046', state: 'YUC'},
    'Tepetongo': {municipality: '046', state: 'ZAC'},
    'Moris': {municipality: '047', state: 'CHH'},
    'Jitotol': {municipality: '047', state: 'CHP'},
    'Pedro Ascencio Alquisiras': {municipality: '047', state: 'GRO'},
    'Pacula': {municipality: '047', state: 'HID'},
    'Jamay': {municipality: '047', state: 'JAL'},
    'Jiquipilco': {municipality: '047', state: 'MEX'},
    'Jungapeo': {municipality: '047', state: 'MIC'},
    //'Hidalgo': {municipality: '047', state: 'NLE'},
    'Santa Magdalena Jicotlán': {municipality: '047', state: 'OAX'},
    //'Chiautla': {municipality: '047', state: 'PUE'},
    'Villa de Guadalupe': {municipality: '047', state: 'SLP'},
    'Pitiquito': {municipality: '047', state: 'SON'},
    //'Lázaro Cárdenas': {municipality: '047', state: 'TLA'},
    'Coscomatepec': {municipality: '047', state: 'VER'},
    'Maní': {municipality: '047', state: 'YUC'},
    'Teúl de González Ortega': {municipality: '047', state: 'ZAC'},
    'Namiquipa': {municipality: '048', state: 'CHH'},
    //'Juárez': {municipality: '048', state: 'CHP'},
    'Petatlán': {municipality: '048', state: 'GRO'},
    'Pachuca de Soto': {municipality: '048', state: 'HID'},
    //'Jesús María': {municipality: '048', state: 'JAL'},
    'Jocotitlán': {municipality: '048', state: 'MEX'},
    //'Lagunillas': {municipality: '048', state: 'MIC'},
    //'Santa Catarina': {municipality: '048', state: 'NLE'},
    'Magdalena Mixtepec': {municipality: '048', state: 'OAX'},
    'Chiautzingo': {municipality: '048', state: 'PUE'},
    'Villa de la Paz': {municipality: '048', state: 'SLP'},
    'Puerto Peñasco': {municipality: '048', state: 'SON'},
    'La Magdalena Tlaltelulco': {municipality: '048', state: 'TLA'},
    'Cosoleacaque': {municipality: '048', state: 'VER'},
    'Maxcanú': {municipality: '048', state: 'YUC'},
    'Tlaltenango de Sánchez Román': {municipality: '048', state: 'ZAC'},
    'Nonoava': {municipality: '049', state: 'CHH'},
    'Larráinzar': {municipality: '049', state: 'CHP'},
    'Pilcaya': {municipality: '049', state: 'GRO'},
    'Pisaflores': {municipality: '049', state: 'HID'},
    'Jilotlán de los Dolores': {municipality: '049', state: 'JAL'},
    'Joquicingo': {municipality: '049', state: 'MEX'},
    'Madero': {municipality: '049', state: 'MIC'},
    'Santiago': {municipality: '049', state: 'NLE'},
    'Magdalena Ocotlán': {municipality: '049', state: 'OAX'},
    'Chiconcuautla': {municipality: '049', state: 'PUE'},
    'Villa de Ramos': {municipality: '049', state: 'SLP'},
    'Quiriego': {municipality: '049', state: 'SON'},
    'San Damián Texóloc': {municipality: '049', state: 'TLA'},
    'Cotaxtla': {municipality: '049', state: 'VER'},
    'Mayapán': {municipality: '049', state: 'YUC'},
    'Valparaíso': {municipality: '049', state: 'ZAC'},
    'Nuevo Casas Grandes': {municipality: '050', state: 'CHH'},
    'La Libertad': {municipality: '050', state: 'CHP'},
    'Pungarabato': {municipality: '050', state: 'GRO'},
    'Progreso de Obregón': {municipality: '050', state: 'HID'},
    'Jocotepec': {municipality: '050', state: 'JAL'},
    'Juchitepec': {municipality: '050', state: 'MEX'},
    'Maravatío': {municipality: '050', state: 'MIC'},
    'Vallecillo': {municipality: '050', state: 'NLE'},
    'Magdalena Peñasco': {municipality: '050', state: 'OAX'},
    'Chichiquila': {municipality: '050', state: 'PUE'},
    'Villa de Reyes': {municipality: '050', state: 'SLP'},
    //'Rayón': {municipality: '050', state: 'SON'},
    'San Francisco Tetlanohcan': {municipality: '050', state: 'TLA'},
    'Coxquihui': {municipality: '050', state: 'VER'},
    'Mérida': {municipality: '050', state: 'YUC'},
    'Vetagrande': {municipality: '050', state: 'ZAC'},
    //'Ocampo': {municipality: '051', state: 'CHH'},
    'Mapastepec': {municipality: '051', state: 'CHP'},
    'Quechultenango': {municipality: '051', state: 'GRO'},
    'Mineral de la Reforma': {municipality: '051', state: 'HID'},
    'Juanacatlán': {municipality: '051', state: 'JAL'},
    'Lerma': {municipality: '051', state: 'MEX'},
    'Marcos Castellanos': {municipality: '051', state: 'MIC'},
    'Villaldama': {municipality: '051', state: 'NLE'},
    'Magdalena Teitipac': {municipality: '051', state: 'OAX'},
    'Chietla': {municipality: '051', state: 'PUE'},
    //'Villa Hidalgo': {municipality: '051', state: 'SLP'},
    //'Rosario': {municipality: '051', state: 'SON'},
    'San Jerónimo Zacualpan': {municipality: '051', state: 'TLA'},
    'Coyutla': {municipality: '051', state: 'VER'},
    'Mocochá': {municipality: '051', state: 'YUC'},
    'Villa de Cos': {municipality: '051', state: 'ZAC'},
    'Ojinaga': {municipality: '052', state: 'CHH'},
    'Las Margaritas': {municipality: '052', state: 'CHP'},
    'San Luis Acatlán': {municipality: '052', state: 'GRO'},
    'San Agustín Tlaxiaca': {municipality: '052', state: 'HID'},
    'Juchitlán': {municipality: '052', state: 'JAL'},
    'Malinalco': {municipality: '052', state: 'MEX'},
    //'Lázaro Cárdenas': {municipality: '052', state: 'MIC'},
    'Magdalena Tequisistlán': {municipality: '052', state: 'OAX'},
    'Chigmecatitlán': {municipality: '052', state: 'PUE'},
    'Villa Juárez': {municipality: '052', state: 'SLP'},
    'Sahuaripa': {municipality: '052', state: 'SON'},
    'San José Teacalco': {municipality: '052', state: 'TLA'},
    'Cuichapa': {municipality: '052', state: 'VER'},
    'Motul': {municipality: '052', state: 'YUC'},
    'Villa García': {municipality: '052', state: 'ZAC'},
    'Praxedis G. Guerrero': {municipality: '053', state: 'CHH'},
    'Mazapa de Madero': {municipality: '053', state: 'CHP'},
    'San Marcos': {municipality: '053', state: 'GRO'},
    'San Bartolo Tutotepec': {municipality: '053', state: 'HID'},
    'Lagos de Moreno': {municipality: '053', state: 'JAL'},
    //'Melchor Ocampo': {municipality: '053', state: 'MEX'},
    'Morelia': {municipality: '053', state: 'MIC'},
    'Magdalena Tlacotepec': {municipality: '053', state: 'OAX'},
    'Chignahuapan': {municipality: '053', state: 'PUE'},
    'Axtla de Terrazas': {municipality: '053', state: 'SLP'},
    'San Felipe de Jesús': {municipality: '053', state: 'SON'},
    'San Juan Huactzinco': {municipality: '053', state: 'TLA'},
    'Cuitláhuac': {municipality: '053', state: 'VER'},
    'Muna': {municipality: '053', state: 'YUC'},
    'Villa González Ortega': {municipality: '053', state: 'ZAC'},
    'Riva Palacio': {municipality: '054', state: 'CHH'},
    //'Mazatán': {municipality: '054', state: 'CHP'},
    'San Miguel Totolapan': {municipality: '054', state: 'GRO'},
    'San Salvador': {municipality: '054', state: 'HID'},
    'El Limón': {municipality: '054', state: 'JAL'},
    //'Metepec': {municipality: '054', state: 'MEX'},
    //'Morelos': {municipality: '054', state: 'MIC'},
    'Magdalena Zahuatlán': {municipality: '054', state: 'OAX'},
    'Chignautla': {municipality: '054', state: 'PUE'},
    'Xilitla': {municipality: '054', state: 'SLP'},
    'San Javier': {municipality: '054', state: 'SON'},
    'San Lorenzo Axocomanitla': {municipality: '054', state: 'TLA'},
    'Chacaltianguis': {municipality: '054', state: 'VER'},
    'Muxupip': {municipality: '054', state: 'YUC'},
    //'Villa Hidalgo': {municipality: '054', state: 'ZAC'},
    'Rosales': {municipality: '055', state: 'CHH'},
    'Metapa': {municipality: '055', state: 'CHP'},
    'Taxco de Alarcón': {municipality: '055', state: 'GRO'},
    'Santiago de Anaya': {municipality: '055', state: 'HID'},
    //'Magdalena': {municipality: '055', state: 'JAL'},
    'Mexicaltzingo': {municipality: '055', state: 'MEX'},
    'Múgica': {municipality: '055', state: 'MIC'},
    'Mariscala de Juárez': {municipality: '055', state: 'OAX'},
    'Chila': {municipality: '055', state: 'PUE'},
    //'Zaragoza': {municipality: '055', state: 'SLP'},
    'San Luis Río Colorado': {municipality: '055', state: 'SON'},
    'San Lucas Tecopilco': {municipality: '055', state: 'TLA'},
    'Chalma': {municipality: '055', state: 'VER'},
    'Opichén': {municipality: '055', state: 'YUC'},
    'Villanueva': {municipality: '055', state: 'ZAC'},
    //'Rosario': {municipality: '056', state: 'CHH'},
    'Mitontic': {municipality: '056', state: 'CHP'},
    'Tecoanapa': {municipality: '056', state: 'GRO'},
    'Santiago Tulantepec de Lugo Guerrero': {municipality: '056', state: 'HID'},
    //'Santa María del Oro': {municipality: '056', state: 'JAL'},
    //'Morelos': {municipality: '056', state: 'MEX'},
    'Nahuatzen': {municipality: '056', state: 'MIC'},
    'Mártires de Tacubaya': {municipality: '056', state: 'OAX'},
    'Chila de la Sal': {municipality: '056', state: 'PUE'},
    'Villa de Arista': {municipality: '056', state: 'SLP'},
    'San Miguel de Horcasitas': {municipality: '056', state: 'SON'},
    'Santa Ana Nopalucan': {municipality: '056', state: 'TLA'},
    'Chiconamel': {municipality: '056', state: 'VER'},
    'Oxkutzcab': {municipality: '056', state: 'YUC'},
    'Zacatecas': {municipality: '056', state: 'ZAC'},
    'San Francisco de Borja': {municipality: '057', state: 'CHH'},
    'Motozintla': {municipality: '057', state: 'CHP'},
    'Técpan de Galeana': {municipality: '057', state: 'GRO'},
    'Singuilucan': {municipality: '057', state: 'HID'},
    'La Manzanilla de la Paz': {municipality: '057', state: 'JAL'},
    'Naucalpan de Juárez': {municipality: '057', state: 'MEX'},
    'Nocupétaro': {municipality: '057', state: 'MIC'},
    'Matías Romero Avendaño': {municipality: '057', state: 'OAX'},
    'Honey': {municipality: '057', state: 'PUE'},
    'Matlapa': {municipality: '057', state: 'SLP'},
    'San Pedro de la Cueva': {municipality: '057', state: 'SON'},
    'Santa Apolonia Teacalco': {municipality: '057', state: 'TLA'},
    'Chiconquiaco': {municipality: '057', state: 'VER'},
    'Panabá': {municipality: '057', state: 'YUC'},
    'Trancoso': {municipality: '057', state: 'ZAC'},
    'San Francisco de Conchos': {municipality: '058', state: 'CHH'},
    'Nicolás Ruíz': {municipality: '058', state: 'CHP'},
    'Teloloapan': {municipality: '058', state: 'GRO'},
    'Tasquillo': {municipality: '058', state: 'HID'},
    'Mascota': {municipality: '058', state: 'JAL'},
    'Nezahualcóyotl': {municipality: '058', state: 'MEX'},
    'Nuevo Parangaricutiro': {municipality: '058', state: 'MIC'},
    'Mazatlán Villa de Flores': {municipality: '058', state: 'OAX'},
    'Chilchotla': {municipality: '058', state: 'PUE'},
    'El Naranjo': {municipality: '058', state: 'SLP'},
    'Santa Ana': {municipality: '058', state: 'SON'},
    'Santa Catarina Ayometla': {municipality: '058', state: 'TLA'},
    'Chicontepec': {municipality: '058', state: 'VER'},
    'Peto': {municipality: '058', state: 'YUC'},
    'Santa María de la Paz': {municipality: '058', state: 'ZAC'},
    'San Francisco del Oro': {municipality: '059', state: 'CHH'},
    'Ocosingo': {municipality: '059', state: 'CHP'},
    'Tepecoacuilco de Trujano': {municipality: '059', state: 'GRO'},
    'Tecozautla': {municipality: '059', state: 'HID'},
    'Mazamitla': {municipality: '059', state: 'JAL'},
    'Nextlalpan': {municipality: '059', state: 'MEX'},
    'Nuevo Urecho': {municipality: '059', state: 'MIC'},
    'Miahuatlán de Porfirio Díaz': {municipality: '059', state: 'OAX'},
    'Chinantla': {municipality: '059', state: 'PUE'},
    'Santa Cruz': {municipality: '059', state: 'SON'},
    'Santa Cruz Quilehtla': {municipality: '059', state: 'TLA'},
    'Chinameca': {municipality: '059', state: 'VER'},
    //'Progreso': {municipality: '059', state: 'YUC'},
    'Santa Bárbara': {municipality: '060', state: 'CHH'},
    'Ocotepec': {municipality: '060', state: 'CHP'},
    'Tetipac': {municipality: '060', state: 'GRO'},
    'Tenango de Doria': {municipality: '060', state: 'HID'},
    'Mexticacán': {municipality: '060', state: 'JAL'},
    'Nicolás Romero': {municipality: '060', state: 'MEX'},
    'Numarán': {municipality: '060', state: 'MIC'},
    'Mixistlán de la Reforma': {municipality: '060', state: 'OAX'},
    'Domingo Arenas': {municipality: '060', state: 'PUE'},
    'Sáric': {municipality: '060', state: 'SON'},
    'Santa Isabel Xiloxoxtla': {municipality: '060', state: 'TLA'},
    'Chinampa de Gorostiza': {municipality: '060', state: 'VER'},
    'Quintana Roo': {municipality: '060', state: 'YUC'},
    'Satevó': {municipality: '061', state: 'CHH'},
    'Ocozocoautla de Espinosa': {municipality: '061', state: 'CHP'},
    'Tixtla de Guerrero': {municipality: '061', state: 'GRO'},
    'Tepeapulco': {municipality: '061', state: 'HID'},
    'Mezquitic': {municipality: '061', state: 'JAL'},
    'Nopaltepec': {municipality: '061', state: 'MEX'},
    //'Ocampo': {municipality: '061', state: 'MIC'},
    'Monjas': {municipality: '061', state: 'OAX'},
    //'Eloxochitlán': {municipality: '061', state: 'PUE'},
    'Soyopa': {municipality: '061', state: 'SON'},
    'Las Choapas': {municipality: '061', state: 'VER'},
    'Río Lagartos': {municipality: '061', state: 'YUC'},
    'Saucillo': {municipality: '062', state: 'CHH'},
    'Ostuacán': {municipality: '062', state: 'CHP'},
    'Tlacoachistlahuaca': {municipality: '062', state: 'GRO'},
    'Tepehuacán de Guerrero': {municipality: '062', state: 'HID'},
    'Mixtlán': {municipality: '062', state: 'JAL'},
    'Ocoyoacac': {municipality: '062', state: 'MEX'},
    'Pajacuarán': {municipality: '062', state: 'MIC'},
    'Natividad': {municipality: '062', state: 'OAX'},
    'Epatlán': {municipality: '062', state: 'PUE'},
    'Suaqui Grande': {municipality: '062', state: 'SON'},
    'Chocamán': {municipality: '062', state: 'VER'},
    'Sacalum': {municipality: '062', state: 'YUC'},
    'Temósachic': {municipality: '063', state: 'CHH'},
    'Osumacinta': {municipality: '063', state: 'CHP'},
    'Tlacoapa': {municipality: '063', state: 'GRO'},
    'Tepeji del Río de Ocampo': {municipality: '063', state: 'HID'},
    'Ocotlán': {municipality: '063', state: 'JAL'},
    'Ocuilan': {municipality: '063', state: 'MEX'},
    'Panindícuaro': {municipality: '063', state: 'MIC'},
    'Nazareno Etla': {municipality: '063', state: 'OAX'},
    'Esperanza': {municipality: '063', state: 'PUE'},
    'Tepache': {municipality: '063', state: 'SON'},
    'Chontla': {municipality: '063', state: 'VER'},
    'Samahil': {municipality: '063', state: 'YUC'},
    'El Tule': {municipality: '064', state: 'CHH'},
    'Oxchuc': {municipality: '064', state: 'CHP'},
    'Tlalchapa': {municipality: '064', state: 'GRO'},
    'Tepetitlán': {municipality: '064', state: 'HID'},
    'Ojuelos de Jalisco': {municipality: '064', state: 'JAL'},
    //'El Oro': {municipality: '064', state: 'MEX'},
    'Parácuaro': {municipality: '064', state: 'MIC'},
    'Nejapa de Madero': {municipality: '064', state: 'OAX'},
    'Francisco Z. Mena': {municipality: '064', state: 'PUE'},
    'Trincheras': {municipality: '064', state: 'SON'},
    'Chumatlán': {municipality: '064', state: 'VER'},
    'Sanahcat': {municipality: '064', state: 'YUC'},
    'Urique': {municipality: '065', state: 'CHH'},
    'Palenque': {municipality: '065', state: 'CHP'},
    'Tlalixtaquilla de Maldonado': {municipality: '065', state: 'GRO'},
    'Tetepango': {municipality: '065', state: 'HID'},
    'Pihuamo': {municipality: '065', state: 'JAL'},
    'Otumba': {municipality: '065', state: 'MEX'},
    'Paracho': {municipality: '065', state: 'MIC'},
    'Ixpantepec Nieves': {municipality: '065', state: 'OAX'},
    'General Felipe Ángeles': {municipality: '065', state: 'PUE'},
    'Tubutama': {municipality: '065', state: 'SON'},
    //'Emiliano Zapata': {municipality: '065', state: 'VER'},
    //'San Felipe': {municipality: '065', state: 'YUC'},
    'Uruachi': {municipality: '066', state: 'CHH'},
    'Pantelhó': {municipality: '066', state: 'CHP'},
    'Tlapa de Comonfort': {municipality: '066', state: 'GRO'},
    'Villa de Tezontepec': {municipality: '066', state: 'HID'},
    'Poncitlán': {municipality: '066', state: 'JAL'},
    'Otzoloapan': {municipality: '066', state: 'MEX'},
    'Pátzcuaro': {municipality: '066', state: 'MIC'},
    'Santiago Niltepec': {municipality: '066', state: 'OAX'},
    //'Guadalupe': {municipality: '066', state: 'PUE'},
    'Ures': {municipality: '066', state: 'SON'},
    'Espinal': {municipality: '066', state: 'VER'},
    'Santa Elena': {municipality: '066', state: 'YUC'},
    'Valle de Zaragoza': {municipality: '067', state: 'CHH'},
    'Pantepec': {municipality: '067', state: 'CHP'},
    'Tlapehuala': {municipality: '067', state: 'GRO'},
    'Tezontepec de Aldama': {municipality: '067', state: 'HID'},
    'Puerto Vallarta': {municipality: '067', state: 'JAL'},
    'Otzolotepec': {municipality: '067', state: 'MEX'},
    'Penjamillo': {municipality: '067', state: 'MIC'},
    'Oaxaca de Juárez': {municipality: '067', state: 'OAX'},
    //'Guadalupe Victoria': {municipality: '067', state: 'PUE'},
    //'Villa Hidalgo': {municipality: '067', state: 'SON'},
    'Filomeno Mata': {municipality: '067', state: 'VER'},
    'Seyé': {municipality: '067', state: 'YUC'},
    'Pichucalco': {municipality: '068', state: 'CHP'},
    'La Unión de Isidoro Montes de Oca': {municipality: '068', state: 'GRO'},
    'Tianguistengo': {municipality: '068', state: 'HID'},
    'Villa Purificación': {municipality: '068', state: 'JAL'},
    'Ozumba': {municipality: '068', state: 'MEX'},
    'Peribán': {municipality: '068', state: 'MIC'},
    'Ocotlán de Morelos': {municipality: '068', state: 'OAX'},
    'Hermenegildo Galeana': {municipality: '068', state: 'PUE'},
    'Villa Pesqueira': {municipality: '068', state: 'SON'},
    'Fortín': {municipality: '068', state: 'VER'},
    'Sinanché': {municipality: '068', state: 'YUC'},
    'Pijijiapan': {municipality: '069', state: 'CHP'},
    'Xalpatláhuac': {municipality: '069', state: 'GRO'},
    'Tizayuca': {municipality: '069', state: 'HID'},
    'Quitupan': {municipality: '069', state: 'JAL'},
    'Papalotla': {municipality: '069', state: 'MEX'},
    'La Piedad': {municipality: '069', state: 'MIC'},
    'La Pe': {municipality: '069', state: 'OAX'},
    'Huaquechula': {municipality: '069', state: 'PUE'},
    'Yécora': {municipality: '069', state: 'SON'},
    'Gutiérrez Zamora': {municipality: '069', state: 'VER'},
    'Sotuta': {municipality: '069', state: 'YUC'},
    'El Porvenir': {municipality: '070', state: 'CHP'},
    'Xochihuehuetlán': {municipality: '070', state: 'GRO'},
    'Tlahuelilpan': {municipality: '070', state: 'HID'},
    'El Salto': {municipality: '070', state: 'JAL'},
    //'La Paz': {municipality: '070', state: 'MEX'},
    'Purépero': {municipality: '070', state: 'MIC'},
    'Pinotepa de Don Luis': {municipality: '070', state: 'OAX'},
    'Huatlatlauca': {municipality: '070', state: 'PUE'},
    'General Plutarco Elías Calles': {municipality: '070', state: 'SON'},
    'Hidalgotitlán': {municipality: '070', state: 'VER'},
    'Sucilá': {municipality: '070', state: 'YUC'},
    'Villa Comaltitlán': {municipality: '071', state: 'CHP'},
    'Xochistlahuaca': {municipality: '071', state: 'GRO'},
    'Tlahuiltepa': {municipality: '071', state: 'HID'},
    'San Cristóbal de la Barranca': {municipality: '071', state: 'JAL'},
    'Polotitlán': {municipality: '071', state: 'MEX'},
    'Puruándiro': {municipality: '071', state: 'MIC'},
    'Pluma Hidalgo': {municipality: '071', state: 'OAX'},
    'Huauchinango': {municipality: '071', state: 'PUE'},
    //'Benito Juárez': {municipality: '071', state: 'SON'},
    'Huatusco': {municipality: '071', state: 'VER'},
    'Sudzal': {municipality: '071', state: 'YUC'},
    'Pueblo Nuevo Solistahuacán': {municipality: '072', state: 'CHP'},
    'Zapotitlán Tablas': {municipality: '072', state: 'GRO'},
    'Tlanalapa': {municipality: '072', state: 'HID'},
    'San Diego de Alejandría': {municipality: '072', state: 'JAL'},
    //'Rayón': {municipality: '072', state: 'MEX'},
    'Queréndaro': {municipality: '072', state: 'MIC'},
    'San José del Progreso': {municipality: '072', state: 'OAX'},
    //'Huehuetla': {municipality: '072', state: 'PUE'},
    'San Ignacio Río Muerto': {municipality: '072', state: 'SON'},
    'Huayacocotla': {municipality: '072', state: 'VER'},
    'Suma': {municipality: '072', state: 'YUC'},
    //'Rayón': {municipality: '073', state: 'CHP'},
    'Zirándaro': {municipality: '073', state: 'GRO'},
    'Tlanchinol': {municipality: '073', state: 'HID'},
    'San Juan de los Lagos': {municipality: '073', state: 'JAL'},
    'San Antonio la Isla': {municipality: '073', state: 'MEX'},
    'Quiroga': {municipality: '073', state: 'MIC'},
    'Putla Villa de Guerrero': {municipality: '073', state: 'OAX'},
    'Huehuetlán el Chico': {municipality: '073', state: 'PUE'},
    'Hueyapan de Ocampo': {municipality: '073', state: 'VER'},
    'Tahdziú': {municipality: '073', state: 'YUC'},
    'Reforma': {municipality: '074', state: 'CHP'},
    'Zitlala': {municipality: '074', state: 'GRO'},
    'Tlaxcoapan': {municipality: '074', state: 'HID'},
    'San Julián': {municipality: '074', state: 'JAL'},
    'San Felipe del Progreso': {municipality: '074', state: 'MEX'},
    'Cojumatlán de Régules': {municipality: '074', state: 'MIC'},
    'Santa Catarina Quioquitani': {municipality: '074', state: 'OAX'},
    'Huejotzingo': {municipality: '074', state: 'PUE'},
    'Huiloapan de Cuauhtémoc': {municipality: '074', state: 'VER'},
    'Tahmek': {municipality: '074', state: 'YUC'},
    'Las Rosas': {municipality: '075', state: 'CHP'},
    'Eduardo Neri': {municipality: '075', state: 'GRO'},
    'Tolcayuca': {municipality: '075', state: 'HID'},
    //'San Marcos': {municipality: '075', state: 'JAL'},
    'San Martín de las Pirámides': {municipality: '075', state: 'MEX'},
    'Los Reyes': {municipality: '075', state: 'MIC'},
    'Reforma de Pineda': {municipality: '075', state: 'OAX'},
    'Hueyapan': {municipality: '075', state: 'PUE'},
    'Ignacio de la Llave': {municipality: '075', state: 'VER'},
    'Teabo': {municipality: '075', state: 'YUC'},
    'Sabanilla': {municipality: '076', state: 'CHP'},
    'Acatepec': {municipality: '076', state: 'GRO'},
    'Tula de Allende': {municipality: '076', state: 'HID'},
    'San Martín de Bolaños': {municipality: '076', state: 'JAL'},
    'San Mateo Atenco': {municipality: '076', state: 'MEX'},
    'Sahuayo': {municipality: '076', state: 'MIC'},
    'La Reforma': {municipality: '076', state: 'OAX'},
    'Hueytamalco': {municipality: '076', state: 'PUE'},
    'Ilamatlán': {municipality: '076', state: 'VER'},
    'Tecoh': {municipality: '076', state: 'YUC'},
    'Salto de Agua': {municipality: '077', state: 'CHP'},
    'Marquelia': {municipality: '077', state: 'GRO'},
    'Tulancingo de Bravo': {municipality: '077', state: 'HID'},
    'San Martín Hidalgo': {municipality: '077', state: 'JAL'},
    'San Simón de Guerrero': {municipality: '077', state: 'MEX'},
    'San Lucas': {municipality: '077', state: 'MIC'},
    'Reyes Etla': {municipality: '077', state: 'OAX'},
    'Hueytlalpan': {municipality: '077', state: 'PUE'},
    'Isla': {municipality: '077', state: 'VER'},
    'Tekal de Venegas': {municipality: '077', state: 'YUC'},
    'San Cristóbal de las Casas': {municipality: '078', state: 'CHP'},
    'Cochoapa el Grande': {municipality: '078', state: 'GRO'},
    'Xochiatipan': {municipality: '078', state: 'HID'},
    'San Miguel el Alto': {municipality: '078', state: 'JAL'},
    'Santo Tomás': {municipality: '078', state: 'MEX'},
    'Santa Ana Maya': {municipality: '078', state: 'MIC'},
    'Rojas de Cuauhtémoc': {municipality: '078', state: 'OAX'},
    'Huitzilan de Serdán': {municipality: '078', state: 'PUE'},
    'Ixcatepec': {municipality: '078', state: 'VER'},
    'Tekantó': {municipality: '078', state: 'YUC'},
    //'San Fernando': {municipality: '079', state: 'CHP'},
    'José Joaquín de Herrera': {municipality: '079', state: 'GRO'},
    'Xochicoatlán': {municipality: '079', state: 'HID'},
    //'Gómez Farías': {municipality: '079', state: 'JAL'},
    'Soyaniquilpan de Juárez': {municipality: '079', state: 'MEX'},
    'Salvador Escalante': {municipality: '079', state: 'MIC'},
    'Salina Cruz': {municipality: '079', state: 'OAX'},
    'Huitziltepec': {municipality: '079', state: 'PUE'},
    'Ixhuacán de los Reyes': {municipality: '079', state: 'VER'},
    'Tekax': {municipality: '079', state: 'YUC'},
    'Siltepec': {municipality: '080', state: 'CHP'},
    'Juchitán': {municipality: '080', state: 'GRO'},
    'Yahualica': {municipality: '080', state: 'HID'},
    'San Sebastián del Oeste': {municipality: '080', state: 'JAL'},
    'Sultepec': {municipality: '080', state: 'MEX'},
    'Senguio': {municipality: '080', state: 'MIC'},
    'San Agustín Amatengo': {municipality: '080', state: 'OAX'},
    'Atlequizayan': {municipality: '080', state: 'PUE'},
    'Ixhuatlán del Café': {municipality: '080', state: 'VER'},
    'Tekit': {municipality: '080', state: 'YUC'},
    'Simojovel': {municipality: '081', state: 'CHP'},
    'Iliatenco': {municipality: '081', state: 'GRO'},
    'Zacualtipán de Ángeles': {municipality: '081', state: 'HID'},
    'Santa María de los Ángeles': {municipality: '081', state: 'JAL'},
    'Tecámac': {municipality: '081', state: 'MEX'},
    'Susupuato': {municipality: '081', state: 'MIC'},
    'San Agustín Atenango': {municipality: '081', state: 'OAX'},
    'Ixcamilpa de Guerrero': {municipality: '081', state: 'PUE'},
    'Ixhuatlancillo': {municipality: '081', state: 'VER'},
    'Tekom': {municipality: '081', state: 'YUC'},
    'Sitalá': {municipality: '082', state: 'CHP'},
    'Zapotlán de Juárez': {municipality: '082', state: 'HID'},
    'Sayula': {municipality: '082', state: 'JAL'},
    'Tejupilco': {municipality: '082', state: 'MEX'},
    'Tacámbaro': {municipality: '082', state: 'MIC'},
    'San Agustín Chayuco': {municipality: '082', state: 'OAX'},
    'Ixcaquixtla': {municipality: '082', state: 'PUE'},
    'Ixhuatlán del Sureste': {municipality: '082', state: 'VER'},
    'Telchac Pueblo': {municipality: '082', state: 'YUC'},
    'Socoltenango': {municipality: '083', state: 'CHP'},
    'Zempoala': {municipality: '083', state: 'HID'},
    'Tala': {municipality: '083', state: 'JAL'},
    'Temamatla': {municipality: '083', state: 'MEX'},
    'Tancítaro': {municipality: '083', state: 'MIC'},
    'San Agustín de las Juntas': {municipality: '083', state: 'OAX'},
    'Ixtacamaxtitlán': {municipality: '083', state: 'PUE'},
    'Ixhuatlán de Madero': {municipality: '083', state: 'VER'},
    'Telchac Puerto': {municipality: '083', state: 'YUC'},
    'Solosuchiapa': {municipality: '084', state: 'CHP'},
    'Zimapán': {municipality: '084', state: 'HID'},
    'Talpa de Allende': {municipality: '084', state: 'JAL'},
    'Temascalapa': {municipality: '084', state: 'MEX'},
    'Tangamandapio': {municipality: '084', state: 'MIC'},
    'San Agustín Etla': {municipality: '084', state: 'OAX'},
    'Ixtepec': {municipality: '084', state: 'PUE'},
    'Ixmatlahuacan': {municipality: '084', state: 'VER'},
    'Temax': {municipality: '084', state: 'YUC'},
    'Soyaló': {municipality: '085', state: 'CHP'},
    'Tamazula de Gordiano': {municipality: '085', state: 'JAL'},
    'Temascalcingo': {municipality: '085', state: 'MEX'},
    'Tangancícuaro': {municipality: '085', state: 'MIC'},
    'San Agustín Loxicha': {municipality: '085', state: 'OAX'},
    'Izúcar de Matamoros': {municipality: '085', state: 'PUE'},
    'Ixtaczoquitlán': {municipality: '085', state: 'VER'},
    'Temozón': {municipality: '085', state: 'YUC'},
    'Suchiapa': {municipality: '086', state: 'CHP'},
    'Tapalpa': {municipality: '086', state: 'JAL'},
    'Temascaltepec': {municipality: '086', state: 'MEX'},
    'Tanhuato': {municipality: '086', state: 'MIC'},
    'San Agustín Tlacotepec': {municipality: '086', state: 'OAX'},
    'Jalpan': {municipality: '086', state: 'PUE'},
    'Jalacingo': {municipality: '086', state: 'VER'},
    'Tepakán': {municipality: '086', state: 'YUC'},
    'Suchiate': {municipality: '087', state: 'CHP'},
    'Tecalitlán': {municipality: '087', state: 'JAL'},
    'Temoaya': {municipality: '087', state: 'MEX'},
    'Taretan': {municipality: '087', state: 'MIC'},
    'San Agustín Yatareni': {municipality: '087', state: 'OAX'},
    'Jolalpan': {municipality: '087', state: 'PUE'},
    'Xalapa': {municipality: '087', state: 'VER'},
    'Tetiz': {municipality: '087', state: 'YUC'},
    'Sunuapa': {municipality: '088', state: 'CHP'},
    'Tecolotlán': {municipality: '088', state: 'JAL'},
    //'Tenancingo': {municipality: '088', state: 'MEX'},
    'Tarímbaro': {municipality: '088', state: 'MIC'},
    'San Andrés Cabecera Nueva': {municipality: '088', state: 'OAX'},
    'Jonotla': {municipality: '088', state: 'PUE'},
    'Jalcomulco': {municipality: '088', state: 'VER'},
    'Teya': {municipality: '088', state: 'YUC'},
    'Tapachula': {municipality: '089', state: 'CHP'},
    'Techaluta de Montenegro': {municipality: '089', state: 'JAL'},
    'Tenango del Aire': {municipality: '089', state: 'MEX'},
    'Tepalcatepec': {municipality: '089', state: 'MIC'},
    'San Andrés Dinicuiti': {municipality: '089', state: 'OAX'},
    'Jopala': {municipality: '089', state: 'PUE'},
    'Jáltipan': {municipality: '089', state: 'VER'},
    'Ticul': {municipality: '089', state: 'YUC'},
    'Tapalapa': {municipality: '090', state: 'CHP'},
    'Tenamaxtlán': {municipality: '090', state: 'JAL'},
    'Tenango del Valle': {municipality: '090', state: 'MEX'},
    'Tingambato': {municipality: '090', state: 'MIC'},
    'San Andrés Huaxpaltepec': {municipality: '090', state: 'OAX'},
    'Juan C. Bonilla': {municipality: '090', state: 'PUE'},
    'Jamapa': {municipality: '090', state: 'VER'},
    'Timucuy': {municipality: '090', state: 'YUC'},
    'Tapilula': {municipality: '091', state: 'CHP'},
    'Teocaltiche': {municipality: '091', state: 'JAL'},
    'Teoloyucan': {municipality: '091', state: 'MEX'},
    'Tingüindín': {municipality: '091', state: 'MIC'},
    'San Andrés Huayápam': {municipality: '091', state: 'OAX'},
    'Juan Galindo': {municipality: '091', state: 'PUE'},
    'Jesús Carranza': {municipality: '091', state: 'VER'},
    'Tinum': {municipality: '091', state: 'YUC'},
    'Tecpatán': {municipality: '092', state: 'CHP'},
    'Teocuitatlán de Corona': {municipality: '092', state: 'JAL'},
    'Teotihuacán': {municipality: '092', state: 'MEX'},
    'Tiquicheo de Nicolás Romero': {municipality: '092', state: 'MIC'},
    'San Andrés Ixtlahuaca': {municipality: '092', state: 'OAX'},
    'Juan N. Méndez': {municipality: '092', state: 'PUE'},
    'Xico': {municipality: '092', state: 'VER'},
    'Tixcacalcupul': {municipality: '092', state: 'YUC'},
    'Tenejapa': {municipality: '093', state: 'CHP'},
    'Tepatitlán de Morelos': {municipality: '093', state: 'JAL'},
    'Tepetlaoxtoc': {municipality: '093', state: 'MEX'},
    'Tlalpujahua': {municipality: '093', state: 'MIC'},
    'San Andrés Lagunas': {municipality: '093', state: 'OAX'},
    'Lafragua': {municipality: '093', state: 'PUE'},
    //'Jilotepec': {municipality: '093', state: 'VER'},
    'Tixkokob': {municipality: '093', state: 'YUC'},
    'Teopisca': {municipality: '094', state: 'CHP'},
    'Tequila': {municipality: '094', state: 'JAL'},
    'Tepetlixpa': {municipality: '094', state: 'MEX'},
    'Tlazazalca': {municipality: '094', state: 'MIC'},
    'San Andrés Nuxiño': {municipality: '094', state: 'OAX'},
    'Libres': {municipality: '094', state: 'PUE'},
    'Juan Rodríguez Clara': {municipality: '094', state: 'VER'},
    'Tixmehuac': {municipality: '094', state: 'YUC'},
    'Teuchitlán': {municipality: '095', state: 'JAL'},
    'Tepotzotlán': {municipality: '095', state: 'MEX'},
    'Tocumbo': {municipality: '095', state: 'MIC'},
    'San Andrés Paxtlán': {municipality: '095', state: 'OAX'},
    'La Magdalena Tlatlauquitepec': {municipality: '095', state: 'PUE'},
    'Juchique de Ferrer': {municipality: '095', state: 'VER'},
    'Tixpéhual': {municipality: '095', state: 'YUC'},
    'Tila': {municipality: '096', state: 'CHP'},
    'Tizapán el Alto': {municipality: '096', state: 'JAL'},
    'Tequixquiac': {municipality: '096', state: 'MEX'},
    'Tumbiscatío': {municipality: '096', state: 'MIC'},
    'San Andrés Sinaxtla': {municipality: '096', state: 'OAX'},
    'Mazapiltepec de Juárez': {municipality: '096', state: 'PUE'},
    'Landero y Coss': {municipality: '096', state: 'VER'},
    'Tizimín': {municipality: '096', state: 'YUC'},
    'Tonalá': {municipality: '097', state: 'CHP'},
    'Tlajomulco de Zúñiga': {municipality: '097', state: 'JAL'},
    'Texcaltitlán': {municipality: '097', state: 'MEX'},
    'Turicato': {municipality: '097', state: 'MIC'},
    'San Andrés Solaga': {municipality: '097', state: 'OAX'},
    'Mixtla': {municipality: '097', state: 'PUE'},
    'Lerdo de Tejada': {municipality: '097', state: 'VER'},
    'Tunkás': {municipality: '097', state: 'YUC'},
    'Totolapa': {municipality: '098', state: 'CHP'},
    'San Pedro Tlaquepaque': {municipality: '098', state: 'JAL'},
    'Texcalyacac': {municipality: '098', state: 'MEX'},
    //'Tuxpan': {municipality: '098', state: 'MIC'},
    'San Andrés Teotilálpam': {municipality: '098', state: 'OAX'},
    'Molcaxac': {municipality: '098', state: 'PUE'},
    //'Magdalena': {municipality: '098', state: 'VER'},
    'Tzucacab': {municipality: '098', state: 'YUC'},
    'La Trinitaria': {municipality: '099', state: 'CHP'},
    //'Tolimán': {municipality: '099', state: 'JAL'},
    'Texcoco': {municipality: '099', state: 'MEX'},
    'Tuzantla': {municipality: '099', state: 'MIC'},
    'San Andrés Tepetlapa': {municipality: '099', state: 'OAX'},
    'Cañada Morelos': {municipality: '099', state: 'PUE'},
    'Maltrata': {municipality: '099', state: 'VER'},
    'Uayma': {municipality: '099', state: 'YUC'},
    'Tumbalá': {municipality: '100', state: 'CHP'},
    'Tomatlán': {municipality: '100', state: 'JAL'},
    'Tezoyuca': {municipality: '100', state: 'MEX'},
    'Tzintzuntzan': {municipality: '100', state: 'MIC'},
    'San Andrés Yaá': {municipality: '100', state: 'OAX'},
    'Naupan': {municipality: '100', state: 'PUE'},
    'Manlio Fabio Altamirano': {municipality: '100', state: 'VER'},
    'Ucú': {municipality: '100', state: 'YUC'},
    'Tuxtla Gutiérrez': {municipality: '101', state: 'CHP'},
    //'Tonalá': {municipality: '101', state: 'JAL'},
    'Tianguistenco': {municipality: '101', state: 'MEX'},
    'Tzitzio': {municipality: '101', state: 'MIC'},
    'San Andrés Zabache': {municipality: '101', state: 'OAX'},
    'Nauzontla': {municipality: '101', state: 'PUE'},
    'Mariano Escobedo': {municipality: '101', state: 'VER'},
    'Umán': {municipality: '101', state: 'YUC'},
    'Tuxtla Chico': {municipality: '102', state: 'CHP'},
    'Tonaya': {municipality: '102', state: 'JAL'},
    'Timilpan': {municipality: '102', state: 'MEX'},
    'Uruapan': {municipality: '102', state: 'MIC'},
    'San Andrés Zautla': {municipality: '102', state: 'OAX'},
    'Nealtican': {municipality: '102', state: 'PUE'},
    'Martínez de la Torre': {municipality: '102', state: 'VER'},
    'Valladolid': {municipality: '102', state: 'YUC'},
    'Tuzantán': {municipality: '103', state: 'CHP'},
    'Tonila': {municipality: '103', state: 'JAL'},
    'Tlalmanalco': {municipality: '103', state: 'MEX'},
    //'Venustiano Carranza': {municipality: '103', state: 'MIC'},
    'San Antonino Castillo Velasco': {municipality: '103', state: 'OAX'},
    'Nicolás Bravo': {municipality: '103', state: 'PUE'},
    'Mecatlán': {municipality: '103', state: 'VER'},
    'Xocchel': {municipality: '103', state: 'YUC'},
    'Tzimol': {municipality: '104', state: 'CHP'},
    'Totatiche': {municipality: '104', state: 'JAL'},
    'Tlalnepantla de Baz': {municipality: '104', state: 'MEX'},
    'Villamar': {municipality: '104', state: 'MIC'},
    'San Antonino el Alto': {municipality: '104', state: 'OAX'},
    'Nopalucan': {municipality: '104', state: 'PUE'},
    'Mecayapan': {municipality: '104', state: 'VER'},
    'Yaxcabá': {municipality: '104', state: 'YUC'},
    'Unión Juárez': {municipality: '105', state: 'CHP'},
    'Tototlán': {municipality: '105', state: 'JAL'},
    'Tlatlaya': {municipality: '105', state: 'MEX'},
    'Vista Hermosa': {municipality: '105', state: 'MIC'},
    'San Antonino Monte Verde': {municipality: '105', state: 'OAX'},
    //'Ocotepec': {municipality: '105', state: 'PUE'},
    'Medellín': {municipality: '105', state: 'VER'},
    'Yaxkukul': {municipality: '105', state: 'YUC'},
    //'Venustiano Carranza': {municipality: '106', state: 'CHP'},
    'Tuxcacuesco': {municipality: '106', state: 'JAL'},
    'Toluca': {municipality: '106', state: 'MEX'},
    'Yurécuaro': {municipality: '106', state: 'MIC'},
    'San Antonio Acutla': {municipality: '106', state: 'OAX'},
    'Ocoyucan': {municipality: '106', state: 'PUE'},
    'Miahuatlán': {municipality: '106', state: 'VER'},
    'Yobaín': {municipality: '106', state: 'YUC'},
    'Villa Corzo': {municipality: '107', state: 'CHP'},
    'Tuxcueca': {municipality: '107', state: 'JAL'},
    'Tonatico': {municipality: '107', state: 'MEX'},
    'Zacapu': {municipality: '107', state: 'MIC'},
    'San Antonio de la Cal': {municipality: '107', state: 'OAX'},
    'Olintla': {municipality: '107', state: 'PUE'},
    'Las Minas': {municipality: '107', state: 'VER'},
    'Villaflores': {municipality: '108', state: 'CHP'},
    //'Tuxpan': {municipality: '108', state: 'JAL'},
    'Tultepec': {municipality: '108', state: 'MEX'},
    'Zamora': {municipality: '108', state: 'MIC'},
    'San Antonio Huitepec': {municipality: '108', state: 'OAX'},
    'Oriental': {municipality: '108', state: 'PUE'},
    //'Minatitlán': {municipality: '108', state: 'VER'},
    'Yajalón': {municipality: '109', state: 'CHP'},
    'Unión de San Antonio': {municipality: '109', state: 'JAL'},
    'Tultitlán': {municipality: '109', state: 'MEX'},
    'Zináparo': {municipality: '109', state: 'MIC'},
    'San Antonio Nanahuatípam': {municipality: '109', state: 'OAX'},
    'Pahuatlán': {municipality: '109', state: 'PUE'},
    'Misantla': {municipality: '109', state: 'VER'},
    //'San Lucas': {municipality: '110', state: 'CHP'},
    'Unión de Tula': {municipality: '110', state: 'JAL'},
    'Valle de Bravo': {municipality: '110', state: 'MEX'},
    'Zinapécuaro': {municipality: '110', state: 'MIC'},
    'San Antonio Sinicahua': {municipality: '110', state: 'OAX'},
    'Palmar de Bravo': {municipality: '110', state: 'PUE'},
    'Mixtla de Altamirano': {municipality: '110', state: 'VER'},
    'Zinacantán': {municipality: '111', state: 'CHP'},
    'Valle de Guadalupe': {municipality: '111', state: 'JAL'},
    'Villa de Allende': {municipality: '111', state: 'MEX'},
    'Ziracuaretiro': {municipality: '111', state: 'MIC'},
    'San Antonio Tepetlapa': {municipality: '111', state: 'OAX'},
    //'Pantepec': {municipality: '111', state: 'PUE'},
    'Moloacán': {municipality: '111', state: 'VER'},
    'San Juan Cancuc': {municipality: '112', state: 'CHP'},
    'Valle de Juárez': {municipality: '112', state: 'JAL'},
    'Villa del Carbón': {municipality: '112', state: 'MEX'},
    'Zitácuaro': {municipality: '112', state: 'MIC'},
    'San Baltazar Chichicápam': {municipality: '112', state: 'OAX'},
    'Petlalcingo': {municipality: '112', state: 'PUE'},
    'Naolinco': {municipality: '112', state: 'VER'},
    //'Aldama': {municipality: '113', state: 'CHP'},
    'San Gabriel': {municipality: '113', state: 'JAL'},
    'Villa Guerrero': {municipality: '113', state: 'MEX'},
    'José Sixto Verduzco': {municipality: '113', state: 'MIC'},
    'San Baltazar Loxicha': {municipality: '113', state: 'OAX'},
    'Piaxtla': {municipality: '113', state: 'PUE'},
    'Naranjal': {municipality: '113', state: 'VER'},
    'Benemérito de las Américas': {municipality: '114', state: 'CHP'},
    'Villa Corona': {municipality: '114', state: 'JAL'},
    'Villa Victoria': {municipality: '114', state: 'MEX'},
    'San Baltazar Yatzachi el Bajo': {municipality: '114', state: 'OAX'},
    'Puebla': {municipality: '114', state: 'PUE'},
    'Nautla': {municipality: '114', state: 'VER'},
    'Maravilla Tenejapa': {municipality: '115', state: 'CHP'},
    //'Villa Guerrero': {municipality: '115', state: 'JAL'},
    'Xonacatlán': {municipality: '115', state: 'MEX'},
    'San Bartolo Coyotepec': {municipality: '115', state: 'OAX'},
    'Quecholac': {municipality: '115', state: 'PUE'},
    //'Nogales': {municipality: '115', state: 'VER'},
    'Marqués de Comillas': {municipality: '116', state: 'CHP'},
    //'Villa Hidalgo': {municipality: '116', state: 'JAL'},
    'Zacazonapan': {municipality: '116', state: 'MEX'},
    'San Bartolomé Ayautla': {municipality: '116', state: 'OAX'},
    'Quimixtlán': {municipality: '116', state: 'PUE'},
    'Oluta': {municipality: '116', state: 'VER'},
    'Montecristo de Guerrero': {municipality: '117', state: 'CHP'},
    'Cañadas de Obregón': {municipality: '117', state: 'JAL'},
    //'Zacualpan': {municipality: '117', state: 'MEX'},
    'San Bartolomé Loxicha': {municipality: '117', state: 'OAX'},
    'Rafael Lara Grajales': {municipality: '117', state: 'PUE'},
    'Omealca': {municipality: '117', state: 'VER'},
    'San Andrés Duraznal': {municipality: '118', state: 'CHP'},
    'Yahualica de González Gallo': {municipality: '118', state: 'JAL'},
    'Zinacantepec': {municipality: '118', state: 'MEX'},
    'San Bartolomé Quialana': {municipality: '118', state: 'OAX'},
    'Los Reyes de Juárez': {municipality: '118', state: 'PUE'},
    'Orizaba': {municipality: '118', state: 'VER'},
    'Santiago el Pinar': {municipality: '119', state: 'CHP'},
    'Zacoalco de Torres': {municipality: '119', state: 'JAL'},
    'Zumpahuacán': {municipality: '119', state: 'MEX'},
    'San Bartolomé Yucuañe': {municipality: '119', state: 'OAX'},
    'San Andrés Cholula': {municipality: '119', state: 'PUE'},
    'Otatitlán': {municipality: '119', state: 'VER'},
    'Zapopan': {municipality: '120', state: 'JAL'},
    'Zumpango': {municipality: '120', state: 'MEX'},
    'San Bartolomé Zoogocho': {municipality: '120', state: 'OAX'},
    'San Antonio Cañada': {municipality: '120', state: 'PUE'},
    'Oteapan': {municipality: '120', state: 'VER'},
    'Capitán Luis Ángel Vidal': {municipality: '120', state: 'CHP'},
    'Zapotiltic': {municipality: '121', state: 'JAL'},
    'Cuautitlán Izcalli': {municipality: '121', state: 'MEX'},
    'San Bartolo Soyaltepec': {municipality: '121', state: 'OAX'},
    'San Diego la Mesa Tochimiltzingo': {municipality: '121', state: 'PUE'},
    'Ozuluama de Mascareñas': {municipality: '121', state: 'VER'},
    'Rincón Chamula San Pedro': {municipality: '121', state: 'CHP'},
    'Zapotitlán de Vadillo': {municipality: '122', state: 'JAL'},
    'Valle de Chalco Solidaridad': {municipality: '122', state: 'MEX'},
    'San Bartolo Yautepec': {municipality: '122', state: 'OAX'},
    'San Felipe Teotlalcingo': {municipality: '122', state: 'PUE'},
    'Pajapan': {municipality: '122', state: 'VER'},
    'El Parral': {municipality: '122', state: 'CHP'},
    'Zapotlán del Rey': {municipality: '123', state: 'JAL'},
    'Luvianos': {municipality: '123', state: 'MEX'},
    'San Bernardo Mixtepec': {municipality: '123', state: 'OAX'},
    'San Felipe Tepatlán': {municipality: '123', state: 'PUE'},
    //'Pánuco': {municipality: '123', state: 'VER'},
    //'Emiliano Zapata': {municipality: '123', state: 'CHP'},
    'Zapotlanejo': {municipality: '124', state: 'JAL'},
    'San José del Rincón': {municipality: '124', state: 'MEX'},
    'San Blas Atempa': {municipality: '124', state: 'OAX'},
    'San Gabriel Chilac': {municipality: '124', state: 'PUE'},
    'Papantla': {municipality: '124', state: 'VER'},
    'Mezcalapa': {municipality: '124', state: 'CHP'},
    'San Ignacio Cerro Gordo': {municipality: '125', state: 'JAL'},
    'Tonanitla': {municipality: '125', state: 'MEX'},
    'San Carlos Yautepec': {municipality: '125', state: 'OAX'},
    'San Gregorio Atzompa': {municipality: '125', state: 'PUE'},
    'Paso del Macho': {municipality: '125', state: 'VER'},
    'San Cristóbal Amatlán': {municipality: '126', state: 'OAX'},
    'San Jerónimo Tecuanipan': {municipality: '126', state: 'PUE'},
    'Paso de Ovejas': {municipality: '126', state: 'VER'},
    'San Cristóbal Amoltepec': {municipality: '127', state: 'OAX'},
    'San Jerónimo Xayacatlán': {municipality: '127', state: 'PUE'},
    'La Perla': {municipality: '127', state: 'VER'},
    'San Cristóbal Lachirioag': {municipality: '128', state: 'OAX'},
    'San José Chiapa': {municipality: '128', state: 'PUE'},
    'Perote': {municipality: '128', state: 'VER'},
    'San Cristóbal Suchixtlahuaca': {municipality: '129', state: 'OAX'},
    'San José Miahuatlán': {municipality: '129', state: 'PUE'},
    'Platón Sánchez': {municipality: '129', state: 'VER'},
    'San Dionisio del Mar': {municipality: '130', state: 'OAX'},
    'San Juan Atenco': {municipality: '130', state: 'PUE'},
    'Playa Vicente': {municipality: '130', state: 'VER'},
    'San Dionisio Ocotepec': {municipality: '131', state: 'OAX'},
    'San Juan Atzompa': {municipality: '131', state: 'PUE'},
    'Poza Rica de Hidalgo': {municipality: '131', state: 'VER'},
    'San Dionisio Ocotlán': {municipality: '132', state: 'OAX'},
    'San Martín Texmelucan': {municipality: '132', state: 'PUE'},
    'Las Vigas de Ramírez': {municipality: '132', state: 'VER'},
    'San Esteban Atatlahuca': {municipality: '133', state: 'OAX'},
    'San Martín Totoltepec': {municipality: '133', state: 'PUE'},
    'Pueblo Viejo': {municipality: '133', state: 'VER'},
    'San Felipe Jalapa de Díaz': {municipality: '134', state: 'OAX'},
    'San Matías Tlalancaleca': {municipality: '134', state: 'PUE'},
    'Puente Nacional': {municipality: '134', state: 'VER'},
    'San Felipe Tejalápam': {municipality: '135', state: 'OAX'},
    'San Miguel Ixitlán': {municipality: '135', state: 'PUE'},
    'Rafael Delgado': {municipality: '135', state: 'VER'},
    'San Felipe Usila': {municipality: '136', state: 'OAX'},
    'San Miguel Xoxtla': {municipality: '136', state: 'PUE'},
    'Rafael Lucio': {municipality: '136', state: 'VER'},
    'San Francisco Cahuacuá': {municipality: '137', state: 'OAX'},
    'San Nicolás Buenos Aires': {municipality: '137', state: 'PUE'},
    //'Los Reyes': {municipality: '137', state: 'VER'},
    'San Francisco Cajonos': {municipality: '138', state: 'OAX'},
    'San Nicolás de los Ranchos': {municipality: '138', state: 'PUE'},
    'Río Blanco': {municipality: '138', state: 'VER'},
    'San Francisco Chapulapa': {municipality: '139', state: 'OAX'},
    'San Pablo Anicano': {municipality: '139', state: 'PUE'},
    'Saltabarranca': {municipality: '139', state: 'VER'},
    'San Francisco Chindúa': {municipality: '140', state: 'OAX'},
    'San Pedro Cholula': {municipality: '140', state: 'PUE'},
    'San Andrés Tenejapan': {municipality: '140', state: 'VER'},
    'San Francisco del Mar': {municipality: '141', state: 'OAX'},
    'San Pedro Yeloixtlahuaca': {municipality: '141', state: 'PUE'},
    'San Andrés Tuxtla': {municipality: '141', state: 'VER'},
    'San Francisco Huehuetlán': {municipality: '142', state: 'OAX'},
    'San Salvador el Seco': {municipality: '142', state: 'PUE'},
    'San Juan Evangelista': {municipality: '142', state: 'VER'},
    'San Francisco Ixhuatán': {municipality: '143', state: 'OAX'},
    'San Salvador el Verde': {municipality: '143', state: 'PUE'},
    'Santiago Tuxtla': {municipality: '143', state: 'VER'},
    'San Francisco Jaltepetongo': {municipality: '144', state: 'OAX'},
    'San Salvador Huixcolotla': {municipality: '144', state: 'PUE'},
    'Sayula de Alemán': {municipality: '144', state: 'VER'},
    'San Francisco Lachigoló': {municipality: '145', state: 'OAX'},
    'San Sebastián Tlacotepec': {municipality: '145', state: 'PUE'},
    'Soconusco': {municipality: '145', state: 'VER'},
    'San Francisco Logueche': {municipality: '146', state: 'OAX'},
    'Santa Catarina Tlaltempan': {municipality: '146', state: 'PUE'},
    'Sochiapa': {municipality: '146', state: 'VER'},
    'San Francisco Nuxaño': {municipality: '147', state: 'OAX'},
    'Santa Inés Ahuatempan': {municipality: '147', state: 'PUE'},
    'Soledad Atzompa': {municipality: '147', state: 'VER'},
    'San Francisco Ozolotepec': {municipality: '148', state: 'OAX'},
    'Santa Isabel Cholula': {municipality: '148', state: 'PUE'},
    'Soledad de Doblado': {municipality: '148', state: 'VER'},
    'San Francisco Sola': {municipality: '149', state: 'OAX'},
    'Santiago Miahuatlán': {municipality: '149', state: 'PUE'},
    'Soteapan': {municipality: '149', state: 'VER'},
    'San Francisco Telixtlahuaca': {municipality: '150', state: 'OAX'},
    'Huehuetlán el Grande': {municipality: '150', state: 'PUE'},
    'Tamalín': {municipality: '150', state: 'VER'},
    'San Francisco Teopan': {municipality: '151', state: 'OAX'},
    'Santo Tomás Hueyotlipan': {municipality: '151', state: 'PUE'},
    'Tamiahua': {municipality: '151', state: 'VER'},
    'San Francisco Tlapancingo': {municipality: '152', state: 'OAX'},
    'Soltepec': {municipality: '152', state: 'PUE'},
    'Tampico Alto': {municipality: '152', state: 'VER'},
    'San Gabriel Mixtepec': {municipality: '153', state: 'OAX'},
    'Tecali de Herrera': {municipality: '153', state: 'PUE'},
    'Tancoco': {municipality: '153', state: 'VER'},
    'San Ildefonso Amatlán': {municipality: '154', state: 'OAX'},
    'Tecamachalco': {municipality: '154', state: 'PUE'},
    'Tantima': {municipality: '154', state: 'VER'},
    'San Ildefonso Sola': {municipality: '155', state: 'OAX'},
    'Tecomatlán': {municipality: '155', state: 'PUE'},
    'Tantoyuca': {municipality: '155', state: 'VER'},
    'San Ildefonso Villa Alta': {municipality: '156', state: 'OAX'},
    'Tehuacán': {municipality: '156', state: 'PUE'},
    'Tatatila': {municipality: '156', state: 'VER'},
    'San Jacinto Amilpas': {municipality: '157', state: 'OAX'},
    'Tehuitzingo': {municipality: '157', state: 'PUE'},
    'Castillo de Teayo': {municipality: '157', state: 'VER'},
    'San Jacinto Tlacotepec': {municipality: '158', state: 'OAX'},
    'Tenampulco': {municipality: '158', state: 'PUE'},
    'Tecolutla': {municipality: '158', state: 'VER'},
    'San Jerónimo Coatlán': {municipality: '159', state: 'OAX'},
    'Teopantlán': {municipality: '159', state: 'PUE'},
    'Tehuipango': {municipality: '159', state: 'VER'},
    'San Jerónimo Silacayoapilla': {municipality: '160', state: 'OAX'},
    'Teotlalco': {municipality: '160', state: 'PUE'},
    'Álamo Temapache': {municipality: '160', state: 'VER'},
    'San Jerónimo Sosola': {municipality: '161', state: 'OAX'},
    'Tepanco de López': {municipality: '161', state: 'PUE'},
    'Tempoal': {municipality: '161', state: 'VER'},
    'San Jerónimo Taviche': {municipality: '162', state: 'OAX'},
    'Tepango de Rodríguez': {municipality: '162', state: 'PUE'},
    'Tenampa': {municipality: '162', state: 'VER'},
    'San Jerónimo Tecóatl': {municipality: '163', state: 'OAX'},
    'Tepatlaxco de Hidalgo': {municipality: '163', state: 'PUE'},
    'Tenochtitlán': {municipality: '163', state: 'VER'},
    'San Jorge Nuchita': {municipality: '164', state: 'OAX'},
    'Tepeaca': {municipality: '164', state: 'PUE'},
    'Teocelo': {municipality: '164', state: 'VER'},
    'San José Ayuquila': {municipality: '165', state: 'OAX'},
    'Tepemaxalco': {municipality: '165', state: 'PUE'},
    'Tepatlaxco': {municipality: '165', state: 'VER'},
    'San José Chiltepec': {municipality: '166', state: 'OAX'},
    'Tepeojuma': {municipality: '166', state: 'PUE'},
    'Tepetlán': {municipality: '166', state: 'VER'},
    'San José del Peñasco': {municipality: '167', state: 'OAX'},
    'Tepetzintla': {municipality: '167', state: 'PUE'},
    //'Tepetzintla': {municipality: '167', state: 'VER'},
    'San José Estancia Grande': {municipality: '168', state: 'OAX'},
    'Tepexco': {municipality: '168', state: 'PUE'},
    //'Tequila': {municipality: '168', state: 'VER'},
    'San José Independencia': {municipality: '169', state: 'OAX'},
    'Tepexi de Rodríguez': {municipality: '169', state: 'PUE'},
    'José Azueta': {municipality: '169', state: 'VER'},
    'San José Lachiguiri': {municipality: '170', state: 'OAX'},
    'Tepeyahualco': {municipality: '170', state: 'PUE'},
    'Texcatepec': {municipality: '170', state: 'VER'},
    'San José Tenango': {municipality: '171', state: 'OAX'},
    'Tepeyahualco de Cuauhtémoc': {municipality: '171', state: 'PUE'},
    'Texhuacán': {municipality: '171', state: 'VER'},
    'San Juan Achiutla': {municipality: '172', state: 'OAX'},
    'Tetela de Ocampo': {municipality: '172', state: 'PUE'},
    'Texistepec': {municipality: '172', state: 'VER'},
    'San Juan Atepec': {municipality: '173', state: 'OAX'},
    'Teteles de Avila Castillo': {municipality: '173', state: 'PUE'},
    'Tezonapa': {municipality: '173', state: 'VER'},
    'Ánimas Trujano': {municipality: '174', state: 'OAX'},
    'Teziutlán': {municipality: '174', state: 'PUE'},
    //'Tierra Blanca': {municipality: '174', state: 'VER'},
    'San Juan Bautista Atatlahuca': {municipality: '175', state: 'OAX'},
    'Tianguismanalco': {municipality: '175', state: 'PUE'},
    'Tihuatlán': {municipality: '175', state: 'VER'},
    'San Juan Bautista Coixtlahuaca': {municipality: '176', state: 'OAX'},
    'Tilapa': {municipality: '176', state: 'PUE'},
    'Tlacojalpan': {municipality: '176', state: 'VER'},
    'San Juan Bautista Cuicatlán': {municipality: '177', state: 'OAX'},
    'Tlacotepec de Benito Juárez': {municipality: '177', state: 'PUE'},
    'Tlacolulan': {municipality: '177', state: 'VER'},
    'San Juan Bautista Guelache': {municipality: '178', state: 'OAX'},
    'Tlacuilotepec': {municipality: '178', state: 'PUE'},
    'Tlacotalpan': {municipality: '178', state: 'VER'},
    'San Juan Bautista Jayacatlán': {municipality: '179', state: 'OAX'},
    'Tlachichuca': {municipality: '179', state: 'PUE'},
    'Tlacotepec de Mejía': {municipality: '179', state: 'VER'},
    'San Juan Bautista Lo de Soto': {municipality: '180', state: 'OAX'},
    'Tlahuapan': {municipality: '180', state: 'PUE'},
    'Tlachichilco': {municipality: '180', state: 'VER'},
    'San Juan Bautista Suchitepec': {municipality: '181', state: 'OAX'},
    'Tlaltenango': {municipality: '181', state: 'PUE'},
    'Tlalixcoyan': {municipality: '181', state: 'VER'},
    'San Juan Bautista Tlacoatzintepec': {municipality: '182', state: 'OAX'},
    'Tlanepantla': {municipality: '182', state: 'PUE'},
    'Tlalnelhuayocan': {municipality: '182', state: 'VER'},
    'San Juan Bautista Tlachichilco': {municipality: '183', state: 'OAX'},
    'Tlaola': {municipality: '183', state: 'PUE'},
    'Tlapacoyan': {municipality: '183', state: 'VER'},
    'San Juan Bautista Tuxtepec': {municipality: '184', state: 'OAX'},
    'Tlapacoya': {municipality: '184', state: 'PUE'},
    'Tlaquilpa': {municipality: '184', state: 'VER'},
    'San Juan Cacahuatepec': {municipality: '185', state: 'OAX'},
    'Tlapanalá': {municipality: '185', state: 'PUE'},
    'Tlilapan': {municipality: '185', state: 'VER'},
    'San Juan Cieneguilla': {municipality: '186', state: 'OAX'},
    'Tlatlauquitepec': {municipality: '186', state: 'PUE'},
    //'Tomatlán': {municipality: '186', state: 'VER'},
    'San Juan Coatzóspam': {municipality: '187', state: 'OAX'},
    //'Tlaxco': {municipality: '187', state: 'PUE'},
    'Tonayán': {municipality: '187', state: 'VER'},
    'San Juan Colorado': {municipality: '188', state: 'OAX'},
    'Tochimilco': {municipality: '188', state: 'PUE'},
    'Totutla': {municipality: '188', state: 'VER'},
    'San Juan Comaltepec': {municipality: '189', state: 'OAX'},
    'Tochtepec': {municipality: '189', state: 'PUE'},
    //'Tuxpan': {municipality: '189', state: 'VER'},
    'San Juan Cotzocón': {municipality: '190', state: 'OAX'},
    'Totoltepec de Guerrero': {municipality: '190', state: 'PUE'},
    'Tuxtilla': {municipality: '190', state: 'VER'},
    'San Juan Chicomezúchil': {municipality: '191', state: 'OAX'},
    'Tulcingo': {municipality: '191', state: 'PUE'},
    'Ursulo Galván': {municipality: '191', state: 'VER'},
    'San Juan Chilateca': {municipality: '192', state: 'OAX'},
    'Tuzamapan de Galeana': {municipality: '192', state: 'PUE'},
    'Vega de Alatorre': {municipality: '192', state: 'VER'},
    'San Juan del Estado': {municipality: '193', state: 'OAX'},
    'Tzicatlacoyan': {municipality: '193', state: 'PUE'},
    'Veracruz': {municipality: '193', state: 'VER'},
    //'San Juan del Río': {municipality: '194', state: 'OAX'},
    //'Venustiano Carranza': {municipality: '194', state: 'PUE'},
    'Villa Aldama': {municipality: '194', state: 'VER'},
    'San Juan Diuxi': {municipality: '195', state: 'OAX'},
    //'Vicente Guerrero': {municipality: '195', state: 'PUE'},
    'Xoxocotla': {municipality: '195', state: 'VER'},
    'San Juan Evangelista Analco': {municipality: '196', state: 'OAX'},
    'Xayacatlán de Bravo': {municipality: '196', state: 'PUE'},
    'Yanga': {municipality: '196', state: 'VER'},
    'San Juan Guelavía': {municipality: '197', state: 'OAX'},
    'Xicotepec': {municipality: '197', state: 'PUE'},
    'Yecuatla': {municipality: '197', state: 'VER'},
    'San Juan Guichicovi': {municipality: '198', state: 'OAX'},
    'Xicotlán': {municipality: '198', state: 'PUE'},
    //'Zacualpan': {municipality: '198', state: 'VER'},
    'San Juan Ihualtepec': {municipality: '199', state: 'OAX'},
    'Xiutetelco': {municipality: '199', state: 'PUE'},
    //'Zaragoza': {municipality: '199', state: 'VER'},
    'San Juan Juquila Mixes': {municipality: '200', state: 'OAX'},
    'Xochiapulco': {municipality: '200', state: 'PUE'},
    'Zentla': {municipality: '200', state: 'VER'},
    'San Juan Juquila Vijanos': {municipality: '201', state: 'OAX'},
    'Xochiltepec': {municipality: '201', state: 'PUE'},
    'Zongolica': {municipality: '201', state: 'VER'},
    'San Juan Lachao': {municipality: '202', state: 'OAX'},
    'Xochitlán de Vicente Suárez': {municipality: '202', state: 'PUE'},
    'Zontecomatlán de López y Fuentes': {municipality: '202', state: 'VER'},
    'San Juan Lachigalla': {municipality: '203', state: 'OAX'},
    'Xochitlán Todos Santos': {municipality: '203', state: 'PUE'},
    'Zozocolco de Hidalgo': {municipality: '203', state: 'VER'},
    'San Juan Lajarcia': {municipality: '204', state: 'OAX'},
    'Yaonáhuac': {municipality: '204', state: 'PUE'},
    'Agua Dulce': {municipality: '204', state: 'VER'},
    'San Juan Lalana': {municipality: '205', state: 'OAX'},
    'Yehualtepec': {municipality: '205', state: 'PUE'},
    'El Higo': {municipality: '205', state: 'VER'},
    'San Juan de los Cués': {municipality: '206', state: 'OAX'},
    'Zacapala': {municipality: '206', state: 'PUE'},
    'Nanchital de Lázaro Cárdenas del Río': {municipality: '206', state: 'VER'},
    'San Juan Mazatlán': {municipality: '207', state: 'OAX'},
    'Zacapoaxtla': {municipality: '207', state: 'PUE'},
    'Tres Valles': {municipality: '207', state: 'VER'},
    'San Juan Mixtepec -Dto. 08 -': {municipality: '208', state: 'OAX'},
    'Zacatlán': {municipality: '208', state: 'PUE'},
    'Carlos A. Carrillo': {municipality: '208', state: 'VER'},
    'San Juan Mixtepec -Dto. 26 -': {municipality: '209', state: 'OAX'},
    'Zapotitlán': {municipality: '209', state: 'PUE'},
    'Tatahuicapan de Juárez': {municipality: '209', state: 'VER'},
    'San Juan Ñumí': {municipality: '210', state: 'OAX'},
    'Zapotitlán de Méndez': {municipality: '210', state: 'PUE'},
    'Uxpanapa': {municipality: '210', state: 'VER'},
    'San Juan Ozolotepec': {municipality: '211', state: 'OAX'},
    //'Zaragoza': {municipality: '211', state: 'PUE'},
    'San Rafael': {municipality: '211', state: 'VER'},
    'San Juan Petlapa': {municipality: '212', state: 'OAX'},
    'Zautla': {municipality: '212', state: 'PUE'},
    'Santiago Sochiapan': {municipality: '212', state: 'VER'},
    'San Juan Quiahije': {municipality: '213', state: 'OAX'},
    'Zihuateutla': {municipality: '213', state: 'PUE'},
    'San Juan Quiotepec': {municipality: '214', state: 'OAX'},
    'Zinacatepec': {municipality: '214', state: 'PUE'},
    'San Juan Sayultepec': {municipality: '215', state: 'OAX'},
    'Zongozotla': {municipality: '215', state: 'PUE'},
    'San Juan Tabaá': {municipality: '216', state: 'OAX'},
    'Zoquiapan': {municipality: '216', state: 'PUE'},
    'San Juan Tamazola': {municipality: '217', state: 'OAX'},
    'Zoquitlán': {municipality: '217', state: 'PUE'},
    'San Juan Teita': {municipality: '218', state: 'OAX'},
    'San Juan Teitipac': {municipality: '219', state: 'OAX'},
    'San Juan Tepeuxila': {municipality: '220', state: 'OAX'},
    'San Juan Teposcolula': {municipality: '221', state: 'OAX'},
    'San Juan Yaeé': {municipality: '222', state: 'OAX'},
    'San Juan Yatzona': {municipality: '223', state: 'OAX'},
    'San Juan Yucuita': {municipality: '224', state: 'OAX'},
    'San Lorenzo': {municipality: '225', state: 'OAX'},
    'San Lorenzo Albarradas': {municipality: '226', state: 'OAX'},
    'San Lorenzo Cacaotepec': {municipality: '227', state: 'OAX'},
    'San Lorenzo Cuaunecuiltitla': {municipality: '228', state: 'OAX'},
    'San Lorenzo Texmelúcan': {municipality: '229', state: 'OAX'},
    'San Lorenzo Victoria': {municipality: '230', state: 'OAX'},
    'San Lucas Camotlán': {municipality: '231', state: 'OAX'},
    'San Lucas Ojitlán': {municipality: '232', state: 'OAX'},
    'San Lucas Quiaviní': {municipality: '233', state: 'OAX'},
    'San Lucas Zoquiápam': {municipality: '234', state: 'OAX'},
    'San Luis Amatlán': {municipality: '235', state: 'OAX'},
    'San Marcial Ozolotepec': {municipality: '236', state: 'OAX'},
    'San Marcos Arteaga': {municipality: '237', state: 'OAX'},
    'San Martín de los Cansecos': {municipality: '238', state: 'OAX'},
    'San Martín Huamelúlpam': {municipality: '239', state: 'OAX'},
    'San Martín Itunyoso': {municipality: '240', state: 'OAX'},
    'San Martín Lachilá': {municipality: '241', state: 'OAX'},
    'San Martín Peras': {municipality: '242', state: 'OAX'},
    'San Martín Tilcajete': {municipality: '243', state: 'OAX'},
    'San Martín Toxpalan': {municipality: '244', state: 'OAX'},
    'San Martín Zacatepec': {municipality: '245', state: 'OAX'},
    'San Mateo Cajonos': {municipality: '246', state: 'OAX'},
    'Capulálpam de Méndez': {municipality: '247', state: 'OAX'},
    'San Mateo del Mar': {municipality: '248', state: 'OAX'},
    'San Mateo Yoloxochitlán': {municipality: '249', state: 'OAX'},
    'San Mateo Etlatongo': {municipality: '250', state: 'OAX'},
    'San Mateo Nejápam': {municipality: '251', state: 'OAX'},
    'San Mateo Peñasco': {municipality: '252', state: 'OAX'},
    'San Mateo Piñas': {municipality: '253', state: 'OAX'},
    'San Mateo Río Hondo': {municipality: '254', state: 'OAX'},
    'San Mateo Sindihui': {municipality: '255', state: 'OAX'},
    'San Mateo Tlapiltepec': {municipality: '256', state: 'OAX'},
    'San Melchor Betaza': {municipality: '257', state: 'OAX'},
    'San Miguel Achiutla': {municipality: '258', state: 'OAX'},
    'San Miguel Ahuehuetitlán': {municipality: '259', state: 'OAX'},
    'San Miguel Aloápam': {municipality: '260', state: 'OAX'},
    'San Miguel Amatitlán': {municipality: '261', state: 'OAX'},
    'San Miguel Amatlán': {municipality: '262', state: 'OAX'},
    'San Miguel Coatlán': {municipality: '263', state: 'OAX'},
    'San Miguel Chicahua': {municipality: '264', state: 'OAX'},
    'San Miguel Chimalapa': {municipality: '265', state: 'OAX'},
    'San Miguel del Puerto': {municipality: '266', state: 'OAX'},
    'San Miguel del Río': {municipality: '267', state: 'OAX'},
    'San Miguel Ejutla': {municipality: '268', state: 'OAX'},
    'San Miguel el Grande': {municipality: '269', state: 'OAX'},
    'San Miguel Huautla': {municipality: '270', state: 'OAX'},
    'San Miguel Mixtepec': {municipality: '271', state: 'OAX'},
    'San Miguel Panixtlahuaca': {municipality: '272', state: 'OAX'},
    'San Miguel Peras': {municipality: '273', state: 'OAX'},
    'San Miguel Piedras': {municipality: '274', state: 'OAX'},
    'San Miguel Quetzaltepec': {municipality: '275', state: 'OAX'},
    'San Miguel Santa Flor': {municipality: '276', state: 'OAX'},
    'Villa Sola de Vega': {municipality: '277', state: 'OAX'},
    'San Miguel Soyaltepec': {municipality: '278', state: 'OAX'},
    'San Miguel Suchixtepec': {municipality: '279', state: 'OAX'},
    'Villa Talea de Castro': {municipality: '280', state: 'OAX'},
    'San Miguel Tecomatlán': {municipality: '281', state: 'OAX'},
    'San Miguel Tenango': {municipality: '282', state: 'OAX'},
    'San Miguel Tequixtepec': {municipality: '283', state: 'OAX'},
    'San Miguel Tilquiápam': {municipality: '284', state: 'OAX'},
    'San Miguel Tlacamama': {municipality: '285', state: 'OAX'},
    'San Miguel Tlacotepec': {municipality: '286', state: 'OAX'},
    'San Miguel Tulancingo': {municipality: '287', state: 'OAX'},
    'San Miguel Yotao': {municipality: '288', state: 'OAX'},
    //'San Nicolás': {municipality: '289', state: 'OAX'},
    'San Nicolás Hidalgo': {municipality: '290', state: 'OAX'},
    'San Pablo Coatlán': {municipality: '291', state: 'OAX'},
    'San Pablo Cuatro Venados': {municipality: '292', state: 'OAX'},
    'San Pablo Etla': {municipality: '293', state: 'OAX'},
    'San Pablo Huitzo': {municipality: '294', state: 'OAX'},
    'San Pablo Huixtepec': {municipality: '295', state: 'OAX'},
    'San Pablo Macuiltianguis': {municipality: '296', state: 'OAX'},
    'San Pablo Tijaltepec': {municipality: '297', state: 'OAX'},
    'San Pablo Villa de Mitla': {municipality: '298', state: 'OAX'},
    'San Pablo Yaganiza': {municipality: '299', state: 'OAX'},
    'San Pedro Amuzgos': {municipality: '300', state: 'OAX'},
    'San Pedro Apóstol': {municipality: '301', state: 'OAX'},
    'San Pedro Atoyac': {municipality: '302', state: 'OAX'},
    'San Pedro Cajonos': {municipality: '303', state: 'OAX'},
    'San Pedro Coxcaltepec Cántaros': {municipality: '304', state: 'OAX'},
    'San Pedro Comitancillo': {municipality: '305', state: 'OAX'},
    'San Pedro el Alto': {municipality: '306', state: 'OAX'},
    'San Pedro Huamelula': {municipality: '307', state: 'OAX'},
    'San Pedro Huilotepec': {municipality: '308', state: 'OAX'},
    'San Pedro Ixcatlán': {municipality: '309', state: 'OAX'},
    'San Pedro Ixtlahuaca': {municipality: '310', state: 'OAX'},
    'San Pedro Jaltepetongo': {municipality: '311', state: 'OAX'},
    'San Pedro Jicayán': {municipality: '312', state: 'OAX'},
    'San Pedro Jocotipac': {municipality: '313', state: 'OAX'},
    'San Pedro Juchatengo': {municipality: '314', state: 'OAX'},
    'San Pedro Mártir': {municipality: '315', state: 'OAX'},
    'San Pedro Mártir Quiechapa': {municipality: '316', state: 'OAX'},
    'San Pedro Mártir Yucuxaco': {municipality: '317', state: 'OAX'},
    'San Pedro Mixtepec -Dto. 22 -': {municipality: '318', state: 'OAX'},
    'San Pedro Mixtepec -Dto. 26 -': {municipality: '319', state: 'OAX'},
    'San Pedro Molinos': {municipality: '320', state: 'OAX'},
    'San Pedro Nopala': {municipality: '321', state: 'OAX'},
    'San Pedro Ocopetatillo': {municipality: '322', state: 'OAX'},
    'San Pedro Ocotepec': {municipality: '323', state: 'OAX'},
    'San Pedro Pochutla': {municipality: '324', state: 'OAX'},
    'San Pedro Quiatoni': {municipality: '325', state: 'OAX'},
    'San Pedro Sochiápam': {municipality: '326', state: 'OAX'},
    'San Pedro Tapanatepec': {municipality: '327', state: 'OAX'},
    'San Pedro Taviche': {municipality: '328', state: 'OAX'},
    'San Pedro Teozacoalco': {municipality: '329', state: 'OAX'},
    'San Pedro Teutila': {municipality: '330', state: 'OAX'},
    'San Pedro Tidaá': {municipality: '331', state: 'OAX'},
    'San Pedro Topiltepec': {municipality: '332', state: 'OAX'},
    'San Pedro Totolápam': {municipality: '333', state: 'OAX'},
    'Villa de Tututepec de Melchor Ocampo': {municipality: '334', state: 'OAX'},
    'San Pedro Yaneri': {municipality: '335', state: 'OAX'},
    'San Pedro Yólox': {municipality: '336', state: 'OAX'},
    'San Pedro y San Pablo Ayutla': {municipality: '337', state: 'OAX'},
    'Villa de Etla': {municipality: '338', state: 'OAX'},
    'San Pedro y San Pablo Teposcolula': {municipality: '339', state: 'OAX'},
    'San Pedro y San Pablo Tequixtepec': {municipality: '340', state: 'OAX'},
    'San Pedro Yucunama': {municipality: '341', state: 'OAX'},
    'San Raymundo Jalpan': {municipality: '342', state: 'OAX'},
    'San Sebastián Abasolo': {municipality: '343', state: 'OAX'},
    'San Sebastián Coatlán': {municipality: '344', state: 'OAX'},
    'San Sebastián Ixcapa': {municipality: '345', state: 'OAX'},
    'San Sebastián Nicananduta': {municipality: '346', state: 'OAX'},
    'San Sebastián Río Hondo': {municipality: '347', state: 'OAX'},
    'San Sebastián Tecomaxtlahuaca': {municipality: '348', state: 'OAX'},
    'San Sebastián Teitipac': {municipality: '349', state: 'OAX'},
    'San Sebastián Tutla': {municipality: '350', state: 'OAX'},
    'San Simón Almolongas': {municipality: '351', state: 'OAX'},
    'San Simón Zahuatlán': {municipality: '352', state: 'OAX'},
    //'Santa Ana': {municipality: '353', state: 'OAX'},
    'Santa Ana Ateixtlahuaca': {municipality: '354', state: 'OAX'},
    'Santa Ana Cuauhtémoc': {municipality: '355', state: 'OAX'},
    'Santa Ana del Valle': {municipality: '356', state: 'OAX'},
    'Santa Ana Tavela': {municipality: '357', state: 'OAX'},
    'Santa Ana Tlapacoyan': {municipality: '358', state: 'OAX'},
    'Santa Ana Yareni': {municipality: '359', state: 'OAX'},
    'Santa Ana Zegache': {municipality: '360', state: 'OAX'},
    'Santa Catalina Quierí': {municipality: '361', state: 'OAX'},
    'Santa Catarina Cuixtla': {municipality: '362', state: 'OAX'},
    'Santa Catarina Ixtepeji': {municipality: '363', state: 'OAX'},
    'Santa Catarina Juquila': {municipality: '364', state: 'OAX'},
    'Santa Catarina Lachatao': {municipality: '365', state: 'OAX'},
    'Santa Catarina Loxicha': {municipality: '366', state: 'OAX'},
    'Santa Catarina Mechoacán': {municipality: '367', state: 'OAX'},
    'Santa Catarina Minas': {municipality: '368', state: 'OAX'},
    'Santa Catarina Quiané': {municipality: '369', state: 'OAX'},
    'Santa Catarina Tayata': {municipality: '370', state: 'OAX'},
    'Santa Catarina Ticuá': {municipality: '371', state: 'OAX'},
    'Santa Catarina Yosonotú': {municipality: '372', state: 'OAX'},
    'Santa Catarina Zapoquila': {municipality: '373', state: 'OAX'},
    'Santa Cruz Acatepec': {municipality: '374', state: 'OAX'},
    'Santa Cruz Amilpas': {municipality: '375', state: 'OAX'},
    'Santa Cruz de Bravo': {municipality: '376', state: 'OAX'},
    'Santa Cruz Itundujia': {municipality: '377', state: 'OAX'},
    'Santa Cruz Mixtepec': {municipality: '378', state: 'OAX'},
    'Santa Cruz Nundaco': {municipality: '379', state: 'OAX'},
    'Santa Cruz Papalutla': {municipality: '380', state: 'OAX'},
    'Santa Cruz Tacache de Mina': {municipality: '381', state: 'OAX'},
    'Santa Cruz Tacahua': {municipality: '382', state: 'OAX'},
    'Santa Cruz Tayata': {municipality: '383', state: 'OAX'},
    'Santa Cruz Xitla': {municipality: '384', state: 'OAX'},
    'Santa Cruz Xoxocotlán': {municipality: '385', state: 'OAX'},
    'Santa Cruz Zenzontepec': {municipality: '386', state: 'OAX'},
    'Santa Gertrudis': {municipality: '387', state: 'OAX'},
    'Santa Inés del Monte': {municipality: '388', state: 'OAX'},
    'Santa Inés Yatzeche': {municipality: '389', state: 'OAX'},
    'Santa Lucía del Camino': {municipality: '390', state: 'OAX'},
    'Santa Lucía Miahuatlán': {municipality: '391', state: 'OAX'},
    'Santa Lucía Monteverde': {municipality: '392', state: 'OAX'},
    'Santa Lucía Ocotlán': {municipality: '393', state: 'OAX'},
    'Santa María Alotepec': {municipality: '394', state: 'OAX'},
    'Santa María Apazco': {municipality: '395', state: 'OAX'},
    'Santa María la Asunción': {municipality: '396', state: 'OAX'},
    'Heroica Ciudad de Tlaxiaco': {municipality: '397', state: 'OAX'},
    'Ayoquezco de Aldama': {municipality: '398', state: 'OAX'},
    'Santa María Atzompa': {municipality: '399', state: 'OAX'},
    'Santa María Camotlán': {municipality: '400', state: 'OAX'},
    'Santa María Colotepec': {municipality: '401', state: 'OAX'},
    'Santa María Cortijo': {municipality: '402', state: 'OAX'},
    'Santa María Coyotepec': {municipality: '403', state: 'OAX'},
    'Santa María Chachoápam': {municipality: '404', state: 'OAX'},
    'Villa de Chilapa de Díaz': {municipality: '405', state: 'OAX'},
    'Santa María Chilchotla': {municipality: '406', state: 'OAX'},
    'Santa María Chimalapa': {municipality: '407', state: 'OAX'},
    'Santa María del Rosario': {municipality: '408', state: 'OAX'},
    'Santa María del Tule': {municipality: '409', state: 'OAX'},
    'Santa María Ecatepec': {municipality: '410', state: 'OAX'},
    'Santa María Guelacé': {municipality: '411', state: 'OAX'},
    'Santa María Guienagati': {municipality: '412', state: 'OAX'},
    'Santa María Huatulco': {municipality: '413', state: 'OAX'},
    'Santa María Huazolotitlán': {municipality: '414', state: 'OAX'},
    'Santa María Ipalapa': {municipality: '415', state: 'OAX'},
    'Santa María Ixcatlán': {municipality: '416', state: 'OAX'},
    'Santa María Jacatepec': {municipality: '417', state: 'OAX'},
    'Santa María Jalapa del Marqués': {municipality: '418', state: 'OAX'},
    'Santa María Jaltianguis': {municipality: '419', state: 'OAX'},
    'Santa María Lachixío': {municipality: '420', state: 'OAX'},
    'Santa María Mixtequilla': {municipality: '421', state: 'OAX'},
    'Santa María Nativitas': {municipality: '422', state: 'OAX'},
    'Santa María Nduayaco': {municipality: '423', state: 'OAX'},
    'Santa María Ozolotepec': {municipality: '424', state: 'OAX'},
    'Santa María Pápalo': {municipality: '425', state: 'OAX'},
    'Santa María Peñoles': {municipality: '426', state: 'OAX'},
    'Santa María Petapa': {municipality: '427', state: 'OAX'},
    'Santa María Quiegolani': {municipality: '428', state: 'OAX'},
    'Santa María Sola': {municipality: '429', state: 'OAX'},
    'Santa María Tataltepec': {municipality: '430', state: 'OAX'},
    'Santa María Tecomavaca': {municipality: '431', state: 'OAX'},
    'Santa María Temaxcalapa': {municipality: '432', state: 'OAX'},
    'Santa María Temaxcaltepec': {municipality: '433', state: 'OAX'},
    'Santa María Teopoxco': {municipality: '434', state: 'OAX'},
    'Santa María Tepantlali': {municipality: '435', state: 'OAX'},
    'Santa María Texcatitlán': {municipality: '436', state: 'OAX'},
    'Santa María Tlahuitoltepec': {municipality: '437', state: 'OAX'},
    'Santa María Tlalixtac': {municipality: '438', state: 'OAX'},
    'Santa María Tonameca': {municipality: '439', state: 'OAX'},
    'Santa María Totolapilla': {municipality: '440', state: 'OAX'},
    'Santa María Xadani': {municipality: '441', state: 'OAX'},
    'Santa María Yalina': {municipality: '442', state: 'OAX'},
    'Santa María Yavesía': {municipality: '443', state: 'OAX'},
    'Santa María Yolotepec': {municipality: '444', state: 'OAX'},
    'Santa María Yosoyúa': {municipality: '445', state: 'OAX'},
    'Santa María Yucuhiti': {municipality: '446', state: 'OAX'},
    'Santa María Zacatepec': {municipality: '447', state: 'OAX'},
    'Santa María Zaniza': {municipality: '448', state: 'OAX'},
    'Santa María Zoquitlán': {municipality: '449', state: 'OAX'},
    'Santiago Amoltepec': {municipality: '450', state: 'OAX'},
    'Santiago Apoala': {municipality: '451', state: 'OAX'},
    'Santiago Apóstol': {municipality: '452', state: 'OAX'},
    'Santiago Astata': {municipality: '453', state: 'OAX'},
    'Santiago Atitlán': {municipality: '454', state: 'OAX'},
    'Santiago Ayuquililla': {municipality: '455', state: 'OAX'},
    'Santiago Cacaloxtepec': {municipality: '456', state: 'OAX'},
    'Santiago Camotlán': {municipality: '457', state: 'OAX'},
    'Santiago Comaltepec': {municipality: '458', state: 'OAX'},
    'Santiago Chazumba': {municipality: '459', state: 'OAX'},
    'Santiago Choápam': {municipality: '460', state: 'OAX'},
    'Santiago del Río': {municipality: '461', state: 'OAX'},
    'Santiago Huajolotitlán': {municipality: '462', state: 'OAX'},
    'Santiago Huauclilla': {municipality: '463', state: 'OAX'},
    'Santiago Ihuitlán Plumas': {municipality: '464', state: 'OAX'},
    'Santiago Ixcuintepec': {municipality: '465', state: 'OAX'},
    'Santiago Ixtayutla': {municipality: '466', state: 'OAX'},
    'Santiago Jamiltepec': {municipality: '467', state: 'OAX'},
    'Santiago Jocotepec': {municipality: '468', state: 'OAX'},
    'Santiago Juxtlahuaca': {municipality: '469', state: 'OAX'},
    'Santiago Lachiguiri': {municipality: '470', state: 'OAX'},
    'Santiago Lalopa': {municipality: '471', state: 'OAX'},
    'Santiago Laollaga': {municipality: '472', state: 'OAX'},
    'Santiago Laxopa': {municipality: '473', state: 'OAX'},
    'Santiago Llano Grande': {municipality: '474', state: 'OAX'},
    'Santiago Matatlán': {municipality: '475', state: 'OAX'},
    'Santiago Miltepec': {municipality: '476', state: 'OAX'},
    'Santiago Minas': {municipality: '477', state: 'OAX'},
    'Santiago Nacaltepec': {municipality: '478', state: 'OAX'},
    'Santiago Nejapilla': {municipality: '479', state: 'OAX'},
    'Santiago Nundiche': {municipality: '480', state: 'OAX'},
    'Santiago Nuyoó': {municipality: '481', state: 'OAX'},
    'Santiago Pinotepa Nacional': {municipality: '482', state: 'OAX'},
    'Santiago Suchilquitongo': {municipality: '483', state: 'OAX'},
    'Santiago Tamazola': {municipality: '484', state: 'OAX'},
    'Santiago Tapextla': {municipality: '485', state: 'OAX'},
    'Villa Tejúpam de la Unión': {municipality: '486', state: 'OAX'},
    'Santiago Tenango': {municipality: '487', state: 'OAX'},
    'Santiago Tepetlapa': {municipality: '488', state: 'OAX'},
    'Santiago Tetepec': {municipality: '489', state: 'OAX'},
    'Santiago Texcalcingo': {municipality: '490', state: 'OAX'},
    'Santiago Textitlán': {municipality: '491', state: 'OAX'},
    'Santiago Tilantongo': {municipality: '492', state: 'OAX'},
    'Santiago Tillo': {municipality: '493', state: 'OAX'},
    'Santiago Tlazoyaltepec': {municipality: '494', state: 'OAX'},
    'Santiago Xanica': {municipality: '495', state: 'OAX'},
    'Santiago Xiacuí': {municipality: '496', state: 'OAX'},
    'Santiago Yaitepec': {municipality: '497', state: 'OAX'},
    'Santiago Yaveo': {municipality: '498', state: 'OAX'},
    'Santiago Yolomécatl': {municipality: '499', state: 'OAX'},
    'Santiago Yosondúa': {municipality: '500', state: 'OAX'},
    'Santiago Yucuyachi': {municipality: '501', state: 'OAX'},
    'Santiago Zacatepec': {municipality: '502', state: 'OAX'},
    'Santiago Zoochila': {municipality: '503', state: 'OAX'},
    'Nuevo Zoquiápam': {municipality: '504', state: 'OAX'},
    'Santo Domingo Ingenio': {municipality: '505', state: 'OAX'},
    'Santo Domingo Albarradas': {municipality: '506', state: 'OAX'},
    'Santo Domingo Armenta': {municipality: '507', state: 'OAX'},
    'Santo Domingo Chihuitán': {municipality: '508', state: 'OAX'},
    'Santo Domingo de Morelos': {municipality: '509', state: 'OAX'},
    'Santo Domingo Ixcatlán': {municipality: '510', state: 'OAX'},
    'Santo Domingo Nuxaá': {municipality: '511', state: 'OAX'},
    'Santo Domingo Ozolotepec': {municipality: '512', state: 'OAX'},
    'Santo Domingo Petapa': {municipality: '513', state: 'OAX'},
    'Santo Domingo Roayaga': {municipality: '514', state: 'OAX'},
    'Santo Domingo Tehuantepec': {municipality: '515', state: 'OAX'},
    'Santo Domingo Teojomulco': {municipality: '516', state: 'OAX'},
    'Santo Domingo Tepuxtepec': {municipality: '517', state: 'OAX'},
    'Santo Domingo Tlatayápam': {municipality: '518', state: 'OAX'},
    'Santo Domingo Tomaltepec': {municipality: '519', state: 'OAX'},
    'Santo Domingo Tonalá': {municipality: '520', state: 'OAX'},
    'Santo Domingo Tonaltepec': {municipality: '521', state: 'OAX'},
    'Santo Domingo Xagacía': {municipality: '522', state: 'OAX'},
    'Santo Domingo Yanhuitlán': {municipality: '523', state: 'OAX'},
    'Santo Domingo Yodohino': {municipality: '524', state: 'OAX'},
    'Santo Domingo Zanatepec': {municipality: '525', state: 'OAX'},
    'Santos Reyes Nopala': {municipality: '526', state: 'OAX'},
    'Santos Reyes Pápalo': {municipality: '527', state: 'OAX'},
    'Santos Reyes Tepejillo': {municipality: '528', state: 'OAX'},
    'Santos Reyes Yucuná': {municipality: '529', state: 'OAX'},
    'Santo Tomás Jalieza': {municipality: '530', state: 'OAX'},
    'Santo Tomás Mazaltepec': {municipality: '531', state: 'OAX'},
    'Santo Tomás Ocotepec': {municipality: '532', state: 'OAX'},
    'Santo Tomás Tamazulapan': {municipality: '533', state: 'OAX'},
    'San Vicente Coatlán': {municipality: '534', state: 'OAX'},
    'San Vicente Lachixío': {municipality: '535', state: 'OAX'},
    'San Vicente Nuñú': {municipality: '536', state: 'OAX'},
    'Silacayoápam': {municipality: '537', state: 'OAX'},
    'Sitio de Xitlapehua': {municipality: '538', state: 'OAX'},
    'Soledad Etla': {municipality: '539', state: 'OAX'},
    'Villa de Tamazulápam del Progreso': {municipality: '540', state: 'OAX'},
    'Tanetze de Zaragoza': {municipality: '541', state: 'OAX'},
    'Taniche': {municipality: '542', state: 'OAX'},
    'Tataltepec de Valdés': {municipality: '543', state: 'OAX'},
    'Teococuilco de Marcos Pérez': {municipality: '544', state: 'OAX'},
    'Teotitlán de Flores Magón': {municipality: '545', state: 'OAX'},
    'Teotitlán del Valle': {municipality: '546', state: 'OAX'},
    'Teotongo': {municipality: '547', state: 'OAX'},
    'Tepelmeme Villa de Morelos': {municipality: '548', state: 'OAX'},
    'Tezoatlán de Segura y Luna': {municipality: '549', state: 'OAX'},
    'San Jerónimo Tlacochahuaya': {municipality: '550', state: 'OAX'},
    'Tlacolula de Matamoros': {municipality: '551', state: 'OAX'},
    'Tlacotepec Plumas': {municipality: '552', state: 'OAX'},
    'Tlalixtac de Cabrera': {municipality: '553', state: 'OAX'},
    'Totontepec Villa de Morelos': {municipality: '554', state: 'OAX'},
    'Trinidad Zaachila': {municipality: '555', state: 'OAX'},
    'La Trinidad Vista Hermosa': {municipality: '556', state: 'OAX'},
    'Unión Hidalgo': {municipality: '557', state: 'OAX'},
    'Valerio Trujano': {municipality: '558', state: 'OAX'},
    'San Juan Bautista Valle Nacional': {municipality: '559', state: 'OAX'},
    'Villa Díaz Ordaz': {municipality: '560', state: 'OAX'},
    'Yaxe': {municipality: '561', state: 'OAX'},
    'Magdalena Yodocono de Porfirio Díaz': {municipality: '562', state: 'OAX'},
    'Yogana': {municipality: '563', state: 'OAX'},
    'Yutanduchi de Guerrero': {municipality: '564', state: 'OAX'},
    'Villa de Zaachila': {municipality: '565', state: 'OAX'},
    'San Mateo Yucutindoo': {municipality: '566', state: 'OAX'},
    'Zapotitlán Lagunas': {municipality: '567', state: 'OAX'},
    'Zapotitlán Palmas': {municipality: '568', state: 'OAX'},
    'Santa Inés de Zaragoza': {municipality: '569', state: 'OAX'},
    'Zimatlán de Álvarez': {municipality: '570', state: 'OAX'},
  };
  /*
  public static PROXY_URL = "https://cors.medicospro.com/";
  public static PROXY_URL = "https://corss.medicospro.com/";
  public static PROXY_URL = '';
  */
 public static PROXY_URL = "https://cors-anywhere.herokuapp.com/";
    
 public static PR_DELETED = '*** Producto eliminado ***';

 public static MONTHS = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
 public static DAYS = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

 public static BILL_STATUS = {
   key0: 'Sin timbrar',
   key1: 'Timbrada',
   key2: 'Se debe sustituír',

   key97: 'Solicitud de cancelación enviada',
   key98: 'En proceso de cancelación',
   key99: 'Cancelada'
 }
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////Vars


  /**
   * Permissions
   */
  public static newPermission(name: string){//Ya en crud
    return {
      name,
      level: name.split('/').length,
      createAction: false,
      readAction: false,
      updateAction: false,
      deleteAction: false
    }
  }
  public static get PERMISSIONS_OBJ(){
    let permissionsObj = {};
    /** Catálogos */
        /** Empresas */
            /** Organización */ 
            permissionsObj[this.COMPANIES_COLLECTION] =                 this.newPermission('Catálogos / Empresas / Organización');//Ya en crud
            /** Naves y módulos */ 
            permissionsObj[this.SHIP_COLLECTION] =                      this.newPermission('Catálogos / Empresas / Naves y módulos');//Ya en crud
            /** Departamentos y áreas */ 
            permissionsObj[this.DEPARTMENT_COLLECTION] =                this.newPermission('Catálogos / Empresas / Departamentos y áreas');//Ya en crud
        /** Empleados */
            /** Datos generales */ 
            permissionsObj[this.EMPLOYEE_COLLECTION] =                  this.newPermission('Catálogos / Empleados / Datos generales');//Ya en crud
            /** Puestos y roles */ 
            permissionsObj[this.JOB_COLLECTION] =                       this.newPermission('Catálogos / Empleados / Puestos y roles');//Ya en crud
            /** Actividades */ 
            permissionsObj[this.ACTIVITY_COLLECTION] =                  this.newPermission('Catálogos / Empleados / Actividades');//Ya en crud
            /** Clasificación de actividades */ 
            permissionsObj[this.ACTIVITY_CLASSIFICATION_COLLECTION] =   this.newPermission('Catálogos / Empleados / Clasificación de actividades');//Ya en crud
            /** Permisos */
            /** Turnos */ 
            permissionsObj[this.WORK_SHIFT_COLLECTION] =                this.newPermission('Catálogos / Empleados / Turnos');//Ya en crud
        /** Costos */
        permissionsObj[this.CONSTANT_COSTS_COLLECTION] =                this.newPermission('Catálogos / Costos');//Ya en crud
        /** Máquinas */
        permissionsObj[this.MACHINE_COLLECTION] =                       this.newPermission('Catálogos / Máquinas');//Ya en crud
        /** Unidades de medida */
        permissionsObj[this.UNIT_COLLECTION] =                          this.newPermission('Catálogos / Unidades de medida');//Ya en crud
        /** Tipos de documentos */
        permissionsObj[this.DOCUMENTS_TYPES_COLLECTION] =               this.newPermission('Catálogos / Tipos de documentos');//Ya en crud
        /** Accesos al sistema */
            /** Usuarios */
            permissionsObj[this.USER_COLLECTION] =                      this.newPermission('Catálogos / Accesos al sistema / Usuarios');//Ya en crud
            /** Grupos */
            permissionsObj[this.GROUP_COLLECTION] =                     this.newPermission('Catálogos / Accesos al sistema / Grupos');//Ya en crud
            /** Permisos */
            permissionsObj['permisos'] =                                this.newPermission('Catálogos / Accesos al sistema / Permisos');//Ya en crud final
        /** Configuración */
        permissionsObj[this.CATALOGS_SETTINGS] =                        this.newPermission('Catálogos / Configuración');//Ya en crud

    /** Nómina */
        /** Configuración */
        /** Entrada de datos */
            /** Reloj checador */
            permissionsObj[this.CHECK_CLOCK_LOAD_COLLECTION] =          this.newPermission('Nómina / Entrada de datos / Reloj checador');//Ya en crud
            /** Caseta seguridad */
            /** Reporte supervisor */
            permissionsObj[this.SUPERVISOR_REPORT_COLLECTION] =         this.newPermission('Nómina / Entrada de datos / Reporte de supervisor');//Ya en crud
            /** Reporte transportista */
            permissionsObj[this.CARRIER_REPORT_COLLECTION] =            this.newPermission('Nómina / Entrada de datos / Reporte transportista');//Ya en crud
            /** Reporte Apuntador */
            permissionsObj[this.PROMPTER_REPORT_COLLECTION] =           this.newPermission('Nómina / Entrada de datos / Reporte Apuntador');//Ya en crud
            /** Asignar Horas Extras */
            permissionsObj[this.OVERTIME_COLLECTION] =                  this.newPermission('Nómina / Entrada de datos / Asignar horas extra');//Ya en crud
        /** Inconsistencias de asistencia */
        permissionsObj[this.ASSISTANCE_REPORT_COLLECTION] =             this.newPermission('Nómina / Inconsistencias de asistencia');//Ya en crud
        /** Asistencia */
        permissionsObj[this.ASSISTANCE_COLLECTION] =                    this.newPermission('Nómina / Asistencia');//Ya en crud
        /** Estimado de nómina */
        permissionsObj['payrollEstimate'] =                             this.newPermission('Nómina / Estimado de nómina');//Ya en crud
        /** Pago de nómina */
        /** Préstamo a empleados */
        permissionsObj[this.LOAN_COLLECTION] =                          this.newPermission('Nómina / Préstamo a empleados');//Ya en crud

    /** Ventas */
        /** Clientes y prospectos */
        permissionsObj['customer'] =                                    this.newPermission('Ventas / Clientes y prospectos');//Ya en crud
        /** Productos de venta */
            /** Clasifficación */
            permissionsObj['prTypeV'] =                                 this.newPermission('Ventas / Productos de venta / Clasificación');//Ya en crud
            /** Productos */
            permissionsObj[this.PRVNTA_COLLECTION] =                    this.newPermission('Ventas / Productos de venta / Productos');//Ya en crud
        /** Productos de cliente */
        permissionsObj[this.PRCLIENT_COLLECTION] =                      this.newPermission('Ventas / Productos de cliente');//Ya en crud
        /** Suajes */
        permissionsObj[this.SUAJE_COLLECTION] =                         this.newPermission('Ventas / Suajes');//Ya en crud
        /** Levantar un pedido */
        permissionsObj[this.LIFT_ORDER_COLLECTION] =                    this.newPermission('Ventas / Levantar un pedido');//Ya en crud
        /** Cotizaciones */
        permissionsObj[this.QUOT_COLLECTION] =                          this.newPermission('Ventas / Cotizaciones');//Ya en crud
        /** Productos de línea */

    /** Compras */
        /** Proveedores */
        permissionsObj['supplier'] =                                    this.newPermission('Compras / Proveedores');//Ya en crud
        /** Productos de compras */
            /** Clasificación */
            permissionsObj['prTypeC'] =                                 this.newPermission('Compras / Productos de compra / Clasificación');//Ya en crud
            /** Productos */
            permissionsObj[this.PRCMPA_COLLECTION] =                    this.newPermission('Compras / Productos de compra / Productos');//Ya en crud
        /** Requisición de compra */
        permissionsObj[this.PURCHASE_REQUEST_COLLECTION] =              this.newPermission('Compras / Requisisión de compra');//Ya en crud
        /** Órdenes de compra */
        permissionsObj[this.PURCHASE_ORDER_COLLECTION] =                this.newPermission('Compras / Órdenes de compra');//Ya en crud
        /** Costos */

    /** Producción */
        /** Configuración */
        /** Órdenes de producción */
        permissionsObj[this.PRODUCTION_ORDER_COLLECTION] =              this.newPermission('Producción / Órdenes de producción');//Ya en crud
        /** Listado de prioridades */
        /** Remisiones */
        permissionsObj[this.REMISSION_COLLECTION] =                     this.newPermission('Producción / Remisiones');//Ya en crud
        /** Reporte de rentabilidad */

    /** Inventarios */
        /** Almacenes */
        permissionsObj[this.WAREHOUSE_COLLECTION] =                     this.newPermission('Inventarios / Almacenes');//Ya en crud
        /** Tipos de entrada y salida */
        permissionsObj[this.IN_AND_OUT_COLLECTION] =                    this.newPermission('Inventarios / Tipos de entrada y salida');//Ya en crud
        /** Entradas */
        permissionsObj['inTran'] =                                      this.newPermission('Inventarios / Entradas');//Ya en crud
        /** Salidas */
        permissionsObj['outTran'] =                                     this.newPermission('Inventarios / Salidas');//Ya en crud
        /** Existencias */
            /** En piezas */
            permissionsObj['stockPiece'] =                              this.newPermission('Inventarios / Existencias / En piezas');//Ya en crud
            /** Para costos */
            /** Archivar */
        /** Movimientos */
        /** Máximos y mínimos */
        /** Requisición de compra */

    /** Ingresos y egresos */
        /** Cuentas x cobrar */
            /** Facturas */
            permissionsObj[this.CUSTOMER_BILL_COLLECTION] =             this.newPermission('Ingresos y egresos / Cuentas x cobrar / Facturas');//Ya en crud
            /** Ingresos */
            permissionsObj[this.INCOME_COLLECTION] =                    this.newPermission('Ingresos y egresos / Cuentas x cobrar / Ingresos');//Ya en crud
            /** Edo de cuenta clientes */
            /** Vencimiento de saldos */
        /** Cuentas x pagar */
            /** Facturas de proveedores */
            permissionsObj[this.SUPPLIER_BILL_COLLECTION] =             this.newPermission('Ingresos y egresos / Cuentas x pagar / Facturas de proveedores');//Ya en crud
            /** Egresos */
            permissionsObj[this.OUTCOME_COLLECTION] =                   this.newPermission('Ingresos y egresos / Cuentas x pagar / Egresos');//Ya en crud
            /** Reporte de gastos */
            /** Vencimiento de saldos */
        /** Interfases para contabilidad */
        /** Cuentas bancarias */
        permissionsObj[Globals.BANK_COLLECTION] =                       this.newPermission('Ingresos y egresos / Cuentas bancarias');//Ya en crud

    return permissionsObj;
  }

}

export type Column<T> = { name: string, key: keyof T, subKey?: string, thClass?: string, tdClass?: string, pipe?: '' | 'currency' | 'percent', onClick?: (...params: any[]) => any };
export class RowSorter<T>{
  constructor(
    private _originalRows: T[],
    private key: '' | keyof T = '',
    private type: 'asc' | 'desc' = 'asc',
  ){
    this.applySort();
  }

  set originalRows(rows: T[]){
    this._originalRows = rows;
    this.applySort();
  }
  get originalRows(): T[]{
    return this._originalRows;
  }

  set(key: RowSorter<T>['key'], type: RowSorter<T>['type']){
    this.key = key;
    this.type = type;
  }
  toggle(key: RowSorter<T>['key']){
    if(this.key != key){
      this.key = key;
      this.type = 'asc';
    }else if(this.type == 'asc'){
      this.type = 'desc';
    }else this.key = '';
    this.applySort();
  }

  _finalRows: T[] = [];
  set finalRows(rows: T[]){
    this._finalRows = rows;
    this.applySort();
  }
  get finalRows(){
    return this._finalRows;
  }

  rows: T[] = [];
  applySort(){
    this.rows = [...this.originalRows];
    if(this.key) this.rows.sort((row1, row2) => {
      if(!this.key) return 0;
      let val1 = row1[this.key] || '';
      let val2 = row2[this.key] || '';
      if(typeof val1 == 'number' && typeof val2 == 'number'){
        return this.type == 'asc' ? (+val1) - (+val2) : (+val2) - (+val1);
      }else{
        let condition: boolean = this.type == 'asc' ? `${val1}` > `${val2}` : `${val1}` < `${val2}`;
        return condition ? 1 : -1;
      }
    });
    this.rows.push(...this.finalRows);
  }
}

export interface Ref extends firestore.DocumentReference{}
export type SelectOption<T extends string | number = string> = {name: string, value: T};
export type CurrencyKey = keyof CustomerBillData['currencySelect']// 'key0' | 'key1' | 'key2';

export interface Table{
    parent?;
    caption: string;
    columns1: Cell[];
    columns2?: Cell[];
    rows1: (Cell | string | number)[][];
    rows2?: (Cell | string | number)[][];
}

export class Cell{
    name: string;
    colspan: number;
    style: any;

    constructor(name: string, {colspan=1,style={}}: Atts = {} as Atts){
        this.name = name;
        this.colspan = colspan;
        this.style = style;
    }
}
export function Cells(cols: (string | Cell)[]): Cell[] { return cols.map(cell => cell instanceof Cell ? cell : new Cell(cell)) }
export function RightCell(name: string, {colspan=1,style={'text-align': 'right'}}: Atts = {} as Atts){ return new Cell(name, {colspan, style}) }

interface Atts{
    colspan: number;
    style: any;
}

export interface PdfMargin {
    s: number[],
    m: number[],
    l: number[],
    xl: number[],
}
export type PdfOrientation = 'landscape' | 'portrait'
export type PdfPageSize = 'A4' | 'A5' | 'EXECUTIVE' | 'FOLIO' | 'LEGAL' | 'LETTER' | 'TABLOID'

export class PdfSettingsKeys {

    static pageMargins: PdfMargin = {
      s: [10, 10, 10, 10],
      m: [20, 20, 20, 20],
      l: [40, 40, 40, 40],
      xl: [60, 60, 60, 60]
    }
    
    static headers = { 
  
      CustomerBillExpiration: {
        title: "Antigüedad de Saldos de Clientes y Pronósticos de Cobranza \n (Interno)",
        subtile: "Todos Los Clientes"
      },
      SupplierBillExpiration: {
        title: "Antigüedad de Saldos de Proveedores y Pronóstico de Pagos \n (Interno)",
        subtile: "SIRE IOCSA"
      },
      RentabilityReport: {
        title: "Reporte de Rentabilidad",
        subtile: "SIRE IOCSA"
      },
      CustomerBillsReport: {
        title: "Listado de Facturación",
        subtile: "(Agrupado por Cliente)"
      },
  
    }
  
    static generalStyles = {
      currencyFormat: {alignment: 'right'},
      h1: {color: '#00428e' , fontSize: 20, bold: true, alignment: 'right', margin: [0,10,0,0]},
      h2: {color: '#00bce6' , fontSize: 15, bold: true, alignment: 'right', margin: [0,0,0,10]},
      h3: {color: '#000000' , fontSize: 16, bold: true, alignment: 'left', margin: [0,10,0,5]},
      span: {color: '#000000', fontSize: 12, bold: false, alignment: 'center', margin: [0,10,0,10]},
      img: {},
      table: {alignment: 'left', fontSize: 12},
      tableHeader: {alignment: 'center', fontSize: 12, fillColor: '#d3deeb', bold: true},
      column: {alignment: 'justify', columnGap: 20},
      pageBreak: {}
      
    };
    static styles = {
      // margin: [left, top, right, bottom]
      CustomerBillExpiration: {
        ...PdfSettingsKeys.generalStyles,
        h1: {color: '#00428e' , fontSize: 20, bold: true, alignment: 'right', margin: [0,10,0,0]},
        h2: {color: '#00bce6' , fontSize: 15, bold: true, alignment: 'right', margin: [0,0,0,10]},
        h3: {color: '#000000' , fontSize: 16, bold: true, alignment: 'left', margin: [0,10,0,5]},
        span: {color: '#000000', fontSize: 12, bold: false, alignment: 'center', margin: [0,10,0,10]},
        img: {},
        table: {alignment: 'center', fontSize: 10, margin: [0,0,20,0]},
        tableHeader: {alignment: 'center', fontSize: 12, fillColor: '#d3deeb', bold: true},
        column: {alignment: 'justify', columnGap: 20},
      },
      SupplierBillExpiration: {
         // margin: [left, top, right, bottom]
        ...PdfSettingsKeys.generalStyles,
        h1: {color: '#00428e' , fontSize: 20, bold: true, alignment: 'right', margin: [0,10,0,0]},
        h2: {color: '#00bce6' , fontSize: 15, bold: true, alignment: 'right', margin: [0,0,0,10]},
        h3: {color: '#000000' , fontSize: 16, bold: true, alignment: 'left', margin: [0,10,0,5]},
        span: {color: '#000000', fontSize: 12, bold: false, alignment: 'center', margin: [0,10,0,10]},
        img: {},
        table: {alignment: 'center', fontSize: 10, margin: [0,0,20,0]},
        tableHeader: {alignment: 'center', fontSize: 12, fillColor: '#d3deeb', bold: true},
        column: {alignment: 'justify', columnGap: 20},
      },
      DisplaySuaje: {
         // margin: [left, top, right, bottom]
        ...PdfSettingsKeys.generalStyles,
        h1: {color: '#00428e' , fontSize: 20, bold: true, alignment: 'right', margin: [0,0,0,40]},
        h2: {color: '#00bce6' , fontSize: 15, bold: true, alignment: 'right', margin: [0,20,0,20]},
        h3: {color: '#000000' , fontSize: 12, bold: false, alignment: 'center', margin: [0,10,0,5]},
        span: {color: '#000000', fontSize: 12, bold: false, alignment: 'center', margin: [0,10,0,10]},
        img: {margin: [0,0,0,20]},
        table: {alignment: 'left', fontSize: 12, margin: [0,10,0,10], fillColor: '#e3e3e3', fillOpacity: '20%' },
        tableHeader: {alignment: 'center', fontSize: 12, fillColor: '#e3e3e3', bold: true},
        column: {alignment: 'justify', columnGap: 20},
        rightContent: {alignment: 'right'},
        leftContent: {alignment:'left'},
        checkBoxes: {alignment: 'right', fillColor: '#ffffff'},
        checkBoxesRight: {alignment: 'left', fillColor: '#ffffff'},
        checkBoxesCenter: {alignment: 'center', fillColor: '#ffffff'}

      },
      RentabilityReport: {
        // margin: [left, top, right, bottom]
        ...PdfSettingsKeys.generalStyles,
        h1: {color: '#00428e' , fontSize: 20, bold: true, alignment: 'right', margin: [0,10,0,10]},
        h2: {color: '#00bce6' , fontSize: 15, bold: true, alignment: 'right', margin: [0,0,0,10]},
        h3: {color: '#000000' , fontSize: 12, bold: true, alignment: 'right', margin: [0,10,0,5]},
        span: {color: '#000000', fontSize: 8, bold: false, alignment: 'center', margin: [0,10,0,10]},
        img: {},
        table: {alignment: 'center', fontSize: 9, margin: [0,0,20,0]},
        tableHeader: {alignment: 'center', fontSize: 11, fillColor: '#d3deeb', bold: true},
        column: {alignment: 'justify', columnGap: 20},
     },
     CustomerBillsReport: {
        // margin: [left, top, right, bottom]
        ...PdfSettingsKeys.generalStyles,
        h1: {color: '#00428e' , fontSize: 20, bold: true, alignment: 'right', margin: [0,10,0,0]},
        h2: {color: '#00bce6' , fontSize: 15, bold: true, alignment: 'right', margin: [0,0,0,10]},
        h3: {color: '#000000' , fontSize: 16, bold: true, alignment: 'left', margin: [0,10,0,5]},
        span: {color: '#000000', fontSize: 8, bold: false, alignment: 'center', margin: [0,10,0,10]},
        img: {},
        table: {alignment: 'center', fontSize: 10, margin: [0,0,20,0]},
        tableHeader: {alignment: 'center', fontSize: 12, fillColor: '#d3deeb', bold: true},
        column: {alignment: 'justify', columnGap: 20},
   },

    }
  
    static imagePosition = {
  
      topLeft: { 
        x: 60, 
        y: 60
      },
      topRight: {
        x: 960, 
        y: 960
      },
       bottomLeft: {
         x: 60, 
         y: 960
       },
       bottomRight: {
        x: 960,
        y: 60
      }
    }
  
  }